webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularUiBootstrap = __webpack_require__(4);
	
	var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);
	
	var _angularTranslate = __webpack_require__(6);
	
	var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	
	var _angularTranslateLoaderStaticFiles = __webpack_require__(7);
	
	var _angularTranslateLoaderStaticFiles2 = _interopRequireDefault(_angularTranslateLoaderStaticFiles);
	
	var _commonCommon = __webpack_require__(8);
	
	var _commonCommon2 = _interopRequireDefault(_commonCommon);
	
	var _routesRoutes = __webpack_require__(96);
	
	var _routesRoutes2 = _interopRequireDefault(_routesRoutes);
	
	var _appComponent = __webpack_require__(169);
	
	var _appComponent2 = _interopRequireDefault(_appComponent);
	
	var _angularResource = __webpack_require__(74);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _angularMessages = __webpack_require__(184);
	
	var _angularMessages2 = _interopRequireDefault(_angularMessages);
	
	var _chapsOffClickLoader = __webpack_require__(186);
	
	var _chapsOffClickLoader2 = _interopRequireDefault(_chapsOffClickLoader);
	
	var _servicesSharedService = __webpack_require__(67);
	
	var _servicesSharedService2 = _interopRequireDefault(_servicesSharedService);
	
	var _appConfigLocations = __webpack_require__(188);
	
	var _appConfigLocations2 = _interopRequireDefault(_appConfigLocations);
	
	var _appConfigAuth = __webpack_require__(189);
	
	var _appConfigAuth2 = _interopRequireDefault(_appConfigAuth);
	
	var _appConfigTranslations = __webpack_require__(190);
	
	var _appConfigTranslations2 = _interopRequireDefault(_appConfigTranslations);
	
	var _appLoadingInterceptor = __webpack_require__(191);
	
	var _appLoadingInterceptor2 = _interopRequireDefault(_appLoadingInterceptor);
	
	var _appConfigLoadingInterceptor = __webpack_require__(192);
	
	var _appConfigLoadingInterceptor2 = _interopRequireDefault(_appConfigLoadingInterceptor);
	
	var _appRunQueryStringInterceptor = __webpack_require__(193);
	
	var _appRunQueryStringInterceptor2 = _interopRequireDefault(_appRunQueryStringInterceptor);
	
	var _configConfig = __webpack_require__(16);
	
	var _configConfig2 = _interopRequireDefault(_configConfig);
	
	var _angularMoment = __webpack_require__(194);
	
	var _angularMoment2 = _interopRequireDefault(_angularMoment);
	
	var _servicesCacheService = __webpack_require__(15);
	
	var _servicesCacheService2 = _interopRequireDefault(_servicesCacheService);
	
	var _servicesDropdownService = __webpack_require__(306);
	
	var _servicesDropdownService2 = _interopRequireDefault(_servicesDropdownService);
	
	var _servicesCookiesConsentService = __webpack_require__(307);
	
	var _servicesCookiesConsentService2 = _interopRequireDefault(_servicesCookiesConsentService);
	
	var _servicesCookiesService = __webpack_require__(309);
	
	var _servicesCookiesService2 = _interopRequireDefault(_servicesCookiesService);
	
	_angular2['default'].module('app', [_configConfig2['default'], _angularUiRouter2['default'], _angularUiBootstrap2['default'], _angularTranslate2['default'], _angularTranslateLoaderStaticFiles2['default'], _commonCommon2['default'], _routesRoutes2['default'], _angularResource2['default'], _chapsOffClickLoader2['default'], _angularMessages2['default'], _servicesSharedService2['default'], _angularMoment2['default'], _servicesCacheService2['default'], _servicesDropdownService2['default'], _servicesCookiesConsentService2['default'], _servicesCookiesService2['default']]).config(_appConfigLocations2['default']).config(_appConfigAuth2['default']).config(_appConfigTranslations2['default']).run(_appRunQueryStringInterceptor2['default']).value('DATE_FORMAT', 'MM/DD/YYYY HH:mm [[]dddd D, MMMM  h:mmA[]]').component('app', _appComponent2['default']).config(_appConfigLoadingInterceptor2['default']).factory('loadingInterceptor', _appLoadingInterceptor2['default']);

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	        value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _navbarNavbar = __webpack_require__(9);
	
	var _navbarNavbar2 = _interopRequireDefault(_navbarNavbar);
	
	var _footerFooter = __webpack_require__(19);
	
	var _footerFooter2 = _interopRequireDefault(_footerFooter);
	
	var _userUser = __webpack_require__(29);
	
	var _userUser2 = _interopRequireDefault(_userUser);
	
	var _languageSelectorLanguageSelector = __webpack_require__(31);
	
	var _languageSelectorLanguageSelector2 = _interopRequireDefault(_languageSelectorLanguageSelector);
	
	var _stSelectStSelect = __webpack_require__(35);
	
	var _stSelectStSelect2 = _interopRequireDefault(_stSelectStSelect);
	
	var _stSelectFilterStSelectFilter = __webpack_require__(39);
	
	var _stSelectFilterStSelectFilter2 = _interopRequireDefault(_stSelectFilterStSelectFilter);
	
	var _stBrowserAlertsStBrowserAlerts = __webpack_require__(43);
	
	var _stBrowserAlertsStBrowserAlerts2 = _interopRequireDefault(_stBrowserAlertsStBrowserAlerts);
	
	var _authAuth = __webpack_require__(47);
	
	var _authAuth2 = _interopRequireDefault(_authAuth);
	
	var _loaderLoader = __webpack_require__(59);
	
	var _loaderLoader2 = _interopRequireDefault(_loaderLoader);
	
	var _stGlobalPreloaderStGlobalPreloader = __webpack_require__(63);
	
	var _stGlobalPreloaderStGlobalPreloader2 = _interopRequireDefault(_stGlobalPreloaderStGlobalPreloader);
	
	var _stLocationStLocation = __webpack_require__(68);
	
	var _stLocationStLocation2 = _interopRequireDefault(_stLocationStLocation);
	
	var _stExtrasStExtras = __webpack_require__(77);
	
	var _stExtrasStExtras2 = _interopRequireDefault(_stExtrasStExtras);
	
	var _stPassengersStPassengers = __webpack_require__(82);
	
	var _stPassengersStPassengers2 = _interopRequireDefault(_stPassengersStPassengers);
	
	var _stPrefixesStPrefixes = __webpack_require__(87);
	
	var _stPrefixesStPrefixes2 = _interopRequireDefault(_stPrefixesStPrefixes);
	
	var _stDateTimePickerStDateTimePicker = __webpack_require__(92);
	
	var _stDateTimePickerStDateTimePicker2 = _interopRequireDefault(_stDateTimePickerStDateTimePicker);
	
	var commonModule = _angular2['default'].module('app.common', [_navbarNavbar2['default'], _userUser2['default'], _footerFooter2['default'], _languageSelectorLanguageSelector2['default'], _stSelectStSelect2['default'], _stBrowserAlertsStBrowserAlerts2['default'], _stSelectFilterStSelectFilter2['default'], _authAuth2['default'], _loaderLoader2['default'], _stGlobalPreloaderStGlobalPreloader2['default'], _stLocationStLocation2['default'], _stExtrasStExtras2['default'], _stPassengersStPassengers2['default'], _stPrefixesStPrefixes2['default'], _stDateTimePickerStDateTimePicker2['default']]).name;
	
	exports['default'] = commonModule;
	module.exports = exports['default'];

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _navbarComponent = __webpack_require__(10);
	
	var _navbarComponent2 = _interopRequireDefault(_navbarComponent);
	
	var _servicesHelpCentreService = __webpack_require__(13);
	
	var _servicesHelpCentreService2 = _interopRequireDefault(_servicesHelpCentreService);
	
	var navbarModule = _angular2['default'].module('navbar', [_angularUiRouter2['default'], _servicesHelpCentreService2['default']]).component('navbar', _navbarComponent2['default']).name;
	
	exports['default'] = navbarModule;
	module.exports = exports['default'];

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _navbarHtml = __webpack_require__(11);
	
	var _navbarHtml2 = _interopRequireDefault(_navbarHtml);
	
	var _navbarController = __webpack_require__(12);
	
	var _navbarController2 = _interopRequireDefault(_navbarController);
	
	var navbarComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _navbarHtml2['default'],
	  controller: _navbarController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = navbarComponent;
	module.exports = exports['default'];

/***/ },
/* 11 */
/***/ function(module, exports) {

	module.exports = "<header class=\"o-header\">\n    <div class=\"o-header__container\">\n        <div class=\"o-header__item\">\n            <a class=\"a-logo\" href=\"//www.suntransfers.com/\" title=\"Suntransfers.com\"></a>\n        </div>\n\n        <div class=\"o-header__item\" ng-class=\"{'has-one-child': !vm.authService.authenticated}\">\n            <nav class=\"o-nav\">\n                <div class=\"o-nav__main\">\n                    <div class=\"o-nav__dropdown--help-centre\">\n                        <a id=\"help-menu\" class=\"o-nav__link js-dropdown-button\" data-dropdown-id=\"js-help-centre-dropdown\" data-is-active-class=\"is-active\">\n                            <i class=\"o-nav__icon\">\n                                <svg class=\"i-help-centre-alt\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\">\n                                    <g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#09AFEE\" fill-rule=\"nonzero\" d=\"M6,12 C2.6862915,12 0,9.3137085 0,6 C0,2.6862915 2.6862915,0 6,0 C9.3137085,0 12,2.6862915 12,6 C12,9.3137085 9.3137085,12 6,12 Z\"></path><path fill=\"#FFF\" d=\"M5.99840284,3 C5.19652695,3 4.44488592,3.31158213 3.87732613,3.87909577 C2.78363997,4.97269299 2.70327644,6.72708991 3.68812943,7.91262942 L3.77132601,8.01277921 L3.71340173,8.12938045 C3.56609345,8.42591115 3.2368141,8.60191552 2.97717285,8.72957357 C2.93721225,8.7493226 3.05530069,8.89173461 3.05530069,8.89173461 C3.05530069,8.89173461 3.09556475,8.96991728 3.13877513,8.9766684 C3.20536255,8.9870256 3.27958214,8.9932347 3.3610762,8.9932347 C3.69614148,8.9932347 4.04021815,8.89515065 4.36998355,8.65752951 L4.47152892,8.58435832 L4.58173337,8.64369435 C5.01921148,8.87924033 5.50487966,9 5.99704967,9 C6.78942212,9 7.55321088,8.68847992 8.12083273,8.12090423 C8.68839253,7.55339058 9,6.80181069 9,6 C9,5.19901887 8.68762922,4.44719923 8.11947956,3.87909577 C7.55191976,3.31158213 6.80027874,3 5.99840284,3 Z\"></path>\n                                        <path fill=\"#1F708F\" d=\"M6.03640199,7.47945755 C5.89476275,7.47945755 5.77310011,7.48209348 5.6714104,7.48736541 C5.5697207,7.49263734 5.47166424,7.49878784 5.37723808,7.50581708 C5.36997453,7.47067087 5.36634281,7.43728247 5.36634281,7.40565088 C5.36634281,7.38104853 5.37269832,7.36435433 5.38540954,7.35556778 C5.39812075,7.34678123 5.4117397,7.34063073 5.4262668,7.33711611 C5.54248361,7.31602838 5.62238147,7.29318369 5.66596277,7.26858134 C5.70954407,7.24397899 5.73133439,7.20531874 5.73133439,7.15259942 L5.73133439,5.7608164 C5.73133439,5.65537776 5.71317579,5.57454269 5.67685804,5.51830875 C5.64054029,5.46207481 5.55519485,5.42868641 5.42081917,5.41814255 C5.37360609,5.41111331 5.3499999,5.38299676 5.3499999,5.33379206 L5.3499999,5.29425277 C5.3499999,5.27843698 5.35363163,5.26350006 5.36089518,5.24944158 C5.38268583,5.24944158 5.41446338,5.24856293 5.4562288,5.24680562 C5.49799421,5.24504831 5.54248279,5.24329103 5.58969587,5.24153372 C5.63690895,5.23977641 5.68412132,5.23714048 5.73133439,5.23362586 C5.77854747,5.23011124 5.82212812,5.22659667 5.86207765,5.22308205 C5.95287203,5.21253819 6.04003333,5.19847991 6.12356415,5.18090681 C6.20709498,5.1633337 6.26338666,5.15454728 6.29244086,5.15454728 C6.35054926,5.15454728 6.37960303,5.18090654 6.37960303,5.23362586 C6.37960303,5.27228669 6.37415545,5.32324794 6.36326012,5.38651112 C6.35236479,5.4497743 6.34691721,5.53763851 6.34691721,5.65010639 L6.34691721,7.15259942 C6.34691721,7.20531874 6.3705234,7.24397899 6.41773648,7.26858134 C6.46494955,7.29318369 6.54303155,7.31602838 6.6519848,7.33711611 C6.69193433,7.34414535 6.7119088,7.36699005 6.7119088,7.40565088 L6.7119088,7.45836993 C6.7119088,7.47594304 6.70827708,7.4917586 6.70101352,7.50581708 C6.61021914,7.49878784 6.51216269,7.49263734 6.4068412,7.48736541 C6.30151972,7.48209348 6.17804122,7.47945755 6.03640199,7.47945755 Z M5.63872459,4.38484909 C5.63872459,4.27238122 5.67594973,4.18012379 5.75040112,4.10807406 C5.82485251,4.03602433 5.91836932,4 6.03095435,4 C6.14717116,4 6.2415959,4.03602433 6.3142314,4.10807406 C6.3868669,4.18012379 6.42318411,4.27238122 6.42318411,4.38484909 C6.42318411,4.49731697 6.3868669,4.58957439 6.3142314,4.66162413 C6.2415959,4.73367386 6.14717116,4.76969819 6.03095435,4.76969819 C5.91836932,4.76969819 5.82485251,4.73367386 5.75040112,4.66162413 C5.67594973,4.58957439 5.63872459,4.49731697 5.63872459,4.38484909 Z\"></path>\n                                        <path fill=\"#1F708F\" fill-rule=\"nonzero\" d=\"M6,12 C2.6862915,12 0,9.3137085 0,6 C0,2.6862915 2.6862915,0 6,0 C9.3137085,0 12,2.6862915 12,6 C12,9.3137085 9.3137085,12 6,12 Z M6,11.6170213 C9.10219519,11.6170213 11.6170213,9.10219519 11.6170213,6 C11.6170213,2.89780481 9.10219519,0.382978723 6,0.382978723 C2.89780481,0.382978723 0.382978723,2.89780481 0.382978723,6 C0.382978723,9.10219519 2.89780481,11.6170213 6,11.6170213 Z M3.69660579,3.6983853 C4.31180422,3.08318686 5.1288567,2.7444618 5.99822049,2.7444618 C6.86758427,2.7444618 7.68463675,3.08318686 8.29983518,3.6983853 C8.91552524,4.31407536 9.25505427,5.13132642 9.25505427,6 C9.25505427,6.86936379 8.9163292,7.68641626 8.30113077,8.3016147 C7.68530995,8.91743551 6.85641304,9.2555382 5.9969249,9.2555382 C5.50158297,9.2555382 5.01204807,9.14276302 4.56470359,8.92240699 C4.20897048,9.15167998 3.83660506,9.2490603 3.4731333,9.2490603 C3.37452828,9.2490603 3.28392828,9.24148022 3.20129814,9.2286266 C2.99469842,9.19634539 2.83427513,9.03468332 2.80198341,8.82801629 C2.76964248,8.62103431 2.87530662,8.41902933 3.06344701,8.32604085 C3.19644167,8.26064569 3.3131654,8.13721968 3.41022283,7.9739551 C2.42765446,6.68980572 2.54053981,4.85445128 3.69660579,3.6983853 Z M5.99822049,3.12744052 C5.23047086,3.12744052 4.5108182,3.42578659 3.96741264,3.96919215 C2.92027162,5.01633317 2.84332821,6.69620301 3.78626779,7.83138059 L3.86592368,7.927276 L3.81046454,8.038924 C3.66942542,8.32285802 3.48138039,8.54731098 3.23278896,8.66954609 C3.194529,8.68845619 3.17394995,8.7277985 3.180371,8.76889322 C3.18704967,8.81163674 3.2189215,8.84375468 3.26029293,8.85021901 C3.32404652,8.86013624 3.39510746,8.86608157 3.4731333,8.86608157 C3.79393886,8.86608157 4.1233723,8.77216414 4.43910352,8.5446372 L4.53632733,8.47457433 L4.64184169,8.53138976 C5.06070159,8.7569297 5.52570068,8.87255948 5.9969249,8.87255948 C6.75557553,8.87255948 7.48685893,8.57427283 8.03032391,8.03080785 C8.57372948,7.48740228 8.87207555,6.76774963 8.87207555,6 C8.87207555,5.23304468 8.57299865,4.51316247 8.02902833,3.96919215 C7.48562277,3.42578659 6.76597012,3.12744052 5.99822049,3.12744052 Z\"></path>\n                                    </g>\n                                </svg>\n                            </i>\n                            <span class=\"o-nav__text\">{{ 'help_centre' | translate }}</span>\n                        </a>\n                        <div id=\"js-help-centre-dropdown\" class=\"m-dropdown\">\n                            <div class=\"m-dropdown__container m-dropdown__container--alt\">\n                                <div class=\"o-detailed-menu\">\n                                    <div class=\"o-detailed-menu__item o-detailed-menu__item--header\">\n                                        <a target=\"_blank\" href=\"{{vm.helpCentreService.getBaseUrl()}}\" class=\"a-menu-link a-menu-link--alt\">\n                                            <span class=\"a-menu-link__icon\">\n                                                <svg class=\"i-help-centre-alt\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\">\n                                                    <g fill=\"none\" fill-rule=\"evenodd\">\n                                                        <path fill=\"#09AFEE\" fill-rule=\"nonzero\" d=\"M6,12 C2.6862915,12 0,9.3137085 0,6 C0,2.6862915 2.6862915,0 6,0 C9.3137085,0 12,2.6862915 12,6 C12,9.3137085 9.3137085,12 6,12 Z\"></path><path fill=\"#FFF\" d=\"M5.99840284,3 C5.19652695,3 4.44488592,3.31158213 3.87732613,3.87909577 C2.78363997,4.97269299 2.70327644,6.72708991 3.68812943,7.91262942 L3.77132601,8.01277921 L3.71340173,8.12938045 C3.56609345,8.42591115 3.2368141,8.60191552 2.97717285,8.72957357 C2.93721225,8.7493226 3.05530069,8.89173461 3.05530069,8.89173461 C3.05530069,8.89173461 3.09556475,8.96991728 3.13877513,8.9766684 C3.20536255,8.9870256 3.27958214,8.9932347 3.3610762,8.9932347 C3.69614148,8.9932347 4.04021815,8.89515065 4.36998355,8.65752951 L4.47152892,8.58435832 L4.58173337,8.64369435 C5.01921148,8.87924033 5.50487966,9 5.99704967,9 C6.78942212,9 7.55321088,8.68847992 8.12083273,8.12090423 C8.68839253,7.55339058 9,6.80181069 9,6 C9,5.19901887 8.68762922,4.44719923 8.11947956,3.87909577 C7.55191976,3.31158213 6.80027874,3 5.99840284,3 Z\"></path><path fill=\"#1F708F\" d=\"M6.03640199,7.47945755 C5.89476275,7.47945755 5.77310011,7.48209348 5.6714104,7.48736541 C5.5697207,7.49263734 5.47166424,7.49878784 5.37723808,7.50581708 C5.36997453,7.47067087 5.36634281,7.43728247 5.36634281,7.40565088 C5.36634281,7.38104853 5.37269832,7.36435433 5.38540954,7.35556778 C5.39812075,7.34678123 5.4117397,7.34063073 5.4262668,7.33711611 C5.54248361,7.31602838 5.62238147,7.29318369 5.66596277,7.26858134 C5.70954407,7.24397899 5.73133439,7.20531874 5.73133439,7.15259942 L5.73133439,5.7608164 C5.73133439,5.65537776 5.71317579,5.57454269 5.67685804,5.51830875 C5.64054029,5.46207481 5.55519485,5.42868641 5.42081917,5.41814255 C5.37360609,5.41111331 5.3499999,5.38299676 5.3499999,5.33379206 L5.3499999,5.29425277 C5.3499999,5.27843698 5.35363163,5.26350006 5.36089518,5.24944158 C5.38268583,5.24944158 5.41446338,5.24856293 5.4562288,5.24680562 C5.49799421,5.24504831 5.54248279,5.24329103 5.58969587,5.24153372 C5.63690895,5.23977641 5.68412132,5.23714048 5.73133439,5.23362586 C5.77854747,5.23011124 5.82212812,5.22659667 5.86207765,5.22308205 C5.95287203,5.21253819 6.04003333,5.19847991 6.12356415,5.18090681 C6.20709498,5.1633337 6.26338666,5.15454728 6.29244086,5.15454728 C6.35054926,5.15454728 6.37960303,5.18090654 6.37960303,5.23362586 C6.37960303,5.27228669 6.37415545,5.32324794 6.36326012,5.38651112 C6.35236479,5.4497743 6.34691721,5.53763851 6.34691721,5.65010639 L6.34691721,7.15259942 C6.34691721,7.20531874 6.3705234,7.24397899 6.41773648,7.26858134 C6.46494955,7.29318369 6.54303155,7.31602838 6.6519848,7.33711611 C6.69193433,7.34414535 6.7119088,7.36699005 6.7119088,7.40565088 L6.7119088,7.45836993 C6.7119088,7.47594304 6.70827708,7.4917586 6.70101352,7.50581708 C6.61021914,7.49878784 6.51216269,7.49263734 6.4068412,7.48736541 C6.30151972,7.48209348 6.17804122,7.47945755 6.03640199,7.47945755 Z M5.63872459,4.38484909 C5.63872459,4.27238122 5.67594973,4.18012379 5.75040112,4.10807406 C5.82485251,4.03602433 5.91836932,4 6.03095435,4 C6.14717116,4 6.2415959,4.03602433 6.3142314,4.10807406 C6.3868669,4.18012379 6.42318411,4.27238122 6.42318411,4.38484909 C6.42318411,4.49731697 6.3868669,4.58957439 6.3142314,4.66162413 C6.2415959,4.73367386 6.14717116,4.76969819 6.03095435,4.76969819 C5.91836932,4.76969819 5.82485251,4.73367386 5.75040112,4.66162413 C5.67594973,4.58957439 5.63872459,4.49731697 5.63872459,4.38484909 Z\">\n                                                    </path>\n                                                        <path fill=\"#1F708F\" fill-rule=\"nonzero\" d=\"M6,12 C2.6862915,12 0,9.3137085 0,6 C0,2.6862915 2.6862915,0 6,0 C9.3137085,0 12,2.6862915 12,6 C12,9.3137085 9.3137085,12 6,12 Z M6,11.6170213 C9.10219519,11.6170213 11.6170213,9.10219519 11.6170213,6 C11.6170213,2.89780481 9.10219519,0.382978723 6,0.382978723 C2.89780481,0.382978723 0.382978723,2.89780481 0.382978723,6 C0.382978723,9.10219519 2.89780481,11.6170213 6,11.6170213 Z M3.69660579,3.6983853 C4.31180422,3.08318686 5.1288567,2.7444618 5.99822049,2.7444618 C6.86758427,2.7444618 7.68463675,3.08318686 8.29983518,3.6983853 C8.91552524,4.31407536 9.25505427,5.13132642 9.25505427,6 C9.25505427,6.86936379 8.9163292,7.68641626 8.30113077,8.3016147 C7.68530995,8.91743551 6.85641304,9.2555382 5.9969249,9.2555382 C5.50158297,9.2555382 5.01204807,9.14276302 4.56470359,8.92240699 C4.20897048,9.15167998 3.83660506,9.2490603 3.4731333,9.2490603 C3.37452828,9.2490603 3.28392828,9.24148022 3.20129814,9.2286266 C2.99469842,9.19634539 2.83427513,9.03468332 2.80198341,8.82801629 C2.76964248,8.62103431 2.87530662,8.41902933 3.06344701,8.32604085 C3.19644167,8.26064569 3.3131654,8.13721968 3.41022283,7.9739551 C2.42765446,6.68980572 2.54053981,4.85445128 3.69660579,3.6983853 Z M5.99822049,3.12744052 C5.23047086,3.12744052 4.5108182,3.42578659 3.96741264,3.96919215 C2.92027162,5.01633317 2.84332821,6.69620301 3.78626779,7.83138059 L3.86592368,7.927276 L3.81046454,8.038924 C3.66942542,8.32285802 3.48138039,8.54731098 3.23278896,8.66954609 C3.194529,8.68845619 3.17394995,8.7277985 3.180371,8.76889322 C3.18704967,8.81163674 3.2189215,8.84375468 3.26029293,8.85021901 C3.32404652,8.86013624 3.39510746,8.86608157 3.4731333,8.86608157 C3.79393886,8.86608157 4.1233723,8.77216414 4.43910352,8.5446372 L4.53632733,8.47457433 L4.64184169,8.53138976 C5.06070159,8.7569297 5.52570068,8.87255948 5.9969249,8.87255948 C6.75557553,8.87255948 7.48685893,8.57427283 8.03032391,8.03080785 C8.57372948,7.48740228 8.87207555,6.76774963 8.87207555,6 C8.87207555,5.23304468 8.57299865,4.51316247 8.02902833,3.96919215 C7.48562277,3.42578659 6.76597012,3.12744052 5.99822049,3.12744052 Z\"></path>\n                                                    </g>\n                                                </svg>\n                                            </span>\n                                            <span class=\"a-menu-link__text\">{{ 'visit_help_centre' | translate }}</span>\n                                        </a>\n                                    </div>\n                                    <div class=\"o-detailed-menu__item\">\n                                        <span class=\"o-detailed-menu__title\">{{ 'most_relevant_articles' | translate }}</span>\n                                        <div class=\"o-detailed-menu__content\">\n                                            <a href=\"{{ 'url_what_if_flight_delayed' | translate }}\" class=\"a-menu-link\" target=\"_blank\">\n                                                <span class=\"a-menu-link__icon\">\n                                                    <svg class=\"i-delayed\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 12\">\n                                                        <path fill=\"#09AFEE\" d=\"M10.3425406,2.58761283 C10.7799533,1.99067641 11.0417636,1.37091062 11.0430347,0.928134548 C11.042495,0.784749802 11.0142871,0.672697738 10.9606226,0.589226761 C10.9549811,0.57901923 10.939519,0.552302127 10.912234,0.525975573 C10.8851058,0.498530628 10.8607287,0.483867288 10.8554527,0.480902665 C10.7695756,0.422462331 10.6591472,0.394271792 10.5184738,0.394271792 C10.0852574,0.395017386 9.47718745,0.661762365 8.89150958,1.10844393 C8.41810579,1.46961301 7.94466718,1.97824985 7.28928815,2.68258725 C7.17811104,2.80204199 7.06111825,2.92763901 6.93738692,3.05934279 L2.25389675,1.62858421 C2.22497503,1.61986787 2.19439915,1.61523454 2.16164674,1.61523454 C2.06995392,1.61635293 1.98498222,1.65104078 1.92294244,1.71374165 L1.46916223,2.17655999 C1.41765685,2.22905333 1.38873513,2.30009775 1.38929232,2.36743195 C1.38765557,2.4666669 1.44151161,2.5583039 1.5277544,2.60541832 L4.24204291,4.1513711 C4.25532845,4.15896905 4.29372242,4.18792294 4.30791339,4.202391 L5.08173043,4.99114025 C4.35793874,5.76856358 3.71311151,6.52152433 3.21059447,7.17651054 C3.16365109,7.23736518 3.1192499,7.29671088 3.07558002,7.35552401 L0.975734377,7.16111936 C0.965548221,7.15982345 0.954073559,7.15888258 0.939516933,7.15888258 C0.843262109,7.16092408 0.749201227,7.1997127 0.679343349,7.26852034 L0.467732482,7.48406789 C0.415513195,7.53620619 0.386034285,7.60668253 0.386765599,7.67476233 C0.385128849,7.77864837 0.446802978,7.87472342 0.539418645,7.91683171 L2.01663766,8.63212224 C2.029366,8.63861955 2.06248407,8.66254956 2.07322742,8.67348493 L2.19586177,8.79759075 C2.1574678,8.90777883 2.13800092,9.00330357 2.13690395,9.0871651 C2.1365383,9.19937693 2.17202443,9.29546974 2.23989731,9.36466793 C2.31630219,9.43924504 2.40654979,9.47430569 2.51826668,9.47430569 C2.59869378,9.47300978 2.69148357,9.45353558 2.79992696,9.41458719 L2.92437219,9.54128485 C2.93401856,9.5516699 2.9571246,9.58468904 2.96313182,9.5978612 L3.66326029,11.1006051 C3.70602473,11.1965026 3.79825733,11.2586354 3.89869109,11.2586354 C3.96964594,11.2586354 4.0360562,11.2302496 4.08681286,11.1783243 L4.3035081,10.9566522 C4.36772441,10.8876493 4.4055786,10.7924974 4.40702382,10.692144 C4.40702382,10.6799128 4.21489724,8.51659074 4.21489724,8.51659074 C4.27239243,8.47244094 4.33061894,8.42699524 4.39046479,8.37950803 C5.03382938,7.86641538 5.77254336,7.20842905 6.53361465,6.47162282 L7.30798888,7.26186325 C7.3205431,7.27409454 7.34983048,7.31325595 7.3583973,7.32957025 L8.87183376,10.0918524 C8.91804583,10.1810751 9.00702234,10.2361781 9.10564522,10.2361781 C9.17606029,10.2361781 9.24301033,10.2077923 9.29432418,10.1551214 L9.75136047,9.6894982 C9.81068395,9.62626476 9.84397613,9.54036173 9.84488157,9.4465057 C9.84488157,9.41497774 9.84052851,9.3843729 9.83251889,9.35561429 L8.42857055,4.57953709 C8.55994584,4.45191632 8.68456519,4.33040232 8.80375193,4.21595371 C9.49214456,3.54997887 9.98921157,3.06915977 10.3425406,2.58761283 Z\"></path>\n                                                        <path fill=\"#1F708F\" d=\"M1.8536115,9.21916194 L1.85998028,9.22560726 C1.85807056,9.22369706 1.85597561,9.2215683 1.8536115,9.21916194 Z M2.69027813,10.0549243 L2.6970494,10.0694584 C2.69508156,10.0654231 2.69292012,10.0607175 2.69027813,10.0549243 Z M1.90585562,9.2559913 C1.87809163,9.24190535 1.87409647,9.23972702 1.85998028,9.22560726 L1.87545566,9.24126862 L1.90585562,9.2559913 Z M2.73007715,10.1127783 C2.70974833,10.0910769 2.7049653,10.0856909 2.6970494,10.0694584 L2.70564118,10.0879 L2.73007715,10.1127783 Z M1.38516976,3.04089947 C1.16529993,2.92078464 1.02828783,2.68595293 1.03244882,2.4413734 C1.0309531,2.26062265 1.10450412,2.08354822 1.23127118,1.95434961 L1.69985472,1.47643906 C1.8382592,1.33655977 2.02490322,1.25975443 2.2260338,1.25733027 C2.29728689,1.25733027 2.3668285,1.2675119 2.43533848,1.28816214 L7.0245336,2.69011454 C7.0802062,2.6304908 7.14185049,2.56432664 7.2174901,2.48305532 C8.1525506,1.47814359 8.4767415,1.15284062 8.91780286,0.816346217 C9.58317517,0.308883738 10.2848278,0.000940756378 10.8317768,0 C11.0502627,0 11.2399234,0.0486740272 11.3710213,0.139643102 C11.4167538,0.165340956 11.467913,0.20299646 11.5110041,0.246750804 C11.5666212,0.300414247 11.6039636,0.353031304 11.6201625,0.384200563 C11.7223141,0.543089399 11.7693733,0.734933917 11.7702,0.956968227 C11.7685998,1.51439502 11.4667991,2.22921805 10.9696429,2.90768642 C10.6361705,3.360735 10.320419,3.68765861 9.33902395,4.63709022 C9.28384396,4.6900766 9.22519604,4.74677047 9.15209812,4.81771796 C9.1455938,4.82403093 10.5084848,9.52337603 10.5084848,9.52337603 C10.5268887,9.58945509 10.5363605,9.65829969 10.5363412,9.73187192 C10.5344319,9.92978123 10.4620052,10.1176229 10.3233101,10.2653093 L9.85371326,10.7437251 C9.72666812,10.8741299 9.55625762,10.9470878 9.37686582,10.9470878 C9.12739056,10.9470878 8.90035771,10.8068198 8.78841524,10.5904482 L7.22648329,7.73952035 C7.2380771,7.75973271 6.71962416,7.23007313 6.71962416,7.23007313 C6.02607748,7.8890004 5.35820603,8.47708608 4.76583593,8.94950851 C4.75988045,8.99074889 4.76352841,9.03185343 4.76797623,9.08197077 C4.79889239,9.43047671 4.81435094,9.60483334 4.83599295,9.84920862 C4.94549137,11.0856529 4.93653099,10.9839011 4.93648807,11.0165803 C4.93355273,11.2204055 4.8565095,11.4164117 4.7137643,11.5696188 L4.49062239,11.7978856 C4.36392073,11.9275044 4.19416001,12 4.01481766,12 C3.75367103,12 3.5178886,11.8415734 3.41265324,11.60545 L2.7349766,10.1508664 C2.68740033,10.1578659 2.6403293,10.1617816 2.593276,10.1625224 C2.37709551,10.1625224 2.18521929,10.0872025 2.02501734,9.93069973 C1.87700797,9.7798003 1.8016003,9.57636238 1.80235001,9.35242066 C1.80295533,9.30614466 1.80672219,9.25917703 1.81355069,9.21128808 L0.393289087,8.52345641 C0.152523245,8.41399074 -0.00415515751,8.16679889 7.06026886e-05,7.90780867 C-0.00189945239,7.72441141 0.0734146736,7.54631636 0.200194438,7.4197616 L0.422877064,7.19301717 C0.566910947,7.0511487 0.759570108,6.97042334 0.967501711,6.96610109 C0.998058913,6.96610109 1.02616214,6.96797356 1.0408128,6.97006821 L2.9848964,7.15005234 C3.45538981,6.5368465 4.03201781,5.8559462 4.6783901,5.14852529 L4.15463122,4.61465953 C4.16477295,4.62441933 1.38516976,3.04089947 1.38516976,3.04089947 Z M9.48824677,10.2028589 C9.48738435,10.2011938 9.48648447,10.1995518 9.48554846,10.1979336 L9.48824677,10.2028589 Z M4.13490437,11.2632057 C4.13435678,11.2619777 4.13378956,11.2607603 4.13320307,11.2595537 L4.13490437,11.2632057 Z M0.760306106,7.99706708 L0.761889399,7.99545453 C0.761366457,7.99599777 0.760838668,7.99653534 0.760306106,7.99706708 Z M0.955485544,7.77731088 L0.960705358,7.77779468 C0.958628578,7.77766892 0.957001071,7.77750369 0.955485544,7.77731088 Z M1.76748479,2.32856873 L1.77051325,2.33029362 C1.76951129,2.32969734 1.76850166,2.32912221 1.76748479,2.32856873 Z M0.977210723,7.77615544 L0.97535301,7.77804747 C0.97563803,7.77804747 0.975305824,7.77816925 0.977210723,7.77615544 Z M0.889886598,7.86509276 L2.25499841,8.52618616 C2.30611731,8.55228034 2.37500422,8.6024188 2.41553331,8.6436747 L2.72108354,8.95289118 L2.63653189,9.19554861 C2.61284529,9.26352755 2.6013263,9.31590082 2.59915829,9.34997717 C2.6349065,9.34733036 2.68543607,9.3356109 2.75100456,9.31206141 L2.98738664,9.22716272 L3.1647264,9.40771227 L3.30063268,9.5463019 C3.33935737,9.58799195 3.38747711,9.65768024 3.41111296,9.70953959 L4.0555067,11.0927733 L4.13953993,11.0068776 C4.13257013,10.9413822 4.05659979,10.0787226 4.04316153,9.92697928 C4.0211034,9.67790515 4.005648,9.50358408 3.97473628,9.15512823 C3.95000692,8.87648194 3.95000692,8.87648194 3.94382537,8.80687833 L3.92384234,8.58187183 L4.10085175,8.44594866 C4.15889775,8.40137592 4.21719282,8.35586361 4.27587269,8.30930314 C4.92616375,7.79068654 5.6771736,7.12202385 6.45400213,6.36996277 L6.73554695,6.09739438 L7.00995558,6.37742539 L7.80080068,7.18462826 C7.8443052,7.2270137 7.90005528,7.30177202 7.9252493,7.34988795 L9.40571472,10.0522115 L9.73416944,9.71768939 L8.22799601,4.59385373 L8.40491012,4.42199559 C8.50535064,4.32436686 8.56213216,4.26916916 8.60291978,4.22958144 C8.6769601,4.15771927 8.73657044,4.10009505 8.79185931,4.04700798 C9.73533422,3.13425772 10.0368643,2.82205872 10.3278002,2.42680876 C10.7356382,1.87024845 10.9727079,1.30874241 10.9737258,0.95733821 C10.9735073,0.899304683 10.9672305,0.862033571 10.9528608,0.830007954 C10.934318,0.820050157 10.897381,0.812031047 10.8324491,0.812030519 C10.4861883,0.812626457 9.93537296,1.05436959 9.39495021,1.46653623 C9.00470675,1.76426065 8.69516539,2.07486383 7.79529201,3.04195988 C7.63785369,3.21112019 7.54053045,3.31538805 7.43162311,3.43131269 L7.26309929,3.6106951 L7.02971699,3.53939918 L2.23845235,2.07571371 L1.91060907,2.41008676 L4.56322712,3.92091513 C4.60963311,3.94745457 4.67812507,3.99998984 4.71779515,4.04043453 L5.7890762,5.1323879 L5.5219347,5.41932409 C4.78419785,6.21172588 4.12857045,6.97741686 3.6192543,7.64126281 C3.57840994,7.69421104 3.53841693,7.74734298 3.48470823,7.81967606 L3.3512996,7.99934633 L3.13117457,7.97896705 L0.974358695,7.77906015 L0.889886598,7.86509276 Z\"></path><g fill=\"#E93861\" transform=\"translate(9.5 2)\"><path d=\"M3.59357132,5.89861734 C2.0550638,5.89861734 0.807857037,4.65141057 0.807857037,3.11290306 C0.807857037,1.57439554 2.0550638,0.327188772 3.59357132,0.327188772 C5.13207884,0.327188772 6.37928561,1.57439554 6.37928561,3.11290306 C6.37928561,4.65141057 5.13207884,5.89861734 3.59357132,5.89861734 Z M3.59357132,5.3711785 C4.84078241,5.3711785 5.85184677,4.36011415 5.85184677,3.11290306 C5.85184677,1.86569197 4.84078241,0.854627614 3.59357132,0.854627614 C2.34636023,0.854627614 1.33529588,1.86569197 1.33529588,3.11290306 C1.33529588,4.36011415 2.34636023,5.3711785 3.59357132,5.3711785 Z\"></path><path d=\"M3.50565176,1.69897274 C3.50565176,1.50204431 3.65254195,1.39735659 3.8346132,1.39735659 C4.01668444,1.39735659 4.16357464,1.50204431 4.16357464,1.69897274 L4.16357464,3.39499416 C4.16357464,3.577372 4.01341437,3.71938403 3.8346132,3.71938403 L2.63931247,3.71938403 C2.46051129,3.71938403 2.31035103,3.577372 2.31035103,3.39499416 C2.31035103,3.21261631 2.46051129,3.07060428 2.63931247,3.07060428 L3.50565176,3.07060428 L3.50565176,1.69897274 Z\"></path>\n                                                    </g>\n                                                    </svg>\n                                                </span>\n                                                <span class=\"a-menu-link__text\">{{ 'flight_delayed' | translate }}</span>\n                                            </a>\n                                            <a href=\"{{ 'url_where_meet_driver_arrival' | translate }}\" class=\"a-menu-link\" target=\"_blank\">\n                                                <span class=\"a-menu-link__icon\">\n                                                    <svg class=\"i-meet-and-greet\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 16\">\n                                                        <polygon fill=\"#FFF\" points=\".454 6.183 9.875 15.341 15.266 10.1 5.482 1.825\"></polygon>\n                                                        <path fill=\"#09AFEE\" d=\"M13.652926,3.31883923 C13.6062965,3.27956973 13.5493049,3.24943267 13.4866141,3.23162441 L9.76713335,2.20239823 C8.2796519,1.79006848 7.31183046,2.50879165 7.05070519,2.73892918 C6.89890023,2.87271945 6.78180834,3.01564217 6.7232624,3.13847351 L5.06532417,6.57409809 C4.97051083,6.77044559 5.00263339,7.03254667 5.15029351,7.29282126 C5.36530737,7.66542488 5.7497418,7.93483191 6.20722912,8.03117917 C6.72118997,8.14031185 7.25328452,7.99190967 7.6703596,7.626612 C7.7796799,7.53026474 7.87242082,7.42295855 7.92734003,7.33391725 L8.48378554,6.42249956 C8.57497214,6.27272752 8.70864341,6.11564952 8.84801385,5.99236155 C9.32777972,5.57181261 9.55419191,5.76405051 9.64952335,5.84624249 C10.4831554,6.55446334 14.8528588,10.4234223 14.8528588,10.4234223 C15.0088087,10.5585824 14.976168,10.8193136 14.7818784,10.9905469 C14.5875887,11.1599537 14.2943409,11.1900908 14.1383911,11.0526475 L12.9099625,9.97182304 C12.7519402,9.83300993 12.4970322,9.83300993 12.33901,9.97182304 C12.1794335,10.1110928 12.1794335,10.3357508 12.33901,10.4750206 L13.5658843,11.5576716 C13.721316,11.6951148 13.6891934,11.9535629 13.4949038,12.1247962 C13.3006142,12.2960295 13.0052939,12.3247967 12.8514165,12.1873534 L11.6229879,11.1065289 C11.4649657,10.9672592 11.2100577,10.9672592 11.0520355,11.1065289 C10.8940132,11.245342 10.8940132,11.4700001 11.0520355,11.6110963 L12.2783916,12.6919208 C12.4343415,12.8293641 12.4001465,13.0878122 12.2079293,13.2590455 C12.0136396,13.4302787 11.7198737,13.4590459 11.5639239,13.3216027 L10.3354953,12.2407782 C10.1779912,12.1015085 9.92256505,12.1015085 9.76506092,12.2407782 C9.60703869,12.3800479 9.60703869,12.6065325 9.76506092,12.7439757 L10.9914171,13.8266267 C11.1473669,13.9636133 11.1147263,14.2243445 10.9204366,14.3937513 C10.726147,14.5649846 10.4308267,14.5932952 10.2769493,14.4576784 L8.78117821,13.1398671 C8.99567397,12.8563048 8.93712802,12.4458015 8.61952923,12.1658922 C8.26514494,11.8535627 7.72061586,11.8252521 7.40508949,12.1033349 C7.72061586,11.8252521 7.6884933,11.3435158 7.33410901,11.0316429 C6.9781704,10.7193134 6.43364131,10.6905462 6.11811494,10.9690857 C6.43364131,10.6905462 6.40151876,10.211093 6.04506204,9.89693702 C5.69067775,9.58506414 5.14666677,9.55629695 4.82854987,9.8343798 C5.14666677,9.55629695 5.11402611,9.07638713 4.7580875,8.76268776 C4.42598175,8.469993 3.9301546,8.42889701 3.60841096,8.65218521 L1.18782116,6.51884682 C1.02979893,6.37957708 0.772818502,6.37957708 0.615314371,6.51884682 C0.459364557,6.65765993 0.459364557,6.88460111 0.615314371,7.02341423 L3.0296869,9.15127315 L2.31521915,9.7827815 C1.99917468,10.0594945 2.02974291,10.5407742 2.38619963,10.8531037 C2.74213824,11.166803 3.28459491,11.1955702 3.6021937,10.9156609 C3.28459491,11.1955702 3.31671746,11.6754801 3.67317418,11.9873529 C4.02704036,12.3015089 4.57364187,12.3298195 4.88968634,12.0517367 C4.57364187,12.3298195 4.60628253,12.8097293 4.96014872,13.1220588 C5.31660544,13.4357582 5.86113452,13.4645254 6.17666089,13.1859859 C5.86113452,13.4645254 5.89325707,13.9439786 6.24764137,14.2581346 C6.60357998,14.5704641 7.14810906,14.5987747 7.46363543,14.3206918 L8.22058785,13.6535669 L9.70444256,14.9627025 C10.1779912,15.380055 10.9789826,15.349918 11.4934615,14.8983187 C11.7421523,14.6791401 11.8758235,14.3974043 11.8939572,14.1188648 C12.2094836,14.1028831 12.5296729,13.9850746 12.7804361,13.7640695 C13.0296449,13.5444343 13.1627981,13.2626984 13.1830042,12.9846156 C13.4990487,12.9686338 13.8166474,12.8489988 14.0674106,12.6298202 C14.3186919,12.4083585 14.4523631,12.1284492 14.4704968,11.8503663 C14.7860232,11.8339279 15.1056944,11.716576 15.3549033,11.4951143 C15.8688641,11.0421452 15.8994323,10.3357508 15.4253656,9.91839826 L14.8000121,9.3672554 L17.3703344,7.10195323 C17.5283566,6.96268349 17.5283566,6.73802542 17.3703344,6.59921231 L13.652926,3.31883923 Z\"></path><path fill=\"#1F708F\" fill-rule=\"nonzero\" d=\"M10.2529058,14.2533077 C10.2888031,14.2849451 10.4215356,14.2719041 10.5162948,14.1883953 C10.5953374,14.1194758 10.604405,14.047032 10.5859747,14.0308416 L9.36117934,12.9495584 C9.07731196,12.7026586 9.07731196,12.2853684 9.35945171,12.0367106 C9.62521511,11.8017149 10.0460317,11.8017149 10.3112751,12.0362519 L11.5398804,13.117232 C11.5775066,13.1503931 11.708535,13.137633 11.8015437,13.0556669 C11.8818092,12.9841638 11.8909566,12.9120063 11.8731258,12.8962915 L10.6454097,11.8142607 C10.3646866,11.5636062 10.3646866,11.1499509 10.6467696,10.9021582 C10.9129487,10.6675667 11.3327654,10.6675667 11.5987677,10.9020027 L12.8287692,11.9842215 C12.8641942,12.0158631 12.9958853,12.0030526 13.089638,11.9204255 C13.1698766,11.8497087 13.1788154,11.7781337 13.160486,11.7619255 L11.9347699,10.6802909 C11.6495955,10.4314062 11.6495955,10.0154374 11.9340879,9.76714988 C12.2001637,9.53341823 12.6194995,9.53341823 12.8857423,9.76729676 L14.1143476,10.8482768 C14.151438,10.8809657 14.2827198,10.8680388 14.3766125,10.7861762 C14.4565221,10.7157495 14.4655787,10.6433938 14.4471107,10.627367 C14.4057762,10.5907691 14.4057762,10.5907691 14.2195871,10.4259942 C13.9712684,10.2062871 13.8367225,10.0872761 13.6192859,9.89502899 C12.9980457,9.34575785 12.3761055,8.79648957 11.7946653,8.28385835 C10.4806215,7.12536332 9.57735235,6.33365828 9.24656555,6.0526251 C9.14365781,5.96390106 9.09222043,5.96159327 8.82435825,6.19638971 C8.70451007,6.30240816 8.58923069,6.4383671 8.51317209,6.56329132 L7.9560745,7.47577163 C7.88459275,7.59166603 7.77288636,7.7194325 7.64566354,7.831556 C7.16128132,8.25580503 6.53633633,8.42900625 5.93248706,8.30078657 C5.39748079,8.18811374 4.94388067,7.87096943 4.68713923,7.42604019 C4.49846862,7.09347805 4.4564275,6.74131921 4.59374967,6.45694087 L6.25111953,3.02250135 C6.32747822,2.86229828 6.46764008,2.69125832 6.64543935,2.5345585 C7.33246084,1.92906585 8.35027444,1.58228839 9.63017359,1.93707637 L13.3515584,2.96683641 C13.4527008,2.99556743 13.5460736,3.04463731 13.6240904,3.11033992 L17.3459471,6.39453915 C17.6286006,6.64283336 17.6286006,7.05751591 17.3462909,7.30632391 L15.0078575,9.36725541 L15.4012077,9.71392679 C16.0043536,10.2449164 15.9647071,11.1408564 15.3317248,11.6987194 C15.0990869,11.9054552 14.8100136,12.0419052 14.5029065,12.0985375 C14.4343431,12.3727414 14.2766737,12.6285701 14.0424976,12.834954 C13.8076399,13.0402305 13.5193165,13.176559 13.2144348,13.2329573 C13.1450432,13.507935 12.9880339,13.7642877 12.7563925,13.9684402 C12.5225194,14.1745596 12.2330505,14.3108256 11.9264669,14.3672084 C11.858091,14.6419875 11.701015,14.8985759 11.4689954,15.1030611 C10.849128,15.6471682 9.88388506,15.6823942 9.2990672,15.1669766 L8.00583336,14.0260169 L7.43959191,14.5250625 C7.01096941,14.9028204 6.30249581,14.8662531 5.84176614,14.4619666 C5.58812249,14.2371156 5.45792073,13.9403407 5.46086248,13.6527622 C5.14253243,13.6628139 4.81034921,13.5512523 4.55472985,13.3262946 C4.30104425,13.1023865 4.17074321,12.8058652 4.17362851,12.5183995 C3.85451405,12.5288023 3.52207254,12.4173641 3.26867238,12.1923946 C3.01296349,11.9686685 2.88183291,11.6717956 2.88486232,11.3836561 C2.56720202,11.3938332 2.23631569,11.2825494 1.98154442,11.058011 C1.50633023,10.6416254 1.4623917,9.97027174 1.90965044,9.57867812 L2.39286796,9.15156872 L0.209012835,7.22686759 C-0.0697862245,6.97870464 -0.0697862245,6.56355641 0.209705155,6.31477925 C0.475411428,6.07983403 0.897541264,6.07983403 1.16377764,6.31447613 L3.43542476,8.31654688 C3.85172275,8.14894086 4.37199844,8.23923549 4.73404397,8.55831707 C4.9889892,8.78300794 5.11988392,9.08004625 5.11684585,9.36782391 C5.43506506,9.35764357 5.76648193,9.46856352 6.02101852,9.69256634 C6.2760305,9.91731605 6.40707268,10.2143254 6.40441348,10.5022029 C6.72252676,10.4919566 7.05448471,10.6030041 7.30991238,10.8271374 C7.56421049,11.0509303 7.69466293,11.3483133 7.6915661,11.6366105 C8.00958749,11.6263764 8.34116036,11.7373769 8.59548571,11.9615215 C8.94003379,12.265182 9.06151827,12.7055529 8.91976617,13.0787788 L10.2529058,14.2533077 Z M13.1942645,3.49694627 L9.47465711,2.46768502 C8.86742591,2.29936058 8.31923352,2.32278991 7.8282465,2.49007323 C7.49100204,2.60497519 7.22054778,2.77242222 7.02666167,2.94329987 C6.90095462,3.05408926 6.80686911,3.1689021 6.76552753,3.25563073 L5.10755927,6.69131756 C5.05595238,6.79818947 5.07643424,6.96975649 5.18314163,7.15786024 C5.35802582,7.46092203 5.67396533,7.68181795 6.05313455,7.76167175 C6.47482587,7.85121224 6.91441814,7.72938084 7.26509376,7.42224132 C7.35247019,7.34523385 7.42835994,7.2584334 7.4686441,7.19312548 L8.02491355,6.28199658 C8.13016887,6.10911697 8.28152667,5.93060764 8.44331495,5.78749254 C8.93642566,5.3552459 9.31263595,5.37212499 9.6216153,5.63852776 C9.95472705,5.92152634 10.8583091,6.7135056 12.158938,7.86017349 C12.7576256,8.38801071 13.3797546,8.93744572 14.0011769,9.48687787 C14.2186721,9.67917688 14.3532525,9.79821833 14.6016471,10.0179925 C14.7879052,10.1828286 14.7879052,10.1828286 14.8270578,10.2175156 C15.1227243,10.4737668 15.0665106,10.9228724 14.7567108,11.1959029 C14.461517,11.453291 14.0066467,11.4980808 13.7333019,11.2571738 L12.5050404,10.1764962 C12.4550717,10.1326016 12.3645915,10.1326016 12.3139407,10.1770933 C12.279962,10.2067481 12.279962,10.2400955 12.3150989,10.2707667 L13.5421887,11.353608 C13.8346461,11.6122186 13.7790276,12.0575697 13.4708603,12.3291669 C13.1759836,12.5890506 12.7170446,12.6336948 12.4463274,12.3918797 L11.2177221,11.3108996 C11.1678567,11.2669517 11.0778574,11.2669517 11.0276482,11.3112021 C10.9940305,11.3407332 10.9940305,11.376394 11.0279919,11.4067257 L12.2543481,12.4875501 C12.5471292,12.7455868 12.4907883,13.1900228 12.1838857,13.4634161 C11.8892321,13.7231032 11.4327691,13.7675556 11.1588347,13.526129 L9.92988608,12.4448458 C9.88064122,12.401302 9.79060562,12.401302 9.7410174,12.4451489 C9.70745604,12.4747275 9.70745604,12.5104064 9.74119399,12.5397608 L10.9670252,13.6219495 C11.2610145,13.8801903 11.2048119,14.329208 10.8963931,14.598122 C10.6023487,14.8572721 10.1442603,14.9022792 9.87171975,14.6620811 L8.18614993,13.1770524 L8.33789533,12.9764457 C8.46488323,12.8085684 8.42466506,12.5556962 8.21426339,12.3702629 C7.96341875,12.149186 7.58319705,12.1295438 7.38104596,12.3077056 L6.99982364,11.8989643 C7.184334,11.7363498 7.16491488,11.4437666 6.92930136,11.2364165 C6.67665822,11.0147269 6.29623295,10.9949929 6.09424301,11.173305 L5.7126775,10.7648664 C5.89752062,10.6016911 5.877822,10.311087 5.6399493,10.1014425 C5.38868781,9.88032201 5.00831807,9.86059092 4.80364971,10.0395024 L4.42414067,9.62925721 C4.60991286,9.46686388 4.59062793,9.17664425 4.35282165,8.96705844 C4.11948499,8.76141184 3.7710302,8.72930907 3.55864678,8.87670192 L3.3725465,9.00585442 L0.782555316,6.72321751 C0.732747216,6.67932013 0.640916203,6.67932013 0.592306534,6.72230018 C0.559205966,6.75176346 0.559205966,6.79049758 0.591270845,6.81904354 L3.23719672,9.15097737 L3.00594624,9.35537653 L2.29048656,9.98775749 C2.10576832,10.1494877 2.12483322,10.4407877 2.36215611,10.648733 C2.61482717,10.8714196 2.99295512,10.8910575 3.19692785,10.7112902 L3.57815017,11.1200316 C3.39170583,11.2843506 3.41099464,11.5746287 3.64989273,11.7836564 C3.89987524,12.0055863 4.2817817,12.0256647 4.48459219,11.8472148 L4.86547113,12.2562585 C4.68089503,12.4186643 4.70023845,12.7095072 4.93595298,12.9175541 C5.18888864,13.1401499 5.5691362,13.1601646 5.77122345,12.9817666 L6.15278896,13.3902052 C5.96801571,13.5533189 5.9873536,13.8443356 6.22313965,14.053361 C6.47560324,14.2748931 6.85615929,14.2945351 7.05836959,14.1163211 L8.00603297,13.281117 L8.19665383,13.4492928 L9.68039903,14.7583318 C10.0418014,15.0768466 10.6784516,15.0536124 11.0881957,14.6939481 C11.2753144,14.5290347 11.3820528,14.3169854 11.3960853,14.1014416 L11.4120535,13.856165 L11.6645358,13.8433765 C11.9269985,13.8300825 12.1814629,13.7304189 12.3751702,13.5596988 C12.5622987,13.3947768 12.6694829,13.1824599 12.685271,12.9651788 L12.7029554,12.721801 L12.9536069,12.709126 C13.2136985,12.6959737 13.4670336,12.5959825 13.6621448,12.4254495 C13.8520001,12.2581243 13.9586211,12.0476933 13.9726268,11.8329146 L13.9885956,11.5880314 L14.2406547,11.5748996 C14.5038457,11.5611878 14.7572126,11.4617405 14.9496374,11.2907436 C15.3429931,10.9440675 15.3658665,10.4271705 15.0200998,10.1227689 L14.1628573,9.3672554 L16.9650686,6.89758254 C16.9988033,6.86785107 16.9988033,6.83321748 16.9649374,6.80346737 L13.2506523,3.52585029 C13.235062,3.51319412 13.2150196,3.50284881 13.1942645,3.49694627 Z\"></path><path fill=\"#09AFEE\" d=\"M20.6926546,3.67570075 L17.4177085,0.789849162 C17.1001097,0.511309689 16.5882213,0.511309689 16.2721768,0.789849162 L15.1266451,1.79761411 C14.8111188,2.07752345 14.8111188,2.52866607 15.1266451,2.80720554 L18.4036636,5.69305714 C18.71919,5.97113999 19.2310784,5.97113999 19.5471229,5.69305714 L20.6926546,4.68529219 C21.008181,4.40720934 21.008181,3.95378361 20.6926546,3.67570075 Z\"></path><path fill=\"#1F708F\" fill-rule=\"nonzero\" d=\"M20.6700291,3.47617837 C21.1100198,3.86376357 21.1100198,4.50695514 20.6698561,4.89469262 L19.5237755,5.9024419 C19.0993872,6.2756702 18.4223756,6.2756702 17.9985942,5.9023636 L14.7197,3.01628776 C14.2800403,2.62835811 14.2800403,1.98809405 14.7200613,1.59793945 L15.8659701,0.590341361 C16.2902958,0.216555314 16.9670681,0.216555314 17.3934628,0.590326774 L20.6700291,3.47617837 Z M20.2886348,3.88493433 L17.0125824,0.999534354 C16.8029679,0.815789833 16.4554569,0.815789833 16.2471914,0.999249592 L15.101967,2.00624279 C14.9097491,2.17667862 14.9097491,2.4386998 15.1011998,2.60762485 L18.3799223,5.49354934 C18.5874231,5.67633554 18.9346947,5.67633554 19.1427259,5.49338248 L20.2886348,4.48578439 C20.4800256,4.31718931 20.4800256,4.05352941 20.2886348,3.88493433 Z\"></path><path fill=\"#FFCD48\" d=\"M18.7757664,4.70516661 C18.4094657,4.70516661 18.1100006,4.4444354 18.1100006,4.12023372 C18.1100006,3.79694528 18.4094657,3.5348442 18.7757664,3.5348442 C19.1420672,3.5348442 19.4394598,3.79694528 19.4394598,4.12023372 C19.4394598,4.44306553 19.1420672,4.70516661 18.7757664,4.70516661 Z\"></path>\n                                                    </svg>\n                                                </span>\n                                                <span class=\"a-menu-link__text\">Meet &amp; greet</span>\n                                            </a>\n                                            <a href=\"{{ 'url_cant_select_address' | translate }}\" class=\"a-menu-link\" target=\"_blank\">\n                                                <span class=\"a-menu-link__icon\">\n                                                    <svg class=\"i-destination-simple\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 16\">\n                                                        <g fill=\"none\" fill-rule=\"evenodd\">\n                                                            <path fill=\"#09AFEE\" d=\"M5.99977877,0 C7.08823421,0 8.09262195,0.27406199 9.01338446,0.822185971 C9.93326205,1.37030995 10.6611113,2.10766721 11.1964898,3.03425775 C11.7318683,3.96084829 12,4.95921697 12,6.02936378 C12,7.0995106 11.6765606,8.28276237 11.0305667,9.57911909 C10.3845728,10.5709625 9.64743188,11.6019576 8.82047122,12.6721044 C7.9930681,13.7422512 7.32716345,14.5644372 6.82275727,15.1386623 L6.06659046,16 C5.97765569,15.9216966 5.85819107,15.8085916 5.70775414,15.6606852 C5.55731721,15.5127787 5.26308027,15.2060903 4.82548579,14.7406199 C4.38744884,14.2751495 3.96224328,13.8009788 3.55075403,13.3181077 C3.13926478,12.8352365 2.67866229,12.2457858 2.17071642,11.5497553 C1.66188562,10.8537249 1.21676929,10.1794454 0.836252351,9.5269168 C0.279193245,8.31799891 0,7.17781403 0,6.10766721 C0,5.02925503 0.267689244,4.02175095 0.803067733,3.08646003 C1.33844622,2.15116911 2.06895026,1.40293638 2.99325246,0.841761827 C3.91799712,0.280587276 4.92017256,0 5.99977877,0 C5.99977877,0 4.92017256,0 5.99977877,0 L5.99977877,0 L5.99977877,0 Z M8.1207767,8.12038835 C8.70679612,7.53398058 9,6.82563107 9,5.99417476 C9,5.1631068 8.70679612,4.45631068 8.1207767,3.87378641 C7.53398058,3.29126214 6.82524272,3 5.99456311,3 C5.1631068,3 4.45631068,3.29320388 3.87378641,3.87961165 C3.29126214,4.46601942 3,5.17087379 3,5.99417476 C3,6.82563107 3.29320388,7.53398058 3.88,8.12038835 C4.46601942,8.70679612 5.17087379,9 5.99456311,9 C6.82524272,9 7.53398058,8.70679612 8.1207767,8.12038835 Z\"></path><path fill=\"#1F708F\" fill-rule=\"nonzero\" d=\"M6.37489381,14.1769469 C6.82935018,13.6548165 7.43385557,12.9015595 8.18650338,11.9191264 C8.93879845,10.9366283 9.60644891,9.99379322 10.1618688,9.1390822 C10.7231343,8.00237288 11,6.97946729 11,6.07125931 C11,5.16658667 10.7766344,4.32654158 10.3281185,3.54313045 C9.87929397,2.7591802 9.27236105,2.13855673 8.50207353,1.67533747 C7.73671965,1.21552749 6.90600658,0.98679092 5.99979721,0.98679092 C5.10353387,0.98679092 4.27616331,1.22057195 3.5075704,1.69128634 C2.73189572,2.16656529 2.12174802,2.79756822 1.67245445,3.58970647 C1.22360125,4.38106831 1,5.2301206 1,6.1436991 C1,7.0590808 1.23921306,8.04588833 1.700919,9.06251297 C2.04018786,9.64967033 2.43872789,10.2592623 2.89683014,10.8916778 C3.35271197,11.522124 3.76799586,12.0589935 4.1389871,12.4983544 C4.50894487,12.9364913 4.89314615,13.3691104 5.29147031,13.7962826 C5.63485899,14.164913 5.88272277,14.4266832 6.02859766,14.5750435 L6.37489381,14.1769469 Z M9.02228223,0.832579396 C9.93886554,1.38377488 10.66622,2.12753619 11.1987795,3.05774422 C11.7321695,3.98940283 12,4.99667369 12,6.07125931 C12,7.14232301 11.6843423,8.30854911 11.0330939,9.62022737 C10.435062,10.5468952 9.75220614,11.5112028 8.98428296,12.5141112 C8.22010262,13.5115978 7.60378282,14.2795764 7.13358869,14.819788 L6.10694628,16 L5.72646253,15.6619116 C5.63759916,15.5829498 5.52268669,15.4732534 5.37758205,15.3292745 C5.23265344,15.1854702 4.95827285,14.8967336 4.55542406,14.4642722 C4.14624965,14.025464 3.75124877,13.5806843 3.37072861,13.1300385 C2.98248976,12.6702515 2.55235191,12.1141791 2.08305586,11.4651818 C1.60598135,10.8065753 1.18901333,10.1687965 0.810698068,9.5095817 C0.272148711,8.33005977 0,7.2073853 0,6.1436991 C0,5.06166198 0.267310751,4.04663722 0.799836399,3.10775457 C1.33163846,2.17014767 2.06043332,1.41644215 2.98015021,0.85290426 C3.90683142,0.285370799 4.91678249,0 5.99979721,0 C7.08898807,0 8.09966814,0.278290423 9.02228223,0.832579396 Z\"></path>\n                                                        </g>\n                                                    </svg>\n                                                </span>\n                                                <span class=\"a-menu-link__text\">{{ 'select_address' | translate }}</span>\n                                            </a>\n                                            <a href=\"{{ 'url_need_booking_code' | translate }}\" class=\"a-menu-link\" target=\"_blank\">\n                                                <span class=\"a-menu-link__icon\">\n                                                    <svg class=\"i-late-booking-code\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 16\">\n                                                        <g fill=\"none\" fill-rule=\"evenodd\">\n                                                            <path fill=\"#FFF\" d=\"M12,2.93417969 L12,1.79180664 C12,1.35522461 11.6393634,1 11.195986,1 L3.41481248,1 C3.31727957,1 3.22373489,1.03817383 3.15471481,1.10605469 L0.107741569,4.10532227 C0.0387810123,4.17320312 0,4.2653125 0,4.36131836 L0,15.2081641 C2.97628644e-05,15.6447754 0.360874731,16 0.804430698,16 L11.1959562,16 C11.6393336,16 11.9999702,15.6447754 11.9999702,15.2081934 L11.9999702,9.6803418 L12,2.93417969 Z\"></path>\n                                                            <g transform=\"translate(0 1)\">\n                                                                <rect width=\"6.853\" height=\"1\" x=\"2.667\" y=\"5.455\" fill=\"#09AFEE\" rx=\".5\"></rect><rect width=\"6.853\" height=\"1\" x=\"2.667\" y=\"8.182\" fill=\"#09AFEE\" rx=\".5\"></rect>\n                                                                <rect width=\"6.853\" height=\"1\" x=\"2.667\" y=\"10.909\" fill=\"#09AFEE\" rx=\".5\"></rect><path fill=\"#1F708F\" fill-rule=\"nonzero\" d=\"M12,1.93417969 L12,0.791806641 C12,0.355224609 11.6393634,0 11.195986,0 L3.41481248,0 C3.31727957,0 3.22373489,0.0381738281 3.15471481,0.106054687 L0.107741569,3.10532227 C0.0387810123,3.17320312 0,3.2653125 0,3.36131836 L0,14.2081641 C2.97628644e-05,14.6447754 0.360874731,15 0.804430698,15 L11.1959562,15 C11.6393336,15 11.9999702,14.6447754 11.9999702,14.2081934 L11.9999702,8.6803418 L12,1.93417969 Z M11.264381,8.6803418 L11.264381,14.2081934 C11.264381,14.2455176 11.2336955,14.2758984 11.1960157,14.2758984 L0.804460461,14.2758984 C0.766542572,14.2758984 0.735678482,14.2455176 0.735678482,14.2081934 L0.735678482,3.72342773 L2.97860794,3.72342773 C3.42201509,3.72342773 3.78268149,3.36834961 3.78268149,2.93191406 L3.78268149,0.724101562 L11.195986,0.724101562 C11.2336955,0.724101562 11.2643513,0.754482422 11.2643513,0.791806641 L11.2643513,1.93417969\"></path><path fill=\"#FFCD48\" d=\"M3.06666668,2.92700558 C3.06666668,2.96726208 3.03236843,3.00000023 2.99022679,3.00000023 L1.06666668,3.00000023 L3.06666668,1.09090935 L3.06666668,2.92700558 Z\"></path>\n                                                            </g>\n                                                            <path fill=\"#FFF\" d=\"M9.87871698,6 C11.4685885,6 12.757434,4.71115451 12.757434,3.12128302 C12.757434,1.53141154 11.4685885,0.242566047 9.87871698,0.242566047 C8.28884549,0.242566047 7,1.53141154 7,3.12128302 C7,4.71115451 8.28884549,6 9.87871698,6 Z\"></path>\n                                                            <path fill=\"#E93861\" fill-rule=\"nonzero\" d=\"M10,6 C8.34314575,6 7,4.65685425 7,3 C7,1.34314575 8.34314575,0 10,0 C11.6568542,0 13,1.34314575 13,3 C13,4.65685425 11.6568542,6 10,6 Z M10,5.35315721 C11.2996128,5.35315721 12.3531572,4.29961284 12.3531572,3 C12.3531572,1.70038716 11.2996128,0.646842793 10,0.646842793 C8.70038716,0.646842793 7.64684279,1.70038716 7.64684279,3 C7.64684279,4.29961284 8.70038716,5.35315721 10,5.35315721 Z\"></path>\n                                                            <path fill=\"#E93861\" fill-rule=\"nonzero\" d=\"M9.70177969,1.68591614 C9.70177969,1.49944358 9.83678922,1.39999998 10.0008898,1.39999998 C10.1649903,1.39999998 10.2999998,1.49944358 10.2999998,1.68591614 L10.2999998,3.1549639 C10.2999998,3.32698763 10.1632941,3.46060604 10.0008898,3.46060604 L8.99910988,3.46060604 C8.83670554,3.46060604 8.69999981,3.32698763 8.69999981,3.1549639 C8.69999981,2.98294016 8.83670554,2.84932175 8.99910988,2.84932175 L9.70177969,2.84932175 L9.70177969,1.68591614 Z\"></path>\n                                                        </g>\n                                                    </svg>\n                                                </span>\n                                                <span class=\"a-menu-link__text\">{{ 'late_booking_code' | translate }}</span>\n                                            </a>\n                                        </div>\n                                    </div>\n                                    <div class=\"o-detailed-menu__item o-detailed-menu__item--alt\">\n                                        <span class=\"o-detailed-menu__title\">{{ 'most_relevant_categories' | translate }}</span>\n\n                                        <div class=\"o-detailed-menu__content\">\n                                            <a href=\"{{ 'url_making_a_booking' | translate }}\" class=\"a-menu-link\" target=\"_blank\">\n                                                <span class=\"a-menu-link__icon\">\n                                                    <svg class=\"i-making-a-booking\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 16\">\n                                                        <g fill=\"none\" fill-rule=\"evenodd\">\n                                                            <path fill=\"#1F708F\" fill-rule=\"nonzero\" d=\"M19.9853669,13.7412769 C19.966258,13.7153587 19.9381082,13.6999998 19.9085201,13.6999998 L0.101565595,13.6999998 C0.0719775221,13.6999998 0.0440332311,13.7151188 0.0247187947,13.7412769 C0.00540435826,13.7671951 -0.00322549632,13.8019927 0.00108943097,13.8363103 C0.00396604916,13.8579088 0.302723396,15.9999998 2.62148313,15.9999998 L17.3886026,15.9999998 C19.7071569,15.9999998 20.0059142,13.8579088 20.0089963,13.8363103 C20.0131058,13.8019927 20.0044759,13.7671951 19.9853669,13.7412769 Z\"></path>\n                                                            <rect width=\"3.287\" height=\"1\" x=\"8.422\" y=\"14.586\" fill=\"#FFCD48\" rx=\".5\"></rect>\n                                                            <polygon fill=\"#FFF\" points=\"2.692 3.005 17.596 3.005 17.596 11.811 2.692 11.811 2.692 3.005\"></polygon>\n                                                            <path fill=\"#1F708F\" fill-rule=\"nonzero\" d=\"M4.58580028,3.0050365 L4.58580028,2.12248175 L18.0192094,2.12248175 C18.2468986,2.12248175 18.4316898,2.30854506 18.4316898,2.53780163 L18.4316898,12.2782988 C18.4316898,12.5075553 18.2468986,12.6936187 18.0192094,12.6936187 L2.26864259,12.6936187 C2.04095337,12.6936187 1.85616212,12.5075553 1.85616212,12.2782988 L1.85616212,6.55256047 L2.69152001,6.55256047 L2.69152001,11.8110639 L17.5963319,11.8110639 L17.5963319,3.0050365 L4.58580028,3.0050365 Z\"></path><polygon fill=\"#FFF\" points=\"3.836 5.328 .816 5.328 .816 .673 3.836 .673\"></polygon><path fill=\"#09AFEE\" d=\"M7.22981835 7.24661775C7.22981835 5.72253742 8.52508769 4.49827617 10.1375659 4.49827617 11.750044 4.49827617 13.0453134 5.72253742 13.0453134 7.24661775 13.0453134 8.77069809 11.750044 9.99495934 10.1375659 9.99495934 8.52508769 9.99495934 7.22981835 8.77069809 7.22981835 7.24661775zM11.8161292 6.38463789C11.8689973 6.33466804 11.8689973 6.25971327 11.8161292 6.22223589L11.6310907 6.04734142C11.5782226 5.99737158 11.4989204 5.99737158 11.4460522 6.04734142L11.4328352 6.04734142 9.66175263 7.78379361C9.63531856 7.80877853 9.59566746 7.80877853 9.56923339 7.78379361L8.84229651 7.04673836 8.82907948 7.0342459C8.77621134 6.98427605 8.69690914 6.98427605 8.644041 7.0342459L8.45900252 7.20914037C8.43256845 7.23412529 8.41935142 7.27160268 8.41935142 7.2965876 8.41935142 7.32157252 8.43256845 7.35904991 8.45900252 7.38403483L8.48543659 7.40901975 9.51636525 8.45838654C9.52958228 8.48337147 9.56923339 8.49586393 9.60888449 8.49586393 9.64853559 8.49586393 9.67496966 8.48337147 9.70140373 8.45838654L11.8161292 6.38463789zM1.20291467 2.91748122C1.20291467 2.32395297 1.70733621 1.84718438 2.33528955 1.84718438 2.96324289 1.84718438 3.46766442 2.32395297 3.46766442 2.91748122 3.46766442 3.51100946 2.96324289 3.98777806 2.33528955 3.98777806 1.70733621 3.98777806 1.20291467 3.51100946 1.20291467 2.91748122zM2.98897868 2.58179721C3.00956731 2.56233727 3.00956731 2.53314735 2.98897868 2.5185524L2.91691846 2.4504426C2.89632983 2.43098266 2.86544687 2.43098266 2.84485824 2.4504426L2.83971108 2.4504426 2.14999184 3.1266756C2.13969752 3.13640557 2.12425605 3.13640557 2.11396173 3.1266756L1.83086801 2.83964145 1.82572085 2.83477646C1.80513222 2.81531652 1.77424927 2.81531652 1.75366063 2.83477646L1.68160041 2.90288626C1.6713061 2.91261623 1.66615894 2.92721119 1.66615894 2.93694116 1.66615894 2.94667113 1.6713061 2.96126609 1.68160041 2.97099606L1.69189473 2.98072603 2.0933731 3.38938482C2.09852025 3.39911479 2.11396173 3.40397978 2.12940321 3.40397978 2.14484468 3.40397978 2.155139 3.39911479 2.16543332 3.38938482L2.98897868 2.58179721z\"></path><path fill=\"#1F708F\" fill-rule=\"nonzero\" d=\"M3.70897872,0.0240234137 L0.943417294,0.0240234137 C0.71301292,0.0240234137 0.524435802,0.208141482 0.524435802,0.433482599 L0.524435802,5.676604 C0.524435802,5.90194512 0.71301292,6.0862364 0.943417294,6.0862364 L3.70897872,6.0862364 C3.93938309,6.0862364 4.12796021,5.90229153 4.12796021,5.67677721 L4.12796021,0.433482599 C4.12796021,0.208141482 3.93938309,0.0240234137 3.70897872,0.0240234137 Z M1.88382161,0.319166583 L2.7685744,0.319166583 C2.7965774,0.319166583 2.81926336,0.341336962 2.81926336,0.368876729 C2.81926336,0.396243291 2.7965774,0.41841367 2.7685744,0.41841367 L1.88382161,0.41841367 C1.85581861,0.41841367 1.83313264,0.396243291 1.83313264,0.368876729 C1.83313264,0.341336962 1.85581861,0.319166583 1.88382161,0.319166583 Z M2.326198,5.8815068 C2.21046412,5.8815068 2.11670726,5.78988078 2.11670726,5.676604 C2.11670726,5.56332722 2.21046412,5.47187441 2.326198,5.47187441 C2.44193189,5.47187441 2.53568875,5.56332722 2.53568875,5.676604 C2.53568875,5.78988078 2.44193189,5.8815068 2.326198,5.8815068 Z M3.83641006,5.32845977 L0.815985951,5.32845977 L0.815985951,0.673373027 L3.83641006,0.673373027 L3.83641006,5.32845977 Z\"></path>\n                                                        </g>\n                                                    </svg>\n                                                </span>\n                                                <span class=\"a-menu-link__text\">{{ 'making_booking' | translate }}</span>\n                                            </a>\n                                            <a href=\"{{ 'url_amend_or_cancel_booking' | translate }}\" class=\"a-menu-link\" target=\"_blank\">\n                                                <span class=\"a-menu-link__icon\">\n                                                    <svg class=\"i-amending\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 16\">\n                                                        <g fill=\"none\" fill-rule=\"evenodd\">\n                                                            <path fill=\"#FFF\" d=\"M0.311783903,3.74932861 L2.83423481,3.74932861 C3.15687897,3.74932861 3.41931702,3.48896377 3.41931702,3.16894273 L3.47369305,0.59375 L11.9475686,0.59375 C11.9750079,0.59375 11.9973145,0.616027091 11.9973145,0.643395474 L11.9973145,15.4837036 L0.359130859,15.4837036 L0.311783903,3.74932861 Z\"></path>\n                                                            <path fill=\"#1F708F\" fill-rule=\"nonzero\" d=\"M12.0359199,2.4493125 C12.2460709,2.4493125 12.4164953,2.27640625 12.4164953,2.063125 L12.4164953,0.84459375 C12.4164953,0.37890625 12.0433417,0 11.5845756,0 L3.53333359,0 C3.43241552,0 3.33562409,0.04071875 3.26420846,0.113125 L0.111481057,3.31234375 C0.0401270214,3.38475 -1.59872116e-14,3.483 -1.59872116e-14,3.58540625 L-1.59872116e-14,15.155375 C3.07958721e-05,15.6210938 0.373399949,16 0.832350831,16 L11.5845448,16 C12.0433109,16 12.4164645,15.6210938 12.4164645,15.1554063 L12.4164645,9.25903125 C12.4164953,9.04578125 12.2461017,8.87284375 12.0359199,8.87284375 C11.8257689,8.87284375 11.6553445,9.04575 11.6553445,9.25903125 L11.6553445,15.1554062 C11.6553445,15.1952187 11.623594,15.227625 11.5846064,15.227625 L0.832381627,15.227625 C0.793147686,15.227625 0.761212367,15.1952187 0.761212367,15.1554062 L0.761212367,3.97165625 L3.08198929,3.97165625 C3.54078619,3.97165625 3.91397057,3.59290625 3.91397057,3.127375 L3.91397057,0.772375 L11.5845756,0.772375 C11.623594,0.772375 11.6553137,0.80478125 11.6553137,0.84459375 L11.6553137,2.063125 C11.6553137,2.27640625 11.8257381,2.4493125 12.0359199,2.4493125 Z\"></path>\n                                                            <path fill=\"#FFCD48\" d=\"M2.95879764,2.9300925 C2.95879764,2.96177536 2.93339931,2.98754108 2.90219285,2.98754108 L1.47777025,2.98754108 L2.95879764,1.48503979 L2.95879764,2.9300925 Z\"></path>\n                                                            <g transform=\"translate(2 3)\">\n                                                                <rect width=\"5.482\" height=\"1\" x=\".44\" y=\"3.548\" fill=\"#09AFEE\" rx=\".5\"></rect>\n                                                                <rect width=\"5.482\" height=\"1\" x=\".44\" y=\"5.708\" fill=\"#09AFEE\" rx=\".5\"></rect>\n                                                                <path fill=\"#09AFEE\" d=\"M0.439677105,9.11614748 C0.439677105,8.92472809 0.604026554,8.76955202 0.783050061,8.76955202 L2.22056425,8.76955202 L2.22056425,9.46274295 L0.783050061,9.46274295 C0.593410414,9.46274295 0.439677105,9.30196868 0.439677105,9.11614748 L0.439677105,9.11614748 Z\"></path>\n                                                                <g transform=\"translate(1.85)\">\n                                                                    <path fill=\"#1F708F\" fill-rule=\"nonzero\" d=\"M8.80932913,1.00756982 L8.43392802,0.626694988 C8.01301202,0.199582852 7.32814574,0.199635246 6.9071781,0.626694988 L0.730912111,6.89385302 C0.686842949,6.93857091 0.65870271,6.98758507 0.643961356,7.04139323 L0.151171567,8.84234257 C0.151171567,8.84234257 0.00932303822,9.27402752 0.0647366288,9.37655439 C0.120150219,9.47908126 0.393745585,9.48982193 0.393745585,9.48982193 C0.393771402,9.48982193 0.463683113,9.48180572 0.473958173,9.47908126 C0.47563626,9.47863591 2.48758585,8.91213076 2.48758585,8.91213076 C2.54061342,8.8971986 2.58894235,8.86859173 2.62784816,8.8291132 L8.80935495,2.55668961 C9.23021932,2.12962987 9.23021932,1.43468196 8.80932913,1.00756982 Z M0.852070036,8.7009586 L1.11248342,7.74933474 L1.78991448,8.43673798 L0.852070036,8.7009586 Z\"></path>\n                                                                    <polygon fill=\"#FFCD48\" points=\"2.402 8.142 1.403 7.128 6.505 1.95 7.505 2.965\"></polygon><path fill=\"#09AFEE\" d=\"M8.35810428,2.09887486 L7.95611194,2.50678477 L6.95643643,1.49239344 L7.35842877,1.08448354 C7.53060056,0.909803479 7.81066047,0.909829676 7.98270317,1.08448354 L8.35810428,1.46541077 C8.53022444,1.64006464 8.53022444,1.92424719 8.35810428,2.09887486 Z\"></path>\n                                                                </g>\n                                                            </g>\n                                                        </g>\n                                                    </svg>\n                                                </span>\n                                                <span class=\"a-menu-link__text\">{{ 'amending_cancelling_booking' | translate }}</span>\n                                            </a>\n                                            <a href=\"{{ 'url_payment_refunds' | translate }}\" class=\"a-menu-link\" target=\"_blank\">\n                                                <span class=\"a-menu-link__icon\">\n                                                    <svg class=\"i-payments\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 12\">\n                                                        <g fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(-.35)\">\n                                                            <path fill=\"#09AFEE\" fill-rule=\"nonzero\" d=\"M12.0117721,1.94652294 L2.33646937,1.94652294 C1.84251381,1.94652294 1.44060801,2.33702229 1.44060801,2.81695894 L1.44060801,9.08409819 C1.44060801,9.56403484 1.84251381,9.9545342 2.33646937,9.9545342 L12.0117721,9.9545342 C12.5057276,9.9545342 12.9076334,9.56403484 12.9076334,9.08409819 L12.9076334,2.81695894 C12.9076334,2.33702229 12.5057276,1.94652294 12.0117721,1.94652294 Z\" transform=\"rotate(-16 7.174 5.95)\"></path>\n                                                            <path fill=\"#1F708F\" fill-rule=\"nonzero\" d=\"M12.0117721,1.67565505 C12.6603549,1.67565505 13.1872647,2.18761067 13.1872647,2.81695894 L13.1872647,9.08409819 C13.1872647,9.71344647 12.6603549,10.2254021 12.0117721,10.2254021 L2.33646937,10.2254021 C1.68788654,10.2254021 1.16097675,9.71344647 1.16097675,9.08409819 L1.16097675,2.81695894 C1.16097675,2.18761067 1.68788654,1.67565505 2.33646937,1.67565505 L12.0117721,1.67565505 Z M12.0117721,2.21739082 L2.33646937,2.21739082 C1.99714108,2.21739082 1.72023926,2.48643391 1.72023926,2.81695894 L1.72023926,9.08409819 C1.72023926,9.41462322 1.99714108,9.68366632 2.33646937,9.68366632 L12.0117721,9.68366632 C12.3511003,9.68366632 12.6280022,9.41462322 12.6280022,9.08409819 L12.6280022,2.81695894 C12.6280022,2.48643391 12.3511003,2.21739082 12.0117721,2.21739082 Z\" transform=\"rotate(-16 7.174 5.95)\"></path>\n                                                            <polygon fill=\"#1F708F\" points=\".716 3.265 12.289 3.265 12.289 4.66 .788 4.66\" transform=\"rotate(-16 6.502 3.962)\"></polygon>\n                                                            <path fill=\"#09AFEE\" fill-rule=\"nonzero\" d=\"M14.1618581,3.68734396 L4.48655537,3.68734396 C3.99259981,3.68734396 3.59069401,4.07784332 3.59069401,4.55777997 L3.59069401,10.8249192 C3.59069401,11.3048559 3.99259981,11.6953552 4.48655537,11.6953552 L14.1618581,11.6953552 C14.6558136,11.6953552 15.0577194,11.3048559 15.0577194,10.8249192 L15.0577194,4.55777997 C15.0577194,4.07784332 14.6558136,3.68734396 14.1618581,3.68734396 Z\"></path>\n                                                            <path fill=\"#1F708F\" fill-rule=\"nonzero\" d=\"M14.1618581,3.41647608 C14.8104409,3.41647608 15.3373507,3.92843169 15.3373507,4.55777997 L15.3373507,10.8249192 C15.3373507,11.4542675 14.8104409,11.9662231 14.1618581,11.9662231 L4.48655537,11.9662231 C3.83797254,11.9662231 3.31106275,11.4542675 3.31106275,10.8249192 L3.31106275,4.55777997 C3.31106275,3.92843169 3.83797254,3.41647608 4.48655537,3.41647608 L14.1618581,3.41647608 Z M14.1618581,3.95821185 L4.48655537,3.95821185 C4.14722708,3.95821185 3.87032526,4.22725494 3.87032526,4.55777997 L3.87032526,10.8249192 C3.87032526,11.1554442 4.14722708,11.4244873 4.48655537,11.4244873 L14.1618581,11.4244873 C14.5011864,11.4244873 14.7780882,11.1554442 14.7780882,10.8249192 L14.7780882,4.55777997 C14.7780882,4.22725494 14.5011864,3.95821185 14.1618581,3.95821185 Z\"></path>\n                                                            <path fill=\"#FFCD48\" fill-rule=\"nonzero\" d=\"M7.53248399,7.16908799 L5.38241673,7.16908799 C5.18449856,7.16908799 5.02407218,7.01321466 5.02407218,6.82091359 L5.02407218,5.42821598 C5.02407218,5.2359149 5.18449856,5.08004157 5.38241673,5.08004157 L7.53248399,5.08004157 C7.73040217,5.08004157 7.89082854,5.2359149 7.89082854,5.42821598 L7.89082854,6.82091359 C7.89082854,7.01321466 7.73040217,7.16908799 7.53248399,7.16908799 Z\"></path>\n                                                            <g fill=\"#1F708F\" fill-rule=\"nonzero\" transform=\"translate(5.024 8.562)\">\n                                                                <path d=\"M1.2542059.870436007L.358344544.870436007C.160426373.870436007 0 .714562679 0 .522261604L0 .348174403C0 .155873328.160426373 0 .358344544 0L1.2542059 0C1.45212408 0 1.61255045.155873328 1.61255045.348174403L1.61255045.522261604C1.61255045.714562679 1.45212408.870436007 1.2542059.870436007zM3.58344544.870436007L2.68758408.870436007C2.48966591.870436007 2.32923954.714562679 2.32923954.522261604L2.32923954.348174403C2.32923954.155873328 2.48966591 0 2.68758408 0L3.58344544 0C3.78136361 0 3.94178999.155873328 3.94178999.348174403L3.94178999.522261604C3.94178999.714562679 3.78136361.870436007 3.58344544.870436007zM5.91268498.870436007L5.01682362.870436007C4.81890545.870436007 4.65847908.714562679 4.65847908.522261604L4.65847908.348174403C4.65847908.155873328 4.81890545 0 5.01682362 0L5.91268498 0C6.11060315 0 6.27102952.155873328 6.27102952.348174403L6.27102952.522261604C6.27102952.714562679 6.11060315.870436007 5.91268498.870436007zM8.24192452.870436007L7.34606316.870436007C7.14814499.870436007 6.98771861.714562679 6.98771861.522261604L6.98771861.348174403C6.98771861.155873328 7.14814499 0 7.34606316 0L8.24192452 0C8.43984269 0 8.60026906.155873328 8.60026906.348174403L8.60026906.522261604C8.60026906.714562679 8.43984269.870436007 8.24192452.870436007z\"></path>\n                                                            </g>\n                                                            <path fill=\"#1F708F\" fill-rule=\"nonzero\" d=\"M8.7866899 10.4911692L5.20324446 10.4911692C5.10420698 10.4911692 5.02407218 10.4099924 5.02407218 10.3098698 5.02407218 10.2097472 5.10420698 10.1285704 5.20324446 10.1285704L8.7866899 10.1285704C8.88572737 10.1285704 8.96586217 10.2097472 8.96586217 10.3098698 8.96586217 10.4099924 8.88572737 10.4911692 8.7866899 10.4911692zM11.1159294 10.4911692L9.50337899 10.4911692C9.40434151 10.4911692 9.32420672 10.4099924 9.32420672 10.3098698 9.32420672 10.2097472 9.40434151 10.1285704 9.50337899 10.1285704L11.1159294 10.1285704C11.2149669 10.1285704 11.2951017 10.2097472 11.2951017 10.3098698 11.2951017 10.4099924 11.2149669 10.4911692 11.1159294 10.4911692z\"></path>\n                                                            <polygon fill=\"#E6B03C\" fill-rule=\"nonzero\" points=\"7.891 6.299 6.099 6.299 6.099 5.95 7.891 5.95 7.891 5.602 6.099 5.602 6.099 5.08 5.741 5.08 5.741 7.169 6.099 7.169 6.099 6.647 7.891 6.647\"></polygon>\n                                                        </g>\n                                                    </svg>\n                                                </span>\n                                                <span class=\"a-menu-link__text\">{{ 'faq_payment' | translate }}</span>\n                                            </a>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                    <a class=\"o-nav__link--mobile\" href=\"#\" ng-click=\"vm.logout()\" ng-if=\"vm.authService.authenticated\">\n                        <i class=\"o-nav__icon st-icon-logout\"></i>\n                        <span class=\"o-nav__text\">{{ 'header_logout' | translate }}</span>\n                    </a>\n\n                    <div class=\"o-nav__context\" style=\"vertical-align: top;\">\n                        <div class=\"o-nav__secondary\" style=\"min-height: 60px\">\n                            <a class=\"o-nav__link\" href=\"#\" ng-click=\"vm.logout()\" ng-if=\"vm.authService.authenticated\">\n                                <i class=\"o-nav__icon--show-in-mobile st-icon-user\"></i>\n                                <span class=\"o-nav__text\">{{ 'header_logout' | translate }}</span>\n                            </a>\n                        </div>\n                    </div>\n                </div>\n            </nav>\n        </div>\n    </div>\n</header>\n<st-browser-alerts></st-browser-alerts>"

/***/ },
/* 12 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var NavbarController = (function () {
	    NavbarController.$inject = ["$state", "$stateParams", "authService", "helpCentreService", "DropdownManager", "$timeout"];
	    function NavbarController($state, $stateParams, authService, helpCentreService, DropdownManager, $timeout) {
	        'ngInject';
	
	        _classCallCheck(this, NavbarController);
	
	        this.$state = $state;
	        this.$stateParams = $stateParams;
	        this.authService = authService;
	        this.helpCentreService = helpCentreService;
	        this.name = 'navbar';
	        this.dropdownManager = DropdownManager;
	        this.$timeout = $timeout;
	    }
	
	    _createClass(NavbarController, [{
	        key: 'logout',
	        value: function logout() {
	            var _this = this;
	
	            //TODO Move to an abstract state inside auth routes
	            this.authService.logout().then(function () {
	                _this.$state.go('auth.login', {
	                    locale: _this.$stateParams.locale
	                });
	            });
	        }
	    }]);
	
	    return NavbarController;
	})();
	
	exports['default'] = NavbarController;
	module.exports = exports['default'];

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _languageService = __webpack_require__(14);
	
	var _languageService2 = _interopRequireDefault(_languageService);
	
	var SharedService = (function () {
	    SharedService.$inject = ["languageService", "CONFIG"];
	    function SharedService(languageService, CONFIG) {
	        'ngInject';
	
	        _classCallCheck(this, SharedService);
	
	        this.languageService = languageService;
	        this.CONFIG = CONFIG;
	    }
	
	    _createClass(SharedService, [{
	        key: 'getBaseUrl',
	        value: function getBaseUrl() {
	            if (this.languageService.currentLanguage.key === 'en') {
	                return this.CONFIG.website.baseUrl + '/help';
	            } else {
	                return this.CONFIG.website.baseUrl + '/' + this.languageService.currentLanguage.key + '/help';
	            }
	        }
	    }]);
	
	    return SharedService;
	})();
	
	var sharedServiceModule = _angular2['default'].module('st.services.helpCentre', [_languageService2['default']]).service('helpCentreService', SharedService).name;
	
	exports['default'] = sharedServiceModule;
	module.exports = exports['default'];

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularTranslate = __webpack_require__(6);
	
	var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	
	var _cacheService = __webpack_require__(15);
	
	var _cacheService2 = _interopRequireDefault(_cacheService);
	
	var _configConfig = __webpack_require__(16);
	
	var _configConfig2 = _interopRequireDefault(_configConfig);
	
	var LanguageService = (function () {
	    LanguageService.$inject = ["cacheService", "$translate", "CONFIG"];
	    function LanguageService(cacheService, $translate, CONFIG) {
	        'ngInject';
	
	        _classCallCheck(this, LanguageService);
	
	        this.cacheService = cacheService;
	        this.$translate = $translate;
	        this.CONFIG = CONFIG;
	
	        //TODO use WeakMap
	        this._wm = {};
	        this.populateTranslationKeys();
	    }
	
	    _createClass(LanguageService, [{
	        key: 'populateTranslationKeys',
	        value: function populateTranslationKeys() {
	            this._wm.languagesByUrl = {};
	            for (var key in this.CONFIG.languages) {
	                this._wm.languagesByUrl[this.CONFIG.languages[key].key] = _angular2['default'].copy(this.CONFIG.languages[key]);
	                this._wm.languagesByUrl[this.CONFIG.languages[key].key].translationKey = key;
	            }
	        }
	    }, {
	        key: 'findLanguageByKey',
	        value: function findLanguageByKey(key) {
	            var language = this._wm.languagesByUrl[key] || null;
	
	            if (language) {
	                return language;
	            }
	
	            throw new Error("Language not found");
	        }
	    }, {
	        key: 'getDefaultLanguage',
	        value: function getDefaultLanguage() {
	            return this.CONFIG.languages[this.CONFIG.default_locale];
	        }
	    }, {
	        key: 'getLanguageByKey',
	        value: function getLanguageByKey(key) {
	            try {
	                return this.findLanguageByKey(key);
	            } catch (e) {
	                return this.getDefaultLanguage();
	            }
	        }
	    }, {
	        key: 'setLanguage',
	        value: function setLanguage(lang) {
	            this.currentLanguage = this.getLanguageByKey(lang);
	            this.$translate.use(this.currentLanguage.translationKey);
	        }
	    }]);
	
	    return LanguageService;
	})();
	
	var _module = _angular2['default'].module('st.services.language', [_cacheService2['default'], _angularTranslate2['default'], _configConfig2['default']]).service('languageService', LanguageService).name;
	
	exports['default'] = _module;
	module.exports = exports['default'];

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	//TODO Use a factory to load weakMap or (local|session)storage
	
	var CacheService = (function () {
	    function CacheService() {
	        _classCallCheck(this, CacheService);
	
	        //TODO use WeakMap
	        this._wm = {};
	
	        this.prefix = "st_";
	        this.storage = localStorage;
	        this.isLocalStorageActive = this.isLocalStorageSupported();
	    }
	
	    _createClass(CacheService, [{
	        key: 'isLocalStorageSupported',
	        value: function isLocalStorageSupported() {
	            try {
	                var testKey = 'test';
	                this.storage.setItem(testKey, '1');
	                this.storage.removeItem(testKey);
	                return true;
	            } catch (error) {
	                return false;
	            }
	        }
	    }, {
	        key: 'get',
	        value: function get(key) {
	            var value = false;
	            if (!this.isLocalStorageActive) {
	                value = this._wm[key] || false;
	                if (value) {
	                    value = _angular2['default'].fromJson(value);
	                }
	                return value;
	            }
	
	            value = this.storage.getItem(key);
	            if (!value) {
	                return false;
	            }
	
	            return _angular2['default'].fromJson(value);
	        }
	    }, {
	        key: 'set',
	        value: function set(key, value) {
	            if (!this.isLocalStorageActive) {
	                this._wm[key] = _angular2['default'].toJson(value);
	            }
	            this.storage.setItem(key, _angular2['default'].toJson(value));
	        }
	    }, {
	        key: 'delete',
	        value: function _delete(key) {
	            if (!this.isLocalStorageActive) {
	                delete this._wm[key];
	            }
	            this.storage.removeItem(key);
	        }
	    }, {
	        key: 'clear',
	        value: function clear() {
	            this.storage.clear();
	        }
	    }]);
	
	    return CacheService;
	})();
	
	var cacheServiceModule = _angular2['default'].module('st.services.cache', []).service('cacheService', CacheService).name;
	
	exports['default'] = cacheServiceModule;
	module.exports = exports['default'];

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _jsonConfigConfigJson = __webpack_require__(17);
	
	var _jsonConfigConfigJson2 = _interopRequireDefault(_jsonConfigConfigJson);
	
	var _jsonConfigParametersJson = __webpack_require__(18);
	
	var _jsonConfigParametersJson2 = _interopRequireDefault(_jsonConfigParametersJson);
	
	var configModule = _angular2["default"].module('app.config', []).constant('CONFIG', _angular2["default"].merge({}, _jsonConfigConfigJson2["default"], _jsonConfigParametersJson2["default"])).name;
	
	exports["default"] = configModule;
	module.exports = exports["default"];

/***/ },
/* 17 */,
/* 18 */,
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularSanitize = __webpack_require__(20);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _footerComponent = __webpack_require__(22);
	
	var _footerComponent2 = _interopRequireDefault(_footerComponent);
	
	var _stCookieSettingsStCookieSettings = __webpack_require__(25);
	
	var _stCookieSettingsStCookieSettings2 = _interopRequireDefault(_stCookieSettingsStCookieSettings);
	
	var footerModule = _angular2['default'].module('footer', [_angularUiRouter2['default'], _angularSanitize2['default'], _stCookieSettingsStCookieSettings2['default']]).component('footer', _footerComponent2['default']).name;
	
	exports['default'] = footerModule;
	module.exports = exports['default'];

/***/ },
/* 20 */,
/* 21 */,
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _footerHtml = __webpack_require__(23);
	
	var _footerHtml2 = _interopRequireDefault(_footerHtml);
	
	var _footerController = __webpack_require__(24);
	
	var _footerController2 = _interopRequireDefault(_footerController);
	
	var footerComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _footerHtml2['default'],
	  controller: _footerController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = footerComponent;
	module.exports = exports['default'];

/***/ },
/* 23 */
/***/ function(module, exports) {

	module.exports = "<style>\n    html{-webkit-font-smoothing:antialiased;}.o-disclaimer{position:fixed;bottom:0;left:0;right:0;width:100%;z-index:200;display:block;text-align:center;background-color:rgba(17,108,142,.95);color:#fff;overflow-y:hidden;max-height:150px;transition:none}.o-disclaimer.is-collapsed{max-height:0;transition:.5s cubic-bezier(.55,.45,.35,1) max-height}.o-disclaimer__text{display:block;font-size:13px}.o-disclaimer__container{padding:14px 8.96px}.o-disclaimer__link,.o-disclaimer__link:focus,.o-disclaimer__link:hover{font-weight:600;text-decoration:underline;color:#fff}.o-disclaimer__text+.o-disclaimer__cta{margin:14px 0 0}.o-disclaimer__cta{display:inline-block;padding:5px 21px;font-size:14px;background-color:#FFCD48;border-radius:5px;border:1px solid #E5A600;font-weight:600;color:#45423C}.o-disclaimer__cta:focus,.o-disclaimer__cta:hover{color:#45423C;text-decoration:none}@media only screen and (min-width:48em){.o-disclaimer__text{display:inline-block}.o-disclaimer__cta,.o-disclaimer__text{vertical-align:middle}.o-disclaimer__text+.o-disclaimer__cta{margin:0 0 0 14px}}\n    .c-alert-cookie {\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        width: 100%;\n        z-index: 200;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: center;\n        -ms-flex-pack: center;\n        justify-content: center;\n        text-align: center;\n        background-color: rgba(17,108,142,.95);\n        color: #fff;\n        overflow-y: hidden;\n        -webkit-transition: max-height .5s cubic-bezier(.55,.45,.35,1);\n        transition: max-height .5s cubic-bezier(.55,.45,.35,1)\n    }\n\n    .c-alert-cookie.is-collapsed {\n        max-height: 0\n    }\n\n    .c-alert-cookie.m-alert-cookie--warning {\n        background-color: #fce1e7;\n        color: #c3113a\n    }\n\n    .c-alert-cookie.m-alert-cookie--outdated {\n        font-size: 15px;\n        font-weight: 600;\n        background-color: #54b3d7;\n        color: #fff\n    }\n\n    .c-alert-cookie__text {\n        display: block;\n        font-size: 13px\n    }\n\n    .c-alert-cookie__text_title {\n        display: block;\n        font-size: 15px;\n        padding-bottom: 5px;\n        font-weight: 700;\n        text-transform: uppercase\n    }\n\n    .c-alert-cookie__container {\n        padding: 14px 8.96px;\n        max-width: 1150px\n    }\n\n    .c-alert-cookie__link,.c-alert-cookie__link:focus,.c-alert-cookie__link:hover {\n        font-weight: 600;\n        text-decoration: underline;\n        color: #fff\n    }\n\n    .c-alert-cookie--warning .c-alert-cookie__link,.c-alert-cookie--warning .c-alert-cookie__link:focus,.c-alert-cookie--warning .c-alert-cookie__link:focus:focus,.c-alert-cookie--warning .c-alert-cookie__link:focus:hover,.c-alert-cookie--warning .c-alert-cookie__link:hover,.c-alert-cookie--warning .c-alert-cookie__link:hover:focus,.c-alert-cookie--warning .c-alert-cookie__link:hover:hover {\n        color: #c3113a\n    }\n\n    .c-alert-cookie__text+.c-alert-cookie__cta {\n        margin: 14px 0 0\n    }\n\n    .c-alert-cookie__cta {\n        display: inline-block;\n        padding: 5px 21px;\n        font-size: 14px;\n        background-color: #ffcd48;\n        border-radius: 5px;\n        border: 1px solid #e5a600;\n        font-weight: 600;\n        color: #45423c\n    }\n\n    .c-alert-cookie__cta:focus,.c-alert-cookie__cta:hover {\n        color: #45423c\n    }\n\n    .c-alert-cookie__cta_blue {\n        background-color: rgba(17,108,142,.95);\n        color: #fff;\n        border: 1px solid #fff\n    }\n\n    .c-alert-cookie__cta_blue:focus,.c-alert-cookie__cta_blue:hover {\n        color: #fff\n    }\n\n    .c-cookies-settings-overlay {\n        z-index: 300;\n        position: fixed;\n        left: 0;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        background-color: rgba(0,0,0,.5);\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        -webkit-box-pack: center;\n        -ms-flex-pack: center;\n        justify-content: center;\n        width: 100%;\n        height: 100%;\n        overflow: auto\n    }\n\n    .c-cookies-settings {\n        width: 50%;\n        z-index: 300;\n        display: block;\n        text-align: center;\n        border: 0;\n        border-radius: 6px;\n        -webkit-box-shadow: 0 2px 14px rgba(0,0,0,.175);\n        box-shadow: 0 2px 14px rgba(0,0,0,.175);\n        background-color: #fff;\n        color: #000;\n        overflow-y: hidden;\n        -webkit-transition: max-height .5s cubic-bezier(.55,.45,.35,1);\n        transition: max-height .5s cubic-bezier(.55,.45,.35,1)\n    }\n\n    .c-cookies-settings__headline {\n        padding: 40px 40px 0\n    }\n\n    .c-cookies-settings__buttons {\n        padding: 30px 40px 40px;\n        text-align: right\n    }\n\n    .c-cookies-settings__content {\n        padding: 15px 40px 0;\n        text-align: left\n    }\n\n    .c-cookies-settings__headline .c-cookies-settings__title {\n        line-height: 35px;\n        font-size: 24px;\n        margin: 0\n    }\n\n    .c-cookies-settings__headline .c-cookies-settings__text {\n        margin-top: 14px;\n        font-size: 17.5px;\n        color: #777\n    }\n\n    .c-cookies-settings__content .c-cookies-settings__element {\n        padding: 14px 0;\n        border-bottom: 1px dotted #b2aea5\n    }\n\n    .c-cookies-settings__content .c-cookies-settings__element .c-cookies-settings__element_title {\n        line-height: 20px;\n        font-size: 18px;\n        margin: 0;\n        padding-bottom: 10px\n    }\n\n    .c-cookies-settings__content .c-cookies-settings__element .c-cookies-settings__element_text {\n        font-size: 14px;\n        color: #777;\n        padding-right: 100px\n    }\n\n    .c-cookies-settings__buttons .c-cookies-settings__save {\n        background-color: #ffcd48;\n        border: 1px solid #e5a600;\n        color: #45423c\n    }\n\n    .c-cookies-settings__buttons .c-cookies-settings__save:focus,.c-cookies-settings__buttons .c-cookies-settings__save:hover {\n        color: #45423c\n    }\n\n    .c-cookies-settings__buttons .c-cookies-settings__save {\n        display: inline-block;\n        padding: 5px 21px;\n        font-size: 14px;\n        background-color: #fff;\n        border-radius: 5px;\n        border: 1px solid #54b3d7;\n        font-weight: 600;\n        color: #54b3d7;\n        cursor: pointer\n    }\n\n    .c-cookies-settings__buttons .c-cookies-settings__save:focus,.c-cookies-settings__buttons .c-cookies-settings__save:hover {\n        color: #54b3d7\n    }\n\n    .c-cookies-settings__element_switch {\n        float: right\n    }\n\n    .c-cookies-settings__buttons .c-cookies-settings__accept {\n        display: inline-block;\n        padding: 5px 21px;\n        font-size: 14px;\n        background-color: #2cb0f2;\n        border-radius: 5px;\n        border: 1px solid #2cb0f2;\n        font-weight: 600;\n        color: #45423c;\n        cursor: pointer\n    }\n\n    .c-cookies-settings__buttons .c-cookies-settings__accept:focus,.c-cookies-settings__buttons .c-cookies-settings__accept:hover {\n        color: #45423c\n    }\n\n    .c-cookies-settings__switch {\n        position: relative;\n        display: inline-block;\n        width: 46px;\n        height: 28px\n    }\n\n    .c-cookies-settings__switch input {\n        opacity: 0;\n        width: 0;\n        height: 0\n    }\n\n    .c-cookies-settings__slider {\n        position: absolute;\n        cursor: pointer;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background-color: #ccc;\n        -webkit-transition: .4s;\n        transition: .4s\n    }\n\n    .c-cookies-settings__slider:before {\n        position: absolute;\n        content: \"\";\n        height: 20px;\n        width: 20px;\n        left: 4px;\n        bottom: 4px;\n        background-color: #fff;\n        -webkit-transition: .4s;\n        transition: .4s\n    }\n\n    .c-cookies-settings__switch input:checked+.c-cookies-settings__slider {\n        background-color: #2cb0f2\n    }\n\n    .c-cookies-settings__switch input:focus+.c-cookies-settings__slider {\n        -webkit-box-shadow: 0 0 1px #2cb0f2;\n        box-shadow: 0 0 1px #2cb0f2\n    }\n\n    .c-cookies-settings__switch input:checked+.c-cookies-settings__slider:before {\n        -webkit-transform: translateX(18px);\n        transform: translateX(18px)\n    }\n\n    .c-cookies-settings__switch input:disabled+.c-cookies-settings__slider {\n        opacity: .5;\n        cursor: default\n    }\n\n    .c-cookies-settings__slider.c-cookies-settings__slider_round {\n        border-radius: 34px\n    }\n\n    .c-cookies-settings__slider.c-cookies-settings__slider_round:before {\n        border-radius: 50%\n    }\n\n    @media (max-width: 1282px) {\n        .c-cookies-settings {\n            width:70%\n        }\n    }\n\n    @media (max-width: 998px) {\n        .c-cookies-settings {\n            width:80%\n        }\n    }\n\n    @media (max-width: 768px) {\n        .c-cookies-settings {\n            width:90%\n        }\n    }\n\n    @media (max-width: 767px) {\n        .c-cookies-settings {\n            width:100%\n        }\n\n        .c-cookies-settings__content {\n            padding: 15px 15px 0\n        }\n    }\n\n    @media (max-width: 998px) {\n        .c-cookies-settings__text {\n            display:block\n        }\n\n        .c-cookies-settings__save {\n            margin: 11.2px 14px 0\n        }\n    }\n\n    @media (min-width: 768px) {\n        .c-alert-cookie__text {\n            display:block\n        }\n\n        .c-alert-cookie__text_content+.c-alert-cookie__cta {\n            margin: 11.2px 14px 0\n        }\n    }\n\n    @media (min-width: 768px) {\n        .c-cookies-settings__text {\n            display:block\n        }\n\n        .c-cookies-settings__save {\n            margin: 11.2px 14px 0\n        }\n\n        .c-cookies-settings {\n            position: fixed;\n            top: 50%;\n            left: 50%;\n            -webkit-transform: translate(-50%,-50%);\n            transform: translate(-50%,-50%)\n        }\n    }\n\n    @media (max-width: 385px) {\n        .c-cookies-settings__save {\n            margin:0 0 14px\n        }\n\n        .c-cookies-settings__accept {\n            margin-left: 14px\n        }\n    }\n\n    html {\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n        -webkit-tap-highlight-color: rgba(0,0,0,0)\n    }\n\n    body,html {\n        height: 100%;\n        width: 100%;\n        font-size: 14px\n    }\n\n    body {\n        line-height: 1.428571429;\n        background-color: #fff;\n        margin: 0;\n        padding: 0;\n        font-family: Lato,Helvetica Neue,Arial,sans-serif\n    }\n\n    body,input,label {\n        color: #45423c;\n        font-weight: 400\n    }\n\n    ul {\n        margin: 0;\n        padding: 0\n    }\n\n    ul li {\n        list-style: none\n    }\n\n    a {\n        color: #1f708f;\n        outline: 0;\n        cursor: pointer\n    }\n\n    a:active,a:hover {\n        color: #54b3d7\n    }\n\n    button:focus {\n        outline: 0!important;\n        -webkit-box-shadow: none!important;\n        box-shadow: none!important\n    }\n\n    input[type=checkbox],input[type=radio] {\n        line-height: normal;\n        margin: 4px 5px 0 0;\n        position: relative;\n        min-height: 5px\n    }\n\n    :focus {\n        outline: transparent\n    }\n\n    select::-ms-expand {\n        width: 12px;\n        border: 0;\n        background: #fff\n    }\n\n    ::-webkit-input-placeholder {\n        color: #b2aea5;\n        opacity: 1\n    }\n\n    :-ms-input-placeholder {\n        color: #b2aea5;\n        opacity: 1\n    }\n\n    ::placeholder {\n        color: #b2aea5;\n        opacity: 1\n    }\n\n    select {\n        outline: none;\n        overflow: hidden;\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n        text-overflow: \"\"\n    }\n\n    select::-ms-expand {\n        display: none!important\n    }\n\n    h1 {\n        color: #45423c;\n        font-size: 27.34375px;\n        text-shadow: none;\n        text-align: left;\n        line-height: 1.35;\n        margin-bottom: 20px;\n        margin-top: 0\n    }\n\n    @media (min-width: 768px) {\n        h1 {\n            font-size:34.17969px\n        }\n    }\n\n    h2 {\n        color: #45423c;\n        font-size: 27.34375px;\n        margin: 0 0 30px;\n        text-align: center\n    }\n\n    h3 {\n        margin: 15px\n    }\n\n    h3,h4 {\n        color: #45423c;\n        font-size: 17.5px\n    }\n\n    h4,h5 {\n        margin-top: 5px\n    }\n\n    h5 {\n        color: #ede9e5;\n        font-size: 14px;\n        text-transform: capitalize;\n        font-weight: 400\n    }\n\n    hr {\n        border-bottom: 1px dotted #b2aea5;\n        padding: 10px 0;\n        margin-right: -15px;\n        margin-left: -15px;\n        margin-top: 0;\n        padding-top: 0;\n        clear: both\n    }\n\n    .checkbox input[type=checkbox],.radio input[type=radio] {\n        margin-left: 0;\n        position: relative\n    }\n\n    .table th {\n        background-color: #b2aea5;\n        color: #fff;\n        text-align: left;\n        text-transform: uppercase;\n        font-size: 16px;\n        padding: 5px 15px!important;\n        line-height: 16px!important\n    }\n\n    .table thead {\n        margin-bottom: 10px\n    }\n\n    .table td {\n        text-align: left;\n        padding: 5px 15px!important\n    }\n\n    .table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th {\n        border-top: 0\n    }\n\n    .table>thead>tr>th {\n        border-bottom: 10px solid #fff\n    }\n\n    .cookie-modal-window .modal-dialog {\n        z-index: 300;\n        position: fixed;\n        left: 0;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        background-color: rgba(0,0,0,.3);\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        -webkit-box-pack: center;\n        -ms-flex-pack: center;\n        justify-content: center;\n        width: 100%;\n        height: 100%;\n        overflow: auto;\n        margin: 0px;\n    }\n</style>\n\n<div class=\"st-footer\">\n    <div class=\"st-footer__text\">\n        <p>{{'copy_right' | translate:vm.values}} | {{'right_reserved' | translate}} | <a href=\"{{vm.terms_and_conditions_note_href}}\">{{'terms_conditions' | translate}}</a></p>\n    </div>\n</div>\n\n<div id=\"js-cookie-alert\" class=\"c-alert-cookie qa-alert--cookies js-collapse is-collapsed\">\n    <div class=\"c-alert-cookie__container\">\n        <div class=\"c-alert-cookie__text_content\">\n            <span class=\"c-alert-cookie__text_title\">{{'alert.message_title' | translate}}</span>\n            <span class=\"c-alert-cookie__text\" ng-bind-html=\"'alert.message' | translate:vm.values\"></span>\n        </div>\n        <a id=\"open_cookie_settings\" class=\"c-alert-cookie__cta c-alert-cookie__cta_blue\" ng-click=\"vm.cookieSettings()\" href=\"#\">{{'alert.button_settings' | translate}}</a>\n        <a class=\"c-alert-cookie__cta qa-close--cookies js-close\" href=\"#\">{{'alert.button_accept_all' | translate}}</a>\n    </div>\n</div>"

/***/ },
/* 24 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var FooterController = (function () {
	  FooterController.$inject = ["$translate", "$uibModal", "CONFIG"];
	  function FooterController($translate, $uibModal, CONFIG) {
	    'ngInject';
	
	    _classCallCheck(this, FooterController);
	
	    this.$translate = $translate;
	    this.languages = CONFIG.languages;
	    this.$uibModal = $uibModal;
	    this.name = 'footer';
	  }
	
	  _createClass(FooterController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      //TODO Use languageService
	      var language = this.languages[this.$translate.use()];
	      this.cookie_policy_note_href = 'http://www.suntransfers.com' + (language.key == 'en' ? '/' : '/' + language.key + '/') + 'terms-and-conditions#cookies_policy';
	      this.terms_and_conditions_note_href = 'http://www.suntransfers.com' + (language.key == 'en' ? '/' : '/' + language.key + '/') + 'terms-and-conditions';
	
	      this.values = {
	        link_start: '<a class="c-alert-cookie__link" href="' + this.cookie_policy_note_href + '" target="_blank">',
	        link_end: '</a>'
	      };
	    }
	  }, {
	    key: 'cookieSettings',
	    value: function cookieSettings() {
	      var modalInstance = this.$uibModal.open({
	        animation: false,
	        component: 'stCookieSettings',
	        windowClass: 'cookie-modal-window'
	      });
	
	      return modalInstance.result;
	    }
	  }]);
	
	  return FooterController;
	})();
	
	exports['default'] = FooterController;
	module.exports = exports['default'];

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _stCookieSettingsComponent = __webpack_require__(26);
	
	var _stCookieSettingsComponent2 = _interopRequireDefault(_stCookieSettingsComponent);
	
	var stCookieSettingsModule = _angular2['default'].module('stCookieSettings', [_angularUiRouter2['default']]).component('stCookieSettings', _stCookieSettingsComponent2['default']).name;
	
	exports['default'] = stCookieSettingsModule;
	module.exports = exports['default'];

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _stCookieSettingsHtml = __webpack_require__(27);
	
	var _stCookieSettingsHtml2 = _interopRequireDefault(_stCookieSettingsHtml);
	
	var _stCookieSettingsController = __webpack_require__(28);
	
	var _stCookieSettingsController2 = _interopRequireDefault(_stCookieSettingsController);
	
	var stCookieSettingsComponent = {
	    restrict: 'E',
	    bindings: {
	        resolve: '<',
	        close: '&',
	        dismiss: '&'
	    },
	    template: _stCookieSettingsHtml2['default'],
	    controller: _stCookieSettingsController2['default'],
	    controllerAs: 'vm'
	};
	
	exports['default'] = stCookieSettingsComponent;
	module.exports = exports['default'];

/***/ },
/* 27 */
/***/ function(module, exports) {

	module.exports = "<section id=\"cookie_settings_modal\" class=\"c-cookies-settings-overlay\">\n    <div class=\"c-cookies-settings\">\n        <div class=\"c-cookies-settings__container\">\n            <div class=\"c-cookies-settings__headline\">\n                <h3 class=\"c-cookies-settings__title\">{{ 'alert.settings_title' | translate }}</h3>\n                <div class=\"c-cookies-settings__text\" ng-bind-html=\"'alert.settings_description' | translate:vm.values\"></div>\n            </div>\n            <div class=\"c-cookies-settings__content\">\n                <div class=\"c-cookies-settings__element\">\n                    <h4 class=\"c-cookies-settings__element_title\">{{ 'alert.settings_essential_title' | translate }}</h4>\n                    <div class=\"c-cookies-settings__element_content\">\n                        <div class=\"c-cookies-settings__element_switch\">\n                            <label class=\"c-cookies-settings__switch\">\n                                <input type=\"checkbox\" name=\"settings_essential\" disabled=\"\" value=\"on\" checked>\n                                <span class=\"c-cookies-settings__slider c-cookies-settings__slider_round\"></span>\n                            </label>\n                        </div>\n                        <div class=\"c-cookies-settings__element_text\">{{ 'alert.settings_essential_description' | translate }}</div>\n                    </div>\n                </div>\n                <div class=\"c-cookies-settings__element\">\n                    <h4 class=\"c-cookies-settings__element_title\">{{ 'alert.settings_performance_title' | translate }}</h4>\n                    <div class=\"c-cookies-settings__element_content\">\n                        <div class=\"c-cookies-settings__element_switch\">\n                            <label class=\"c-cookies-settings__switch\">\n                                <input type=\"checkbox\" name=\"settings_performance\" value=\"on\" checked>\n                                <span class=\"c-cookies-settings__slider c-cookies-settings__slider_round\"></span>\n                            </label>\n                        </div>\n                        <div class=\"c-cookies-settings__element_text\">{{ 'alert.settings_performance_description' | translate }}</div>\n                    </div>\n                </div>\n                <div class=\"c-cookies-settings__element\">\n                    <h4 class=\"c-cookies-settings__element_title\">{{ 'alert.settings_marketing_title' | translate }}</h4>\n                    <div class=\"c-cookies-settings__element_content\">\n                        <div class=\"c-cookies-settings__element_switch\">\n                            <label class=\"c-cookies-settings__switch\">\n                                <input type=\"checkbox\" name=\"settings_marketing\" value=\"on\" checked>\n                                <span class=\"c-cookies-settings__slider c-cookies-settings__slider_round\"></span>\n                            </label>\n                        </div>\n                        <div class=\"c-cookies-settings__element_text\">{{ 'alert.settings_marketing_description' | translate }}</div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"c-cookies-settings__buttons\">\n                <button class=\"c-cookies-settings__save\" ng-click=\"vm.save()\">{{ 'alert.settings_button_save' | translate }}</button>\n                <button class=\"c-cookies-settings__accept\" ng-click=\"vm.allowAll()\">{{ 'alert.settings_button_accept' | translate }}</button>\n            </div>\n        </div>\n    </div>\n</section>"

/***/ },
/* 28 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var StCookieSettingsController = (function () {
	    StCookieSettingsController.$inject = ["$translate", "cookiesConsent", "CONFIG"];
	    function StCookieSettingsController($translate, cookiesConsent, CONFIG) {
	        'ngInject';
	
	        _classCallCheck(this, StCookieSettingsController);
	
	        this.$translate = $translate;
	        this.languages = CONFIG.languages;
	        this.CookiesConsent = cookiesConsent;
	        this.name = 'stCookieSettings';
	    }
	
	    _createClass(StCookieSettingsController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var language = this.languages[this.$translate.use()];
	            this.cookie_policy_note_href = 'http://www.suntransfers.com' + (language.key == 'en' ? '/' : '/' + language.key + '/') + 'terms-and-conditions#cookies_policy';
	
	            this.values = {
	                link_start: '<a href="' + this.cookie_policy_note_href + '" target="_blank">',
	                link_end: '</a>'
	            };
	        }
	    }, {
	        key: 'allowAll',
	        value: function allowAll() {
	            this.CookiesConsent.setCookie('{"performance":true,"targeting":true}');
	            this.closeCookie();
	        }
	    }, {
	        key: 'save',
	        value: function save() {
	            this.CookiesConsent.setCookie('{"performance":' + document.getElementsByName('settings_performance')[0].checked + ',"targeting":' + document.getElementsByName('settings_marketing')[0].checked + ' }');
	            this.closeCookie();
	        }
	    }, {
	        key: 'closeCookie',
	        value: function closeCookie() {
	            document.getElementById('js-cookie-alert').classList.add('is-collapsed');
	            this.close();
	        }
	    }]);
	
	    return StCookieSettingsController;
	})();
	
	exports['default'] = StCookieSettingsController;
	module.exports = exports['default'];

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _userFactory = __webpack_require__(30);
	
	var _userFactory2 = _interopRequireDefault(_userFactory);
	
	var userModule = _angular2['default'].module('user', []).factory('User', _userFactory2['default']).name;
	
	exports['default'] = userModule;
	module.exports = exports['default'];

/***/ },
/* 30 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var UserFactory = function UserFactory() {
	  var user = {};
	
	  var getUser = function getUser() {
	    return user;
	  };
	
	  var isSignedIn = function isSignedIn() {
	    return user.isSignedIn;
	  };
	
	  return { getUser: getUser, isSignedIn: isSignedIn };
	};
	
	exports["default"] = UserFactory;
	module.exports = exports["default"];

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _languageSelectorDirective = __webpack_require__(32);
	
	var _languageSelectorDirective2 = _interopRequireDefault(_languageSelectorDirective);
	
	var languageSelectorModule = _angular2['default'].module('languageSelector', [_angularUiRouter2['default']]).directive('stLangSelector', _languageSelectorDirective2['default']).name;
	
	exports['default'] = languageSelectorModule;
	module.exports = exports['default'];

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _languageSelectorHtml = __webpack_require__(33);
	
	var _languageSelectorHtml2 = _interopRequireDefault(_languageSelectorHtml);
	
	var _languageSelectorController = __webpack_require__(34);
	
	var _languageSelectorController2 = _interopRequireDefault(_languageSelectorController);
	
	function languageSelectorDirective() {
	    return {
	        restrict: 'AEC',
	        replace: true,
	        scope: {},
	        template: _languageSelectorHtml2['default'],
	        controller: _languageSelectorController2['default'],
	        controllerAs: 'vm',
	        link: function link(scope) {
	            scope.name = 'langSelector';
	        }
	    };
	}
	exports['default'] = languageSelectorDirective;
	module.exports = exports['default'];

/***/ },
/* 33 */
/***/ function(module, exports) {

	module.exports = "<li uib-dropdown on-toggle=\"vm.toggled(open)\" class=\"st-navbar__menu__item\">\n\n    <a uib-dropdown-toggle class=\"st-navbar__menu__link\" href=\"#\">{{vm.language.key}}<span class=\"st-icon-chevron-down  st-icon-chevron-down-sm-button\"></span></a>\n    <ul uib-dropdown-menu class=\"st-navbar__dropdown\">\n        <li ng-repeat=\"(key, language) in vm.languages\">\n            <a href ng-click=\"vm.fetchLanguage(key)\"> {{language.label}} </a>\n        </li>\n    </ul>\n</li>"

/***/ },
/* 34 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var LanguageSelectorController = (function () {
	
	    // TODO: CONSTANTS
	    // static const SUFIX = '-label';
	
	    LanguageSelectorController.$inject = ["$translate", "$state", "CONFIG"];
	    function LanguageSelectorController($translate, $state, CONFIG) {
	        'ngInject';
	
	        _classCallCheck(this, LanguageSelectorController);
	
	        this.name = 'languageSelector';
	        this.$translate = $translate;
	        this.$state = $state;
	        this.languages = CONFIG.languages;
	    }
	
	    _createClass(LanguageSelectorController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            var currentLanguage = this.$translate.proposedLanguage() || this.$translate.use();
	            this.$translate.onReady().then(function () {
	                _this.setLanguage(currentLanguage);
	            });
	        }
	    }, {
	        key: 'fetchLanguage',
	        value: function fetchLanguage(lang) {
	            var _this2 = this;
	
	            this.$translate.use(lang).then(function () {
	                _this2.setLanguage(lang);
	                _this2.$state.reload();
	            });
	        }
	    }, {
	        key: 'setLanguage',
	        value: function setLanguage(lang) {
	            this.language = this.languages[lang];
	        }
	    }]);
	
	    return LanguageSelectorController;
	})();
	
	exports['default'] = LanguageSelectorController;
	module.exports = exports['default'];

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	// TODO: rename module
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _stSelectComponent = __webpack_require__(36);
	
	var _stSelectComponent2 = _interopRequireDefault(_stSelectComponent);
	
	var stSelectModule = _angular2['default'].module('stSelect', [_angularUiRouter2['default']]).component('stSelect', _stSelectComponent2['default']).name;
	
	exports['default'] = stSelectModule;
	module.exports = exports['default'];

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _stSelectHtml = __webpack_require__(37);
	
	var _stSelectHtml2 = _interopRequireDefault(_stSelectHtml);
	
	var _stSelectController = __webpack_require__(38);
	
	var _stSelectController2 = _interopRequireDefault(_stSelectController);
	
	var stSelectComponent = {
	  restrict: 'E',
	  bindings: {
	    items: '=',
	    getTransfers: '&'
	  },
	  template: _stSelectHtml2['default'],
	  controller: _stSelectController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = stSelectComponent;
	module.exports = exports['default'];

/***/ },
/* 37 */
/***/ function(module, exports) {

	module.exports = "<div class=\"{{ vm.name }}\">\n  <div class=\"btn-group\" uib-dropdown is-open=\"status.isopen\">\n   <button id=\"single-button\" type=\"button\" class=\"btn btn-link\" uib-dropdown-toggle ng-disabled=\"disabled\">\n   {{vm.dropText | translate}}<span class=\"st-icon-chevron-down st-icon-chevron-down-sm-button\"></span>\n   </button>\n   <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\">\n      <li ng-repeat=\"item in vm.items\">\n          <a href=\"\" ng-click=\"vm.toggleDropdown(item)\">{{item.name | translate}}</a>\n      </li>\n   </ul>\n </div>\n</div>\n"

/***/ },
/* 38 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var StSelectController = (function () {
	    StSelectController.$inject = ["$translate"];
	    function StSelectController($translate) {
	        'ngInject';
	        // TODO: tranlations
	
	        _classCallCheck(this, StSelectController);
	
	        this.$translate = $translate;
	        this.name = 'stSelect';
	        // this.transfersTableService = transfersTableService;
	        this.dropText = this.$translate.instant(this.items[0].name);
	    }
	
	    _createClass(StSelectController, [{
	        key: 'toggleDropdown',
	        value: function toggleDropdown(item) {
	            this.getTransfers({
	                gateway: item.id
	            });
	            this.dropText = this.$translate.instant(item.name);
	        }
	    }]);
	
	    return StSelectController;
	})();
	
	exports['default'] = StSelectController;
	module.exports = exports['default'];

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	// TODO: rename module
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _stSelectFilterComponent = __webpack_require__(40);
	
	var _stSelectFilterComponent2 = _interopRequireDefault(_stSelectFilterComponent);
	
	var stSelectFilterModule = _angular2['default'].module('stSelectFilter', [_angularUiRouter2['default']]).component('stSelectFilter', _stSelectFilterComponent2['default']).name;
	
	exports['default'] = stSelectFilterModule;
	module.exports = exports['default'];

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _stSelectFilterHtml = __webpack_require__(41);
	
	var _stSelectFilterHtml2 = _interopRequireDefault(_stSelectFilterHtml);
	
	var _stSelectFilterController = __webpack_require__(42);
	
	var _stSelectFilterController2 = _interopRequireDefault(_stSelectFilterController);
	
	var stSelectFilterComponent = {
	  restrict: 'E',
	  bindings: {
	    filter: '=',
	    items: '='
	  },
	  template: _stSelectFilterHtml2['default'],
	  controller: _stSelectFilterController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = stSelectFilterComponent;
	module.exports = exports['default'];

/***/ },
/* 41 */
/***/ function(module, exports) {

	module.exports = "<div class=\"{{ vm.name }}\">\n  <div class=\"btn-group\" uib-dropdown is-open=\"status.isopen\">\n   <button id=\"single-button\" type=\"button\" class=\"btn btn-link\" uib-dropdown-toggle ng-disabled=\"disabled\">\n   {{vm.dropText | translate}}<span class=\"st-icon-chevron-down st-icon-chevron-down-sm-button\"></span>\n   </button>\n   <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\">\n      <li ng-repeat=\"item in vm.items\">\n        <a href=\"\" ng-click=\"vm.toggleFilter(item, filter)\" >{{item.name | translate}}</a>\n      </li>\n   </ul>\n </div>\n</div>\n"

/***/ },
/* 42 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var StSelectFilterController = (function () {
	  StSelectFilterController.$inject = ["$translate"];
	  function StSelectFilterController($translate) {
	    'ngInject';
	
	    _classCallCheck(this, StSelectFilterController);
	
	    this.$translate = $translate;
	    this.name = 'stSelect';
	    this.dropText = this.$translate.instant(this.items[0].name);
	  }
	
	  _createClass(StSelectFilterController, [{
	    key: 'toggleFilter',
	    value: function toggleFilter(item) {
	      this.dropText = this.$translate.instant(item.name);
	      this.filter = item.filter;
	    }
	  }]);
	
	  return StSelectFilterController;
	})();
	
	exports['default'] = StSelectFilterController;
	module.exports = exports['default'];

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _stBrowserAlertsComponent = __webpack_require__(44);
	
	var _stBrowserAlertsComponent2 = _interopRequireDefault(_stBrowserAlertsComponent);
	
	var stBrowserAlertsModule = _angular2['default'].module('stBrowserAlerts', [_angularUiRouter2['default']]).component('stBrowserAlerts', _stBrowserAlertsComponent2['default']).name;
	
	exports['default'] = stBrowserAlertsModule;
	module.exports = exports['default'];

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _stBrowserAlertsHtml = __webpack_require__(45);
	
	var _stBrowserAlertsHtml2 = _interopRequireDefault(_stBrowserAlertsHtml);
	
	var _stBrowserAlertsController = __webpack_require__(46);
	
	var _stBrowserAlertsController2 = _interopRequireDefault(_stBrowserAlertsController);
	
	var stBrowserAlertsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _stBrowserAlertsHtml2['default'],
	  controller: _stBrowserAlertsController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = stBrowserAlertsComponent;
	module.exports = exports['default'];

/***/ },
/* 45 */
/***/ function(module, exports) {

	module.exports = "<div class=\"{{ vm.name }}\">\n<!--[if lt IE 10]>\n<div class=\"st-disclaimer\" role=\"alert\" type=\"info\">\n   <span class=\"st-disclaimer__text\">  \n       {{ 'user_outdated_browser' | translate}}\n       {{ 'browser_upgrade_recommended' | translate}}\n    </span>\n</div>\n<![endif]-->\n</div>\n"

/***/ },
/* 46 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var StBrowserAlertsController = (function () {
	  function StBrowserAlertsController() {
	    'ngInject';
	
	    _classCallCheck(this, StBrowserAlertsController);
	
	    this.name = 'stBrowserAlerts';
	  }
	
	  _createClass(StBrowserAlertsController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }]);
	
	  return StBrowserAlertsController;
	})();
	
	exports['default'] = StBrowserAlertsController;
	module.exports = exports['default'];

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularOauth2 = __webpack_require__(48);
	
	var _angularOauth22 = _interopRequireDefault(_angularOauth2);
	
	var _configConfig = __webpack_require__(16);
	
	var _configConfig2 = _interopRequireDefault(_configConfig);
	
	var _authConfig = __webpack_require__(54);
	
	var _authConfig2 = _interopRequireDefault(_authConfig);
	
	var _authRun = __webpack_require__(55);
	
	var _authRun2 = _interopRequireDefault(_authRun);
	
	var _authService = __webpack_require__(56);
	
	var _authService2 = _interopRequireDefault(_authService);
	
	var _authInterceptor = __webpack_require__(58);
	
	var _authInterceptor2 = _interopRequireDefault(_authInterceptor);
	
	var _servicesCacheService = __webpack_require__(15);
	
	var _servicesCacheService2 = _interopRequireDefault(_servicesCacheService);
	
	var authModule = _angular2['default'].module('authService', [_angularUiRouter2['default'], _angularOauth22['default'].name, _configConfig2['default'], _servicesCacheService2['default']]).config(_authConfig2['default']).config(["$httpProvider", function ($httpProvider) {
	    'ngInject';
	    $httpProvider.interceptors.push('authInterceptor');
	}]).factory('authInterceptor', _authInterceptor2['default']).run(_authRun2['default']).service('authService', _authService2['default']).name;
	
	exports['default'] = authModule;
	module.exports = exports['default'];

/***/ },
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ function(module, exports) {

	'use strict';
	
	authConfig.$inject = ["OAuthProvider", "OAuthTokenProvider", "CONFIG"];
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	function authConfig(OAuthProvider, OAuthTokenProvider, CONFIG) {
	    'ngInject';
	    OAuthProvider.configure(CONFIG.oauth);
	
	    OAuthTokenProvider.configure({
	        name: 'token',
	        options: {
	            secure: CONFIG.oauth.cookieSecure === 'true'
	        }
	    });
	}
	
	exports['default'] = authConfig;
	module.exports = exports['default'];

/***/ },
/* 55 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var authRun = function authRun($rootScope, $state, $window, OAuth, OAuthToken, sharedService, cacheService) {
	    "ngInject";
	
	    $rootScope.$on('oauth:error', function (event, rejection) {
	
	        // Ignore `invalid_grant` error - should be catched on `LoginController`.
	        if ('invalid_grant' === rejection.data.error && 400 === rejection.status && ($state.is('auth.login') || $state.is('onTheBeach.login'))) {
	            return;
	        }
	
	        // Refresh token on any 401 (expired JWT).
	        // The backend returns {"code":401,"message":"Unauthorized"} — not the OAuth2
	        // {"error":"invalid_token"} format — so we match on status code.
	        if (401 === rejection.status) {
	            if (sharedService.refreshingToken) {
	                return;
	            }
	            sharedService.refreshingToken = true;
	            return OAuth.getRefreshToken().then(function () {
	                sharedService.refreshingToken = false;
	                $state.reload('home');
	            }, function () {
	                sharedService.refreshingToken = false;
	                OAuthToken.removeToken();
	                var currentState = $state.current.name;
	                var targetState = currentState.includes('onTheBeach') ? 'onTheBeach.login' : 'auth.login';
	                $state.go(targetState);
	            });
	        }
	
	        // Redirect to the same login page with the `error_reason`.
	        var currentState = $state.current.name;
	        var targetState = currentState.includes('onTheBeach') ? 'onTheBeach.login' : 'auth.login';
	        $state.go(targetState, {
	            'error_reason': rejection.data.error
	        });
	        event.preventDefault();
	    });
	
	    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
	
	        var unauthenticatedStates = ['auth.login', 'onTheBeach.login', 'old_goldupgrade', 'tab_name'];
	        var onTheBeachBooking = cacheService.get('onTheBeachBooking') === true;
	        var bookingReference = cacheService.get('bookingReference');
	        var agencyBookingReference = cacheService.get('agencyBookingReference');
	
	        if (OAuth.isAuthenticated()) {
	            if (toState.name === 'onTheBeach.login') {
	                if (onTheBeachBooking && agencyBookingReference) {
	                    var language = toParams.locale || fromParams.locale;
	                    $state.go('onTheBeach.booking.view', { locale: language });
	                    event.preventDefault();
	                }
	            } else if (toState.name === 'auth.login') {
	                if (!onTheBeachBooking && bookingReference) {
	                    var language = toParams.locale || fromParams.locale;
	                    $state.go('bookings.booking.view', { locale: language, bookingReference: bookingReference });
	                    event.preventDefault();
	                }
	            }
	        } else {
	            // User isn't authenticated
	            if (toState.name === 'tab_name' && toParams.tab === undefined) {
	                $state.go('auth.login');
	                event.preventDefault();
	            } else if (unauthenticatedStates.indexOf(toState.name) === -1) {
	                var area = toState.name.startsWith('onTheBeach') ? 'onTheBeach' : 'auth';
	                $state.go(area + '.login');
	                event.preventDefault();
	            }
	        }
	    });
	};
	authRun.$inject = ["$rootScope", "$state", "$window", "OAuth", "OAuthToken", "sharedService", "cacheService"];
	
	exports['default'] = authRun;
	module.exports = exports['default'];

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _onTheBeachAgencyIds = __webpack_require__(57);
	
	var _onTheBeachAgencyIds2 = _interopRequireDefault(_onTheBeachAgencyIds);
	
	var AuthService = (function () {
	    AuthService.$inject = ["$state", "$q", "cacheService", "OAuth", "OAuthToken"];
	    function AuthService($state, $q, cacheService, OAuth, OAuthToken) {
	        'ngInject';
	
	        _classCallCheck(this, AuthService);
	
	        this.$state = $state;
	        this.$q = $q;
	        this.OAuth = OAuth;
	        this.OAuthToken = OAuthToken;
	        this.authenticated = this.OAuth.isAuthenticated();
	        this.cacheService = cacheService;
	    }
	
	    _createClass(AuthService, [{
	        key: 'loginByBookingReferenceAndCustomerEmail',
	        value: function loginByBookingReferenceAndCustomerEmail(reference, email) {
	            return this._authenticate({
	                reference: reference,
	                email: email
	            });
	        }
	    }, {
	        key: 'loginByAgencyBookingReferenceAndCustomerSurname',
	        value: function loginByAgencyBookingReferenceAndCustomerSurname(agencyBookingReference, customerSurname) {
	            return this._authenticate({
	                agency_reference: agencyBookingReference,
	                surname: customerSurname,
	                'agency_id[]': _onTheBeachAgencyIds2['default']
	            });
	        }
	    }, {
	        key: '_authenticate',
	        value: function _authenticate(credentials) {
	            var _this = this;
	
	            return this.OAuth.getAccessToken(credentials).then(function (response) {
	                _this.authenticated = true;
	                return response;
	            });
	        }
	    }, {
	        key: 'logout',
	        value: function logout() {
	            this.clearSession();
	            return this.$q.when();
	        }
	    }, {
	        key: 'clearSession',
	        value: function clearSession() {
	            this.OAuthToken.removeToken();
	            this.cacheService.clear();
	            this.authenticated = false;
	        }
	    }, {
	        key: 'getAccessToken',
	        value: function getAccessToken() {
	            return this.OAuthToken.getAccessToken();
	        }
	    }]);
	
	    return AuthService;
	})();
	
	exports['default'] = AuthService;
	module.exports = exports['default'];

/***/ },
/* 57 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var ON_THE_BEACH_AGENCY_IDS = ['21608', '21610', '21611'];
	
	exports['default'] = ON_THE_BEACH_AGENCY_IDS;
	module.exports = exports['default'];

/***/ },
/* 58 */
/***/ function(module, exports) {

	/**
	 * OAuth interceptor.
	 */
	
	'use strict';
	
	authInterceptor.$inject = ["$q", "$rootScope", "OAuthToken", "CONFIG"];
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	function authInterceptor($q, $rootScope, OAuthToken, CONFIG) {
	    'ngInject';
	    return {
	        request: function request(config) {
	            config.headers = config.headers || {};
	
	            var avoidToken = CONFIG.nonAuthenticatedUrl.some(function (item) {
	                return config.url.indexOf(item) !== -1;
	            });
	
	            // Remove `Authorization` header.
	            if (config.headers.hasOwnProperty('Authorization') && avoidToken) {
	                delete config.headers.Authorization;
	            }
	
	            return config;
	        }
	    };
	}
	
	/**
	 * Export `oauthInterceptor`.
	 */
	
	exports['default'] = authInterceptor;
	module.exports = exports['default'];

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _loaderComponent = __webpack_require__(60);
	
	var _loaderComponent2 = _interopRequireDefault(_loaderComponent);
	
	var loaderModule = _angular2['default'].module('loader', []).component('loader', _loaderComponent2['default']).name;
	
	exports['default'] = loaderModule;
	module.exports = exports['default'];

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _loaderHtml = __webpack_require__(61);
	
	var _loaderHtml2 = _interopRequireDefault(_loaderHtml);
	
	var _loaderController = __webpack_require__(62);
	
	var _loaderController2 = _interopRequireDefault(_loaderController);
	
	var loaderComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _loaderHtml2['default'],
	  controller: _loaderController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = loaderComponent;
	module.exports = exports['default'];

/***/ },
/* 61 */
/***/ function(module, exports) {

	module.exports = "<div class=\"loader\"></div>\n"

/***/ },
/* 62 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var LoaderController = function LoaderController() {
	    'ngInject';
	
	    _classCallCheck(this, LoaderController);
	
	    this.name = 'loader';
	};
	
	exports['default'] = LoaderController;
	module.exports = exports['default'];

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _stGlobalPreloaderComponent = __webpack_require__(64);
	
	var _stGlobalPreloaderComponent2 = _interopRequireDefault(_stGlobalPreloaderComponent);
	
	var _servicesSharedService = __webpack_require__(67);
	
	var _servicesSharedService2 = _interopRequireDefault(_servicesSharedService);
	
	var stGlobalPreloaderModule = _angular2['default'].module('stGlobalPreloader', [_servicesSharedService2['default']]).component('stGlobalPreloader', _stGlobalPreloaderComponent2['default']).name;
	
	exports['default'] = stGlobalPreloaderModule;
	module.exports = exports['default'];

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _stGlobalPreloaderHtml = __webpack_require__(65);
	
	var _stGlobalPreloaderHtml2 = _interopRequireDefault(_stGlobalPreloaderHtml);
	
	var _stGlobalPreloaderController = __webpack_require__(66);
	
	var _stGlobalPreloaderController2 = _interopRequireDefault(_stGlobalPreloaderController);
	
	var stGlobalPreloaderComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _stGlobalPreloaderHtml2['default'],
	  controller: _stGlobalPreloaderController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = stGlobalPreloaderComponent;
	module.exports = exports['default'];

/***/ },
/* 65 */
/***/ function(module, exports) {

	module.exports = "<div class=\"{{ vm.name }}\"\n    ng-if=\"vm.loader.loadingCount > 0\"\n    style=\"position: fixed; \n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 999;\n    background-color: rgba(255,255,255,0.5);\n    pointer-events: none; \n    display: flex;\n    align-items: center;\n    justify-content: center;\"> \n      <div class=\"spinner\"></div>\n</div>\n\n"

/***/ },
/* 66 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var StGlobalPreloaderController = function StGlobalPreloaderController(sharedService) {
	  'ngInject';
	
	  _classCallCheck(this, StGlobalPreloaderController);
	
	  this.name = 'stGlobalPreloader';
	  this.loader = sharedService.loader;
	};
	StGlobalPreloaderController.$inject = ["sharedService"];
	
	exports['default'] = StGlobalPreloaderController;
	module.exports = exports['default'];

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var SharedService = function SharedService() {
	    'ngInject';
	
	    _classCallCheck(this, SharedService);
	
	    this.refreshingToken = false;
	    this.loader = {
	        visible: false
	    };
	};
	
	var sharedServiceModule = _angular2['default'].module('st.services.shared', []).service('sharedService', SharedService).name;
	
	exports['default'] = sharedServiceModule;
	module.exports = exports['default'];

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _stLocationComponent = __webpack_require__(69);
	
	var _stLocationComponent2 = _interopRequireDefault(_stLocationComponent);
	
	var _angularTranslate = __webpack_require__(6);
	
	var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	
	var _apiLocationsLocations = __webpack_require__(73);
	
	var _apiLocationsLocations2 = _interopRequireDefault(_apiLocationsLocations);
	
	var stLocationModule = _angular2['default'].module('stLocation', [_angularTranslate2['default'], _apiLocationsLocations2['default']]).component('stLocation', _stLocationComponent2['default']).name;
	
	exports['default'] = stLocationModule;
	module.exports = exports['default'];

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _stLocationController = __webpack_require__(70);
	
	var _stLocationController2 = _interopRequireDefault(_stLocationController);
	
	var _stLocationHtml = __webpack_require__(71);
	
	var _stLocationHtml2 = _interopRequireDefault(_stLocationHtml);
	
	var _stLocationViewHtml = __webpack_require__(72);
	
	var _stLocationViewHtml2 = _interopRequireDefault(_stLocationViewHtml);
	
	var stLocationComponent = {
	    restrict: 'E',
	    bindings: {
	        transfer: '=',
	        type: '@',
	        direction: '@'
	    },
	    template: ["$element", "$attrs", function template($element, $attrs) {
	        'ngInject';
	        return $attrs.editable == "true" ? _stLocationHtml2['default'] : _stLocationViewHtml2['default'];
	    }],
	    controller: _stLocationController2['default'],
	    controllerAs: 'vm'
	};
	
	exports['default'] = stLocationComponent;
	module.exports = exports['default'];

/***/ },
/* 70 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var StLocationController = (function () {
	    StLocationController.$inject = ["$translate", "locationsService", "DATE_FORMAT"];
	    function StLocationController($translate, locationsService, DATE_FORMAT) {
	        'ngInject';
	
	        _classCallCheck(this, StLocationController);
	
	        this.name = 'stLocation';
	        this.$translate = $translate;
	        this.TYPE_AIRPORT = 'airport';
	        this.TYPE_HOTEL = 'hotel';
	        this.TYPE_SEAPORT = 'sea_port';
	        this.TYPE_TRAINSTATION = 'train_station';
	        this.TYPE_ACCOMODATION = 'accommodation';
	        this.DATE_FORMAT = DATE_FORMAT;
	        this.locationsService = locationsService;
	        this.hotels = [];
	    }
	
	    _createClass(StLocationController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.transferData = this.transfer[this.direction].data;
	            this.type = this.transfer[this.direction].type;
	
	            if (this.type == this.TYPE_ACCOMODATION) {
	                if (this.transferData.address1) {
	                    var address2 = "";
	                    var address3 = "";
	
	                    if (this.transferData.address2) {
	                        address2 = "\n" + this.transferData.address2;
	                        this.transferData.address2 = '';
	                    }
	                    if (this.transferData.address3) {
	                        address3 = "\n" + this.transferData.address3;
	                        this.transferData.address3 = '';
	                    }
	
	                    this.transferData.address1 = this.transferData.address1.concat(address2, address3);
	                }
	            }
	
	            this.transferData.airline = this.transferData.airline === 'NOT_PROVIDED' && this.isDirectionFrom() ? '' : this.transferData.airline;
	            this.transferData.origin_airport = this.transferData.origin_airport === 'NOT_PROVIDED' ? '' : this.transferData.origin_airport;
	            this.transferData.flight_number = this.transferData.flight_number === 'NOT_PROVIDED' ? '' : this.transferData.flight_number;
	
	            //airport && from
	            this.isFromAndAirport = this.type == this.TYPE_AIRPORT && this.isDirectionFrom();
	
	            this.translations = this.$translate.instant(["outward_airline", "flight_num", "flight_origin", "yes", "no", "inform_later", "arr_date", "flight_dept", "ship_arrival_date", "ship_departure_time", "gateway_cruiseline", "gateway_cruise_terminal", "gateway_ship_name", "gateway_train", "train_arrival_date", "train_departure_date", "out_accom", "outward_acc", "outward_acc3", "trans_from", "trans_to", "hotel_pickup", "hotel_dest", "departure_pickup", "your_pickup_time", "pickup_date", "share_email_from", "share_email_to:", "departure_pickup", "hotel_placeholder"]);
	
	            this.translations["transfer_sub_title"] = this.isDirectionFrom() ? this.translations.trans_from : this.translations.trans_to;
	            this.translations["hotel_title"] = this.isDirectionFrom() ? this.translations.hotel_pickup : this.translations.hotel_dest;
	            this.translations['transfer_label'] = this.isDirectionFrom() ? this.translations.share_email_from : this.translations['share_email_to:'];
	            this.translations['fligth_datetime_label'] = this.isDirectionFrom() ? this.translations.arr_date : this.translations.flight_dept;
	            this.translations['train_datetime_label'] = this.isDirectionFrom() ? this.translations.train_arrival_date : this.translations.train_departure_date;
	            this.translations['ship_datetime_label'] = this.isDirectionFrom() ? this.translations.ship_arrival_date : this.translations.ship_dept;
	
	            this.getHotels();
	        }
	
	        //TODO: Improve
	    }, {
	        key: 'isDirectionFrom',
	        value: function isDirectionFrom() {
	            return this.direction == "from";
	        }
	    }, {
	        key: 'isDirectionTo',
	        value: function isDirectionTo() {
	            return !this.isDirectionFrom();
	        }
	    }, {
	        key: 'getHotels',
	        value: function getHotels() {
	            var _this = this;
	
	            if (this.type !== this.TYPE_HOTEL) {
	                return;
	            }
	            this.hotel = this.transferData.name;
	            this.locationsService.getHotels(this.transferData.location_id).then(function (response) {
	                _this.hotels = response;
	            });
	        }
	    }, {
	        key: 'onSelectHotel',
	        value: function onSelectHotel($item, $model, $label, $event) {
	            this.transferData.id = $item.id;
	            this.transferData.name = $item.name;
	        }
	    }, {
	        key: 'onBlurHotel',
	        value: function onBlurHotel() {
	            if (angular.isString(this.hotel) && this.hotel != this.transferData.name) {
	                this.hotel = this.transferData.name;
	            }
	        }
	    }]);
	
	    return StLocationController;
	})();
	
	exports['default'] = StLocationController;
	module.exports = exports['default'];

/***/ },
/* 71 */
/***/ function(module, exports) {

	module.exports = "<ng-form name=\"amendForm\">\n<!-- TODO: component for each type -->\n<!-- TYPE TRAIN STATION -->\n    <div class=\"st-form__list__section\" ng-if=\"vm.type == vm.TYPE_TRAINSTATION\">\n        <div class=\"st-form__item\">\n            <h4 class=\"st-form__sub-title\"> {{vm.translations.transfer_sub_title}} </h4>\n            <input type=\"text\" class=\"st-form__input--disabled\" ng-value=\"vm.transferData.location_name\" disabled=\"disabled\">\n        </div>\n        <div class=\"st-form__item\">\n            <div class=\"st-form__list-group\">\n                <div class=\"st-form__list--airline\">\n                    <span class=\"st-form__label--required\"> {{vm.translations.gateway_train}}</span>\n                    <input type=\"text\"\n                           class=\"st-form__input\"\n                           name=\"train_number\"\n                           ng-model=\"vm.transferData.train_number\"\n                           ng-class=\"amendForm.train_number.$valid ? 'st-form__input' : 'st-form__input--error'\"\n                           required>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"st-form__item\">\n            <span class=\"st-form__label--required\">{{vm.translations.train_datetime_label}}</span>\n            <!-- @ST-COMPONENT -->\n            <st-date-time-picker date=\"vm.transferData.train_datetime\"\n                                 min-date=\"vm.transferData.train_datetime\"\n                                 max-date=\"vm.isDirectionFrom() ? vm.transfer.latest_pickup_time : angular.noop\" />\n        </div>\n\n    </div>\n<!-- END TYPE TRAIN STATION -->\n\n<!-- TYPE SEAPORT -->\n    <div class=\"st-form__list__section\" ng-if=\"vm.type == vm.TYPE_SEAPORT\">\n        <div class=\"st-form__item\">\n            <h4 class=\"st-form__sub-title\"> {{vm.translations.transfer_sub_title}} </h4>\n            <input type=\"text\" class=\"st-form__input--disabled\" ng-value=\"vm.transferData.location_name\" disabled=\"disabled\">\n        </div>\n        <div class=\"st-form__item\">\n            <div class=\"st-form__list-group\">\n                <div class=\"st-form__list--airline\">\n                    <span class=\"st-form__label--required\">{{vm.translations.gateway_cruiseline}} </span>\n                    <input type=\"text\"\n                           class=\"st-form__input\"\n                           name=\"cruise_line\"\n                           ng-model=\"vm.transferData.cruise_line\"\n                           ng-class=\"amendForm.cruise_line.$valid ? 'st-form__input' : 'st-form__input--error'\"\n                           required>\n                </div>\n                <div class=\"st-form__list--flight-number\">\n                    <span class=\"st-form__label--required\">{{vm.translations.gateway_ship_name}}</span>\n                    <input type=\"text\"\n                           name=\"ship_name\"\n                           class=\"st-form__input\"\n                           ng-model=\"vm.transferData.ship_name\"\n                           ng-class=\"amendForm.ship_name.$valid ? 'st-form__input' : 'st-form__input--error'\"\n                           required>\n                </div>\n            </div>\n        </div>\n        <div class=\"st-form__item\" ng-if=\"vm.isDirectionFrom()\">\n            <span class=\"st-form__label\">{{vm.translations.gateway_cruise_terminal}}</span>\n            <input type=\"text\"\n                   class=\"st-form__input\"\n                   name=\"cruise_terminal\"\n                   ng-model=\"vm.transferData.cruise_terminal\"\n                   ng-class=\"amendForm.cruise_terminal.$valid ? 'st-form__input' : 'st-form__input--error'\"\n                   >\n        </div>\n        <div class=\"st-form__item\">\n            <span class=\"st-form__label--required\">{{vm.translations.ship_datetime_label}}</span>\n            <!-- @ST-COMPONENT -->\n            <st-date-time-picker date=\"vm.transferData.cruise_datetime\"\n                                 min-date=\"vm.transferData.cruise_datetime\"\n                                 max-date=\"vm.isDirectionFrom() ? vm.transfer.latest_pickup_time : angular.noop\" />\n        </div>\n    </div>\n<!-- END TYPE SEAPORT -->\n\n<!-- TYPE Airport -->\n    <div class=\"st-form__list__section\" ng-if=\"vm.type == vm.TYPE_AIRPORT\">\n        <div class=\"st-form__item\">\n            <h4 class=\"st-form__sub-title\"> {{vm.translations.transfer_sub_title}} </h4>\n            <input type=\"text\" class=\"st-form__input--disabled\" ng-value=\"vm.transferData.location_name\" disabled=\"disabled\">\n        </div>\n        <div class=\"st-form__item\">\n            <div class=\"st-form__list-group\">\n                <div class=\"st-form__list--airline\">\n                    <span ng-class=\"vm.isDirectionTo() ? 'st-form__label--required' : 'st-form__label'\"> {{vm.translations.outward_airline}}</span>\n                    <input type=\"text\"\n                           class=\"st-form__input\"\n                           name=\"airline\"\n                           ng-model=\"vm.transferData.airline\"\n                           ng-class=\"amendForm.airline.$valid ? 'st-form__input' : 'st-form__input--error'\"\n                           ng-required=\"vm.isDirectionTo()\">\n                </div>\n                <div class=\"st-form__list--flight-number\">\n                    <span class=\"st-form__label--required\" ng-if=\"vm.isDirectionFrom() || (vm.isDirectionTo() && vm.transferData.flight_number != 'NOT_NEEDED')\">\n                        {{vm.translations.flight_num}}\n                    </span>\n\n                    <input type=\"{{vm.isDirectionFrom() || (vm.isDirectionTo() && vm.transferData.flight_number != 'NOT_NEEDED') ? 'text' : 'hidden'}}\"\n                           name=\"flight_number\"\n                           class=\"st-form__input\"\n                           ng-model=\"vm.transferData.flight_number\"\n                           ng-class=\"amendForm.flight_number.$valid ? 'st-form__input' : 'st-form__input--error'\"\n                           required>\n                </div>\n            </div>\n        </div>\n        <div class=\"st-form__item\" ng-if=\"vm.isDirectionFrom()\">\n            <span class=\"st-form__label\">{{vm.translations.flight_origin}}</span>\n            <input type=\"text\"\n                   class=\"st-form__input\"\n                   name=\"origin_airport\"\n                   ng-model=\"vm.transferData.origin_airport\"\n                   ng-class=\"amendForm.origin_airport.$valid ? 'st-form__input' : 'st-form__input--error'\"\n                   >\n        </div>\n        <div class=\"st-form__item\">\n            <span class=\"st-form__label--required\">{{vm.translations.fligth_datetime_label}}</span>\n            <!-- @ST-COMPONENT -->\n            <st-date-time-picker date=\"vm.transferData.flight_datetime\"\n                                 min-date=\"vm.transferData.flight_datetime\"\n                                 max-date=\"vm.isDirectionFrom() ? vm.transfer.latest_pickup_time : angular.noop\" />\n        </div>\n    </div>\n\n    <!-- TYPE Hotel-->\n    <div class=\"st-form__list__section\" ng-if=\"vm.type == vm.TYPE_HOTEL\">\n        <div class=\"st-form__item\">\n            <h4 class=\"st-form__sub-title\">{{vm.translations.transfer_sub_title}}</h4>\n            <input type=\"text\" class=\"st-form__input--disabled\" ng-value=\"vm.transferData.location_name\" disabled=\"disabled\">\n        </div>\n        <div class=\"st-form__item\">\n            <span class=\"st-form__label\">{{ vm.translations.hotel_title }}</span>\n            <input type=\"text\"\n                   ng-model=\"vm.hotel\"\n                   uib-typeahead=\"hotel as hotel.name for hotel in vm.hotels | filter:$viewValue\"\n                   typeahead-loading=\"loadingLocations\"\n                   typeahead-no-results=\"noResults\"\n                   typeahead-on-select=\"vm.onSelectHotel($item, $model, $label, $event)\"\n                   ng-blur=\"vm.onBlurHotel()\"\n                   class=\"st-form__input\">\n        </div>\n        <div class=\"st-form__item\" ng-if=\"vm.isDirectionFrom()\">\n            <p ng-if=\"!vm.transfer.pickup_time\" translate=\"departure_pickup\" translate-value-hours=\"24\"></p>\n            <p ng-if=\"vm.transfer.pickup_time\" translate=\"your_pickup_time\" translate-value-time=\"{{vm.transfer.pickup_time | date:'HH:mm (hh:mm a) dd MMMM'}}\"></p>\n        </div>\n    </div>\n\n    <!-- TYPE Accommodation-->\n    <div class=\"st-form__list__section\" ng-if=\"vm.type == vm.TYPE_ACCOMODATION\">\n        <div class=\"st-form__item\">\n            <h4 class=\"st-form__sub-title\">{{vm.translations.transfer_sub_title}}</h4>\n            <input type=\"text\" class=\"st-form__input--disabled\" ng-value=\"vm.transferData.location_name\" disabled=\"disabled\">\n        </div>\n        <div class=\"st-form__item\">\n            <span class=\"st-form__label\">{{vm.translations.outward_acc}}</span>\n            <input type=\"text\"\n                   class=\"st-form__input\"\n                   name=\"accomodation_name\"\n                   ng-model=\"vm.transferData.name\"\n                   ng-class=\"amendForm.accomodation_name.$valid ? 'st-form__input' : 'st-form__input--error'\">\n        </div>\n        <div class=\"st-form__item\">\n            <span class=\"st-form__label--required\">{{vm.translations.outward_acc3}}</span>\n            <textarea type=\"text\"\n                      class=\"st-form__input\"\n                      name=\"accomodation_address1\"\n                      ng-model=\"vm.transferData.address1\"\n                      ng-class=\"amendForm.accomodation_address1.$valid ? 'st-form__input' : 'st-form__input--error'\"\n                      ng-maxlength=\"500\"\n                      required></textarea>\n        </div>\n        <!-- @ST-COMPONENT -->\n        <div class=\"st-form__item\" ng-if=\"vm.isDirectionFrom()\">\n            <span class=\"st-form__label--required\">{{vm.translations.pickup_date}}</span>\n            <!-- @ST-COMPONENT -->\n            <st-date-time-picker date=\"vm.transfer.pickup_time\"\n                                 min-date=\"vm.transferData.pickup_time\"\n                                 max-date=\"vm.transfer.latest_pickup_time\" />\n            <p translate=\"pickup_datetime\" translate-value-time=\"{{vm.transfer.route_minutes + ' min.'}}\"></p>\n        </div>\n    </div>\n</ng-form>"

/***/ },
/* 72 */
/***/ function(module, exports) {

	module.exports = "<!-- TYPE Airport  -->\n\n<!-- <h1>{{vm.type}}</h1> -->\n\n<div class=\"st-form__list__section\" ng-if=\"vm.type == vm.TYPE_AIRPORT\">\n    <div class=\"st-form__item\">\n        <h4 class=\"st-form__sub-title\">{{vm.translations.transfer_sub_title}}</h4>\n    </div>\n    <div class=\"st-form__item\">\n        <span class=\"st-form__label\">{{vm.translations.transfer_label}}</span>\n        <div class=\"st-form__input\">{{vm.transferData.location_name}}</div>\n    </div>\n    <div class=\"st-form__item\">\n        <span class=\"st-form__label\"> {{vm.translations.outward_airline}}</span>\n        <div class=\"st-form__input\">{{vm.transferData.airline}}</div>\n    </div>\n    <div class=\"st-form__item\" ng-if=\"'NOT_NEEDED' !== vm.transferData.flight_number\">\n        <span class=\"st-form__label\">{{vm.translations.flight_num}}</span>\n        <div class=\"st-form__input\">{{vm.transferData.flight_number}}</div>\n    </div>\n    <div class=\"st-form__item\" ng-if=\"vm.isDirectionFrom()\">\n        <span class=\"st-form__label\">{{vm.translations.flight_origin}}</span>\n        <div class=\"st-form__input\">{{vm.transferData.origin_airport}}</div>\n    </div>\n    <div class=\"st-form__item\">\n        <span class=\"st-form__label\">{{vm.translations.arr_date}}</span>\n        <div class=\"st-form__input\">{{vm.transferData.flight_datetime | date: vm.DATE_FORMAT}}</div>\n\n\n    </div>\n</div>\n\n<!-- TYPE Hotel-->\n<div class=\"st-form__list__section\" ng-if=\"vm.type == vm.TYPE_HOTEL\">\n    <div class=\"st-form__item\">\n        <h4 class=\"st-form__sub-title\">{{vm.translations.transfer_sub_title}}</h4>\n    </div>\n    <div class=\"st-form__item\">\n        <span class=\"st-form__label\">{{vm.translations.transfer_label}}</span>\n        <div class=\"st-form__input\">{{vm.transferData.location_name}}</div>\n    </div>\n    <div class=\"st-form__item\">\n        <span class=\"st-form__label\">{{ vm.translations.hotel_title }}</span>\n        <div class=\"st-form__input\">{{vm.transferData.name}}</div>\n    </div>\n</div>\n\n<!-- TYPE Acommodation-->\n<div class=\"st-form__list__section\" ng-if=\"vm.type == vm.TYPE_ACCOMODATION\">\n    <div class=\"st-form__item\">\n        <h4 class=\"st-form__sub-title\">{{vm.translations.transfer_sub_title}}</h4>\n    </div>\n    <div class=\"st-form__item\">\n        <span class=\"st-form__label\">{{vm.translations.transfer_label}}</span>\n        <div class=\"st-form__input\">{{vm.transferData.location_name}}</div>\n    </div>\n    <div class=\"st-form__item\">\n        <!--Accommodation name-->\n        <span class=\"st-form__label\">{{vm.translations.outward_acc}}</span>\n        <div class=\"st-form__input\">{{vm.transferData.name}}</div>\n    </div>\n    <div class=\"st-form__item\">\n        <span class=\"st-form__label\">{{vm.translations.outward_acc3}}</span>\n        <div class=\"st-form__input\" style=\"white-space: pre-wrap;\">{{vm.transferData.address1}}</div>\n    </div>\n</div>\n</div>"

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularResource = __webpack_require__(74);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _configConfig = __webpack_require__(16);
	
	var _configConfig2 = _interopRequireDefault(_configConfig);
	
	var _locationsService = __webpack_require__(76);
	
	var _locationsService2 = _interopRequireDefault(_locationsService);
	
	var locationsModule = _angular2['default'].module('locations', [_angularResource2['default'], _configConfig2['default']]).service('locationsService', _locationsService2['default']).name;
	
	exports['default'] = locationsModule;
	module.exports = exports['default'];

/***/ },
/* 74 */,
/* 75 */,
/* 76 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var locationsService = (function () {
	    locationsService.$inject = ["$resource", "CONFIG"];
	    function locationsService($resource, CONFIG) {
	        'ngInject';
	
	        _classCallCheck(this, locationsService);
	
	        this.resource = {
	            "countries": $resource(CONFIG.apiLocations.baseUrl + "/country"),
	            "hotels": $resource(CONFIG.apiLocations.baseUrl + "/locations/:cityId/hotels")
	        };
	    }
	
	    _createClass(locationsService, [{
	        key: "getCountries",
	        value: function getCountries() {
	            return this.resource.countries.query().$promise;
	        }
	    }, {
	        key: "getHotels",
	        value: function getHotels(cityId) {
	            return this.resource.hotels.query({ cityId: cityId }).$promise;
	        }
	    }]);
	
	    return locationsService;
	})();
	
	exports["default"] = locationsService;
	module.exports = exports["default"];

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _stExtrasComponent = __webpack_require__(78);
	
	var _stExtrasComponent2 = _interopRequireDefault(_stExtrasComponent);
	
	var _filtersExtractAndCreateTranslationLink = __webpack_require__(81);
	
	var _filtersExtractAndCreateTranslationLink2 = _interopRequireDefault(_filtersExtractAndCreateTranslationLink);
	
	var stExtrasModule = _angular2['default'].module('stExtras', [_filtersExtractAndCreateTranslationLink2['default']]).component('stExtras', _stExtrasComponent2['default']).name;
	
	exports['default'] = stExtrasModule;
	module.exports = exports['default'];

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _stExtrasHtml = __webpack_require__(79);
	
	var _stExtrasHtml2 = _interopRequireDefault(_stExtrasHtml);
	
	var _stExtrasController = __webpack_require__(80);
	
	var _stExtrasController2 = _interopRequireDefault(_stExtrasController);
	
	var stExtrasComponent = {
	    restrict: 'E',
	    bindings: {
	        data: '=',
	        index: '='
	    },
	    template: _stExtrasHtml2['default'],
	    controller: _stExtrasController2['default'],
	    controllerAs: 'vm'
	};
	
	exports['default'] = stExtrasComponent;
	module.exports = exports['default'];

/***/ },
/* 79 */
/***/ function(module, exports) {

	module.exports = "<div class=\"st-form__list__section\">\n    <div class=\"st-form__item\">\n        <h4 class=\"st-form__sub-title\">{{vm.translations.n_transfer_extras}}</h4>\n        <span>\n            {{ vm.translations.extras_price_zero }}\n            <a id=\"contact_cs_add_extras\" href ng-click=\"vm.openChat()\"> {{ vm.translations.extras_price_zero_link }}</a>\n            {{ vm.translations.extras_price_zero_end }}\n        </span>\n    </div>\n    <div class=\"st-form__item\">\n        <div class=\"no-more-tables\">\n            <table class=\"st-form__table__group\">\n                <thead>\n                <tr class=\"st-form__table__row\">\n                    <th class=\"table__item\">\n                        <div class=\"tooltip__item\">{{vm.translations.title_col1}}</div>\n                    </th>\n                    <th class=\"table__item--date\">\n                        <div class=\"tooltip__item\">{{vm.translations.title_col2}}</div>\n                    </th>\n                    <th class=\"table__item--date\">\n                        <div class=\"tooltip__item\">{{vm.translations.title_col3}}</div>\n                    </th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr ng-repeat=\"item in vm.data\"\n                    class=\"st-form__table__row\">\n                    <td class=\"table__item\"\n                        data-title=\"Gold bag\">\n                        <div class=\"tooltip__item\">\n                            {{ item.id + '_title' |translate }}\n                            <i class=\"icon st-icon-info-inverted\"\n                               title=\"{{ item.id + '_description' |translate }}\"\n                               alt=\"{{ item.id + '_description' |translate }}\"></i>\n                        </div>\n                    </td>\n                    <td class=\"table__item--date\"\n                        data-title=\"price\">\n                        <div class=\"tooltip__item\">{{item.price}} {{item.currency}}</div>\n                    </td>\n                    <td class=\"table__item--date\"\n                        data-title=\"Select\">\n                        <div class=\"tooltip__item\">\n                            <select class=\"st-form__select--extras\"\n                                    ng-model=\"item.quantity\"\n                                    ng-disabled=\"item.price>0\"\n                                    ng-options=\"item as item for item in vm.range(item.max_quantity)\"></select>\n                        </div>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n    </div>\n</div>"

/***/ },
/* 80 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var StExtrasController = (function () {
	    StExtrasController.$inject = ["$translate", "$filter"];
	    function StExtrasController($translate, $filter) {
	        'ngInject';
	
	        _classCallCheck(this, StExtrasController);
	
	        this.name = 'stExtras';
	        this.$translate = $translate;
	        this.$filter = $filter;
	    }
	
	    _createClass(StExtrasController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.translations = this.$translate.instant(["title_col1", "title_col2", "title_col2b", "title_col3", "title_col4", "1_description", "2_description", "3_description", "4_description", "5_description", "6_description", "7_description", "8_description", "extras_price_zero"]);
	
	            //TODO Clean up when we have correct segment
	            angular.merge(this.translations, this.$filter('splitTranslationWithLink')('extras_price_zero', {
	                link_start: '<a>',
	                link_end: '</a>'
	            }));
	
	            this.translations.n_transfer_extras = this.$translate.instant("n_transfer_extras", {
	                n: this.index
	            });
	        }
	    }, {
	        key: 'range',
	        value: function range(num) {
	            // return [...Array(1 + num).keys()].map(v => v);
	            var arr = new Array(num + 1);
	            for (var i = 0; i < arr.length; i++) {
	                arr[i] = i;
	            }
	            return arr;
	        }
	    }, {
	        key: 'openChat',
	        value: function openChat() {
	            var chat = document.querySelector('.inbenta-launcher');
	            if (chat) {
	                chat.click();
	            } else if (!document.querySelector('.inbenta-avatar')) {
	                zE.activate();
	            }
	            return false;
	        }
	    }]);
	
	    return StExtrasController;
	})();
	
	exports['default'] = StExtrasController;
	module.exports = exports['default'];

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	splitTranslationWithLink.$inject = ["$translate"];
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularTranslate = __webpack_require__(6);
	
	var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	
	function splitTranslationWithLink($translate) {
	    'ngInject';
	    return function (key, params) {
	        var message = $translate.instant(key, params);
	        var translations = {};
	        var transArray = message.split(params.link_start);
	
	        translations[key] = transArray[0];
	        if (transArray[1]) {
	            transArray = transArray[1].split(params.link_end);
	            translations[key + '_end'] = transArray[1];
	        }
	
	        translations[key + '_link'] = transArray[0];
	
	        return translations;
	    };
	}
	
	var splitTranslationWithLinkFilter = _angular2['default'].module('st.filters.splitTranslationWithLink', [_angularTranslate2['default']]).filter('splitTranslationWithLink', splitTranslationWithLink).name;
	
	exports['default'] = splitTranslationWithLinkFilter;
	module.exports = exports['default'];

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _stPassengersComponent = __webpack_require__(83);
	
	var _stPassengersComponent2 = _interopRequireDefault(_stPassengersComponent);
	
	var _angularTranslate = __webpack_require__(6);
	
	var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	
	var stPassengersModule = _angular2['default'].module('stPassengers', [_angularTranslate2['default']]).component('stPassengers', _stPassengersComponent2['default']).name;
	
	exports['default'] = stPassengersModule;
	module.exports = exports['default'];

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _stPassengersHtml = __webpack_require__(84);
	
	var _stPassengersHtml2 = _interopRequireDefault(_stPassengersHtml);
	
	var _stPassengersViewHtml = __webpack_require__(85);
	
	var _stPassengersViewHtml2 = _interopRequireDefault(_stPassengersViewHtml);
	
	var _stPassengersController = __webpack_require__(86);
	
	var _stPassengersController2 = _interopRequireDefault(_stPassengersController);
	
	var stPassengersComponent = {
	    restrict: 'E',
	    bindings: {
	        data: '=',
	        index: '='
	    },
	    template: ["$element", "$attrs", function template($element, $attrs) {
	        'ngInject';
	        return $attrs.editable == "true" ? _stPassengersHtml2['default'] : _stPassengersViewHtml2['default'];
	    }],
	    controller: _stPassengersController2['default'],
	    controllerAs: 'vm'
	};
	
	exports['default'] = stPassengersComponent;
	module.exports = exports['default'];

/***/ },
/* 84 */
/***/ function(module, exports) {

	module.exports = "<div class=\"st-form__list__section\"\n     ng-if=\"vm.data.vehicle.service_type == 'private'\">\n    <div class=\"st-form__item\">\n        <h4 class=\"st-form__sub-title\">{{vm.translations.passengers_number}}</h4>\n    </div>\n    <div class=\"st-form__item\">\n        <div class=\"st-form__list-group\">\n            <div class=\"st-form__list--passengers\">\n                <span class=\"st-form__label--required\">{{vm.translations.pass_total}}</span>\n                <select id=\"passangers_selector\" class=\"st-form__select--passengers\"\n                        ng-model=\"vm.data.passengers.total\"\n                        ng-options=\"item as item for item in vm.range(vm.data.vehicle.max_passengers)\"\n                        ng-change=\"vm.updatePassengers(vm.data)\"\n                        ></select>\n            </div>\n        </div>\n    </div>\n    <div class=\"st-form__item\"  style=\"display: none\">\n        <div class=\"st-form__list-group\">\n            <div class=\"st-form__radio--adults\">\n                <input type=\"radio\"\n                       ng-click=\"vm.toggleAddExtraChild(vm.data,false)\"\n                       name=\"st-form__radios--adults-infants-{{vm.index}}\"\n                       ng-checked=\"vm.data.passengers.infants.length ? false : true\"> <span>{{vm.translations.all_adults}}</span>\n            </div>\n            <div class=\"st-form__radio--infants\">\n                <input type=\"radio\"\n                       ng-click=\"vm.toggleAddExtraChild(vm.data,true)\"\n                       name=\"st-form__radios--adults-infants-{{vm.index}}\"\n                       ng-checked=\"vm.data.passengers.infants.length ? true : false\"> <span>{{vm.translations.infants_children}}</span>\n            </div>\n        </div>\n    </div>\n    <div class=\"st-form__item\" style=\"display:none;\">\n        <div class=\"st-form__list-group\"\n             ng-if=\"vm.showInfants\">\n            <div class=\"st-form__list--infants\"\n                 ng-repeat=\"infant in vm.data.passengers.infants\">\n                <span class=\"st-form__label\">{{vm.translations.option_infant}}</span>\n                <a href=\"\"\n                   ng-click=\"vm.removeExtraChild(vm.data,$index)\"\n                   role=\"button\"\n                   class=\"st-form__icon--remove\"></a>\n                <div class=\"st-form__item\">\n                    <div class=\"st-form__item-group\">\n                        <div class=\"st-form__item--infants\">\n                            <select id=\"infant_years\" ng-model=\"infant.years\"\n                                    ng-options=\"year as year + ' Years' for year in vm.years\"\n                                    class=\"st-form__select--infants\"></select>\n                        </div>\n                        <div class=\"st-form__item--infants\">\n                            <select id=\"infant_months\" ng-model=\"infant.months\"\n                                    ng-options=\"month as month + ' Months' for month in vm.months\"\n                                    class=\"st-form__select--infants\"></select>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <span ng-if=\"vm.showInfants && vm.data.passengers.total -1 > vm.data.passengers.infants.length\">\n            <a href=\"\" ng-click=\"vm.addExtraChild(vm.data)\">{{vm.translations.click_here}}</a>\n        </span>\n    </div>\n</div>"

/***/ },
/* 85 */
/***/ function(module, exports) {

	module.exports = "<div class=\"st-form__list__section\"\n     ng-if=\"vm.data.vehicle.service_type == 'private'\">\n    <div class=\"st-form__item\">\n        <h4 class=\"st-form__sub-title\">{{vm.translations.passengers_number}}</h4>\n    </div>\n    <div class=\"st-form__item\">\n        <span class=\"st-form__label\">{{vm.translations.pass_total}}</span>\n        <div class=\"st-form__input\">{{vm.data.passengers.total}}</div>\n    </div>\n    <div class=\"st-form__item\" ng-if=\"vm.showInfants\">\n        <span class=\"st-form__label\">{{vm.translations.option_infant}}</span>\n        <div class=\"st-form__input\">{{vm.data.passengers.infants.length}}</div>\n    </div>\n</div>"

/***/ },
/* 86 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var StPassengersController = (function () {
	    StPassengersController.$inject = ["$translate"];
	    function StPassengersController($translate) {
	        'ngInject';
	
	        _classCallCheck(this, StPassengersController);
	
	        this.name = 'stPassengers';
	        //Infants array
	        // this.years = [...Array(18).keys()];
	        this.years = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 16, 17];
	        // this.months = [...Array(12).keys()];
	        this.months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
	        this.$translate = $translate;
	    }
	
	    _createClass(StPassengersController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.showInfants = this.data.passengers.infants.length ? true : false;
	            this.translations = this.$translate.instant(["n_transfer_extras", "title_col1", "click_here", "additional_children", "option_infant", "all_adults", "infants_children", "passengers_number", "pass_total", "option_years", "option_months"]);
	        }
	    }, {
	        key: 'updatePassengers',
	        value: function updatePassengers(transfer) {
	            var maxChildren = transfer.passengers.total - 1;
	            if (maxChildren < transfer.passengers.infants.length) {
	                transfer.passengers.infants = transfer.passengers.infants.slice(0, maxChildren);
	            }
	        }
	    }, {
	        key: 'toggleAddExtraChild',
	        value: function toggleAddExtraChild(transfer, value) {
	            if (value == false) {
	                this.showInfants = false;
	            } else {
	                this.showInfants = true;
	            }
	        }
	    }, {
	        key: 'addExtraChild',
	        value: function addExtraChild(transfer) {
	            var maxPassengers = transfer.passengers.total - 1;
	            if (transfer.passengers.infants.length < maxPassengers) {
	                transfer.passengers.infants.push({
	                    "years": 1,
	                    "months": 0
	                });
	            }
	        }
	    }, {
	        key: 'removeExtraChild',
	        value: function removeExtraChild(transfer, i) {
	            transfer.passengers.infants.splice(i, 1);
	        }
	    }, {
	        key: 'range',
	        value: function range(num) {
	            // return [...Array(1 + num).keys()].map(v => 1 + v);
	            var arr = new Array(num);
	            for (var i = 0; i < arr.length; i++) {
	                arr[i] = 1 + i;
	            }
	            return arr;
	        }
	    }]);
	
	    return StPassengersController;
	})();
	
	exports['default'] = StPassengersController;
	module.exports = exports['default'];

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _stPrefixesComponent = __webpack_require__(88);
	
	var _stPrefixesComponent2 = _interopRequireDefault(_stPrefixesComponent);
	
	var _apiLocationsLocations = __webpack_require__(73);
	
	var _apiLocationsLocations2 = _interopRequireDefault(_apiLocationsLocations);
	
	var _filtersRemovePrefix = __webpack_require__(91);
	
	var _filtersRemovePrefix2 = _interopRequireDefault(_filtersRemovePrefix);
	
	var stPrefixesModule = _angular2['default'].module('stPrefixes', [_apiLocationsLocations2['default'], _filtersRemovePrefix2['default']]).component('stPrefixes', _stPrefixesComponent2['default']).name;
	
	exports['default'] = stPrefixesModule;
	module.exports = exports['default'];

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _stPrefixesHtml = __webpack_require__(89);
	
	var _stPrefixesHtml2 = _interopRequireDefault(_stPrefixesHtml);
	
	var _stPrefixesController = __webpack_require__(90);
	
	var _stPrefixesController2 = _interopRequireDefault(_stPrefixesController);
	
	var stPrefixesComponent = {
	  restrict: 'E',
	  bindings: {
	    data: '='
	  },
	  template: _stPrefixesHtml2['default'],
	  controller: _stPrefixesController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = stPrefixesComponent;
	module.exports = exports['default'];

/***/ },
/* 89 */
/***/ function(module, exports) {

	module.exports = "<ng-form name=\"amendForm\">\n    <div class=\"st-form__item\">\n        <div class=\"st-form__list-group--phones\">\n            <div class=\"st-form__list--phone-country\">\n                <span class=\"st-form__label--required\">{{vm.translations.mobile_phone}}</span>\n                <select id=\"phone_country_selector\" class=\"st-form__select--country\"\n                        ng-options=\"item as item.name for item in vm.prefixes track by item.id\"\n                        ng-model=\"vm.selectedPrefix\"\n                        ng-change=\"vm.changePrefix()\"\n                ></select>\n            </div>\n            <div class=\"st-form__list--phone-prefix\">\n                <span class=\"st-form__phone-prefix\">{{vm.selectedPrefix.phonePrefix}}</span>\n                <input type=\"tel\"\n                       class=\"st-form__input\"\n                       name=\"mobile_phone\"\n                       ng-model=\"vm.data.mobile_phone\"\n                       ng-class=\"amendForm.mobile_phone.$valid ? 'st-form__input' : 'st-form__input--error'\"\n                       required>\n            </div>\n        </div>\n</ng-form>"

/***/ },
/* 90 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var StPrefixesController = (function () {
	    StPrefixesController.$inject = ["locationsService", "$filter", "$translate"];
	    function StPrefixesController(locationsService, $filter, $translate) {
	        'ngInject';
	
	        _classCallCheck(this, StPrefixesController);
	
	        this.name = 'stPrefixes';
	        this.locationsService = locationsService;
	        this.$filter = $filter;
	        this.prefixes = [];
	        this.selectedPrefix = {};
	        this.translations = $translate.instant(['mobile_phone']);
	    }
	
	    _createClass(StPrefixesController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.getPrefixes();
	        }
	    }, {
	        key: 'changePrefix',
	        value: function changePrefix() {
	            this.data.mobile_country_id = this.selectedPrefix.id;
	            this.removePrefix();
	        }
	    }, {
	        key: 'removePrefix',
	        value: function removePrefix() {
	            //TODO: Make name independent by type phone for example, to work for all fields
	            // Transformation si made on save on amend controller
	            this.data.mobile_phone = this.$filter('removePrefix')(this.data.mobile_phone, this.selectedPrefix.phonePrefix);
	            this.data.mobile_phone_prefix = this.selectedPrefix.phonePrefix;
	        }
	    }, {
	        key: 'getPrefixes',
	        value: function getPrefixes() {
	            var _this = this;
	
	            this.locationsService.getCountries().then(function (response) {
	                _this.prefixes = response.reduce(function (items, item) {
	                    items[item.id] = item;
	                    return items;
	                }, {});
	
	                var prefix = _this.prefixes[_this.data.mobile_country_id] || false;
	                if (prefix) {
	                    _this.selectedPrefix = prefix;
	                    _this.removePrefix();
	                }
	            });
	        }
	    }]);
	
	    return StPrefixesController;
	})();
	
	exports['default'] = StPrefixesController;
	module.exports = exports['default'];

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function removePrefix() {
	    return function (item, prefix) {
	        prefix = prefix + " "; //add white space to prefix to trim from database EWWW! string.trim() aproach won´t work
	        item = item.replace(prefix, "");
	        return item;
	    };
	}
	
	var removePrefixFilter = _angular2["default"].module('st.filters.removePrefix', []).filter('removePrefix', removePrefix).name;
	
	exports["default"] = removePrefixFilter;
	module.exports = exports["default"];

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _stDateTimePickerComponent = __webpack_require__(93);
	
	var _stDateTimePickerComponent2 = _interopRequireDefault(_stDateTimePickerComponent);
	
	var stDateTimePickerModule = _angular2['default'].module('stDateTimePicker', [_angularUiRouter2['default']]).component('stDateTimePicker', _stDateTimePickerComponent2['default']).name;
	
	exports['default'] = stDateTimePickerModule;
	module.exports = exports['default'];

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _stDateTimePickerHtml = __webpack_require__(94);
	
	var _stDateTimePickerHtml2 = _interopRequireDefault(_stDateTimePickerHtml);
	
	var _stDateTimePickerController = __webpack_require__(95);
	
	var _stDateTimePickerController2 = _interopRequireDefault(_stDateTimePickerController);
	
	var stDateTimePickerComponent = {
	    restrict: 'E',
	    bindings: {
	        date: '=',
	        maxDate: '=',
	        minDate: '='
	    },
	    template: _stDateTimePickerHtml2['default'],
	    controller: _stDateTimePickerController2['default'],
	    controllerAs: 'vm'
	};
	
	exports['default'] = stDateTimePickerComponent;
	module.exports = exports['default'];

/***/ },
/* 94 */
/***/ function(module, exports) {

	module.exports = "<div class=\"{{ vm.name }}\">\n  <span uib-dropdown auto-close=\"disabled\" is-open=\"vm.dropdownStatus.isopen\" off-click=\"vm.closeDropDown()\">\n    <div class=\"st-form__input-group--open\" uib-dropdown-toggle>\n        <span class=\"input-group-addon\"><i class=\"st-form__calendar__icon st-icon-calendar\"></i></span>\n        <input type=\"text\" class=\"st-form__input is-readonly\" readonly ng-value=\"vm.date | amDateFormat: vm.DATE_FORMAT\">\n    </div>\n    <ul class=\"dropdown-menu dropdown-datepicker\" uib-dropdown-menu>\n        <li class=\"dropdown-edit-date\">\n            <!-- Add max-date from this dateTimePicker, use only in pickup  -->\n            <div uib-datepicker ng-model=\"vm.date\" class=\"st-datepicker has-navigation\"\n                 max-date=\"vm.maxDate ? vm.maxDate : undefined\" datepicker-options=\"vm.datePickerOptions\"></div>\n        </li>\n        <li class=\"dropdown-timepicker\">\n            <div class=\"pull-left\">\n                Select Time <br>\n                <a href ng-click=\"vm.toggleModeMeridian()\">{{vm.timePickerOptions.isMeridian ? '24h' : 'AM/PM'}}</a>\n            </div>\n            <div class=\"pull-right text-right\">\n                <!-- Add max from this dateTimePicker, use only in pickup  -->\n                <div uib-timepicker ng-model=\"vm.date\" show-meridian=\"vm.timePickerOptions.isMeridian\"\n                     max=\"vm.maxDate ? vm.maxDate : undefined\"\n                     min=\"vm.timePickerOptions.minDate\"></div>\n            </div>\n        </li>\n        <li>\n            <button type=\"button\" class=\"btn-st btn-st-success btn-block btn-lg\" ng-click=\"vm.save($event)\">SAVE</button>\n        </li>\n    </ul>\n  </span>\n</div>"

/***/ },
/* 95 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var StDateTimePickerController = (function () {
	    StDateTimePickerController.$inject = ["DATE_FORMAT"];
	    function StDateTimePickerController(DATE_FORMAT) {
	        'ngInject';
	
	        _classCallCheck(this, StDateTimePickerController);
	
	        this.name = 'stDateTimePicker';
	        this.date = typeof this.date === 'object' ? this.date : this.createDate(this.date);
	        this.oldDate = this.date;
	        this.DATE_FORMAT = DATE_FORMAT;
	        this.datePickerOptions = {
	            formatYear: 'yyyy',
	            showWeeks: false,
	            initDate: this.date,
	            minDate: new Date()
	        };
	        this.timePickerOptions = {
	            isMeridian: false,
	            minDate: new Date()
	        };
	
	        if (this.maxDate) {
	            this.datePickerOptions.maxDate = this.maxDate;
	        }
	
	        this.dropdownStatus = {
	            isopen: false
	        };
	
	        if (this.minDate) {
	            var minDateObj = typeof this.minDate === 'object' ? this.minDate : this.createDate(this.minDate);
	            var newMinDate = new Date();
	            newMinDate.setDate(minDateObj.getDate() - 1); // Subtract 1 day (24h)
	
	            if (newMinDate > new Date()) {
	                this.minDate = newMinDate;
	                this.datePickerOptions.minDate = this.minDate;
	                this.timePickerOptions.minDate = this.minDate;
	            }
	        }
	    }
	
	    _createClass(StDateTimePickerController, [{
	        key: '$onInit',
	        value: function $onInit() {}
	    }, {
	        key: 'save',
	        value: function save($event) {
	            $event.preventDefault();
	            $event.stopPropagation();
	            this.dropdownStatus.isopen = false;
	            this.oldDate = this.date;
	        }
	    }, {
	        key: 'createDate',
	        value: function createDate(dateTimeString) {
	            var dateTime = dateTimeString.split(' ');
	            var date = dateTime[0].split('-');
	            var time = dateTime[1].split(':');
	            var dateObject = new Date();
	
	            dateObject.setFullYear(Number(date[0]), Number(date[1]) - 1, Number(date[2]));
	            dateObject.setHours(Number(time[0]), Number(time[1]), 0);
	
	            return dateObject;
	        }
	    }, {
	        key: 'toggleDropdown',
	        value: function toggleDropdown() {
	            this.dropdownStatus.isopen = !this.dropdownStatus.isopen;
	        }
	    }, {
	        key: 'closeDropDown',
	        value: function closeDropDown() {
	            this.dropdownStatus.isopen = false;
	            this.date = this.oldDate;
	        }
	    }, {
	        key: 'toggleModeMeridian',
	        value: function toggleModeMeridian() {
	            this.timePickerOptions.isMeridian = !this.timePickerOptions.isMeridian;
	        }
	    }]);
	
	    return StDateTimePickerController;
	})();
	
	exports['default'] = StDateTimePickerController;
	module.exports = exports['default'];

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _authAuth = __webpack_require__(97);
	
	var _authAuth2 = _interopRequireDefault(_authAuth);
	
	var _bookingsBookings = __webpack_require__(108);
	
	var _bookingsBookings2 = _interopRequireDefault(_bookingsBookings);
	
	var _onTheBeachOnTheBeach = __webpack_require__(145);
	
	var _onTheBeachOnTheBeach2 = _interopRequireDefault(_onTheBeachOnTheBeach);
	
	var _apiMybookingMybooking = __webpack_require__(105);
	
	var _apiMybookingMybooking2 = _interopRequireDefault(_apiMybookingMybooking);
	
	var _servicesLanguageService = __webpack_require__(14);
	
	var _servicesLanguageService2 = _interopRequireDefault(_servicesLanguageService);
	
	var _servicesCacheService = __webpack_require__(15);
	
	var _servicesCacheService2 = _interopRequireDefault(_servicesCacheService);
	
	var _commonFiltersReferenceFormatter = __webpack_require__(107);
	
	var _commonFiltersReferenceFormatter2 = _interopRequireDefault(_commonFiltersReferenceFormatter);
	
	var routesModule = _angular2['default'].module('app.routes', [_angularUiRouter2['default'], _apiMybookingMybooking2['default'], _servicesLanguageService2['default'], _servicesCacheService2['default'], _commonFiltersReferenceFormatter2['default'], _authAuth2['default'], _bookingsBookings2['default'], _onTheBeachOnTheBeach2['default']]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    "ngInject";
	    //HOTFIX  MYB-123 TODO: improve lang url
	    $urlRouterProvider.when('/my-booking/goldupgrade?booking&email&confirm', '/en/my-booking/goldupgrade?booking&email&confirm');
	    $stateProvider.state('old_goldupgrade', {
	        resolve: {
	            data: ["$state", "$stateParams", "$q", "languageService", "authService", "myBookingService", "cacheService", "ReferenceFormatterFilter", function data($state, $stateParams, $q, languageService, authService, myBookingService, cacheService, ReferenceFormatterFilter) {
	                'ngInject';
	                var reference = ReferenceFormatterFilter($stateParams.booking);
	                authService.logout();
	                authService.loginByBookingReferenceAndCustomerEmail(reference, $stateParams.email).then(function (response) {
	                    //Bookings
	                    return myBookingService.getGlobalInfoBooking(reference);
	                }).then(function (response) {
	                    cacheService.set('bookingReference', response.booking.reference);
	                    languageService.setLanguage($stateParams.locale || null);
	                    $state.go('bookings.booking.goldupgrade', {
	                        bookingReference: response.booking.reference
	                    });
	                })['catch'](function (error) {
	                    authService.logout();
	                });
	            }]
	        },
	        url: '/{locale}/my-booking/goldupgrade?booking&email&confirm'
	    });
	    $urlRouterProvider.when('/my-booking?tab&booking&email&confirm', '/en/my-booking?tab&booking&email&confirm');
	    $stateProvider.state('tab_name', {
	        resolve: {
	            data: ["$state", "$stateParams", "$q", "languageService", "authService", "myBookingService", "cacheService", "ReferenceFormatterFilter", function data($state, $stateParams, $q, languageService, authService, myBookingService, cacheService, ReferenceFormatterFilter) {
	                'ngInject';
	                var reference = ReferenceFormatterFilter($stateParams.booking);
	                authService.loginByBookingReferenceAndCustomerEmail(reference, $stateParams.email).then(function (response) {
	                    //Bookings
	                    return myBookingService.getGlobalInfoBooking(reference);
	                }).then(function (response) {
	                    cacheService.set('bookingReference', response.booking.reference);
	                    languageService.setLanguage($stateParams.locale || null);
	                    if ($state.href('bookings.booking.' + $stateParams.tab) !== null) {
	                        $state.go('bookings.booking.' + $stateParams.tab, {
	                            locale: $stateParams.locale,
	                            bookingReference: response.booking.reference
	                        });
	                    } else {
	                        authService.logout();
	                        $stateParams.email = "";
	                        cacheService.set('bookingReference', "");
	                        $state.go('auth.login');
	                    }
	                })['catch'](function (error) {
	                    authService.logout();
	                });
	            }]
	        },
	        url: '/{locale}/my-booking?tab&booking&email&confirm'
	    });
	}]).name;
	
	exports['default'] = routesModule;
	module.exports = exports['default'];

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _authComponent = __webpack_require__(98);
	
	var _authComponent2 = _interopRequireDefault(_authComponent);
	
	var _loginLogin = __webpack_require__(101);
	
	var _loginLogin2 = _interopRequireDefault(_loginLogin);
	
	var authModule = _angular2['default'].module('auth', [_angularUiRouter2['default'], _loginLogin2['default']]).config(["$stateProvider", function ($stateProvider) {
	    "ngInject";
	    $stateProvider.state('auth', {
	        url: '/{locale}/auth',
	        views: {
	            'navbar@': {
	                template: '<navbar></navbar>'
	            },
	            'main@': {
	                template: '<auth></auth>'
	            },
	            'footer@': {
	                template: '<footer></footer>'
	            }
	        }
	    });
	}]).component('auth', _authComponent2['default']).name;
	
	exports['default'] = authModule;
	module.exports = exports['default'];

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _authHtml = __webpack_require__(99);
	
	var _authHtml2 = _interopRequireDefault(_authHtml);
	
	var _authController = __webpack_require__(100);
	
	var _authController2 = _interopRequireDefault(_authController);
	
	var authComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _authHtml2['default'],
	  controller: _authController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = authComponent;
	module.exports = exports['default'];

/***/ },
/* 99 */
/***/ function(module, exports) {

	module.exports = "<div class=\"auth\">\n    <div ui-view></div>\n</div>\n"

/***/ },
/* 100 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var AuthController = function AuthController() {
	    _classCallCheck(this, AuthController);
	
	    this.name = 'auth';
	};
	
	exports['default'] = AuthController;
	module.exports = exports['default'];

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _loginComponent = __webpack_require__(102);
	
	var _loginComponent2 = _interopRequireDefault(_loginComponent);
	
	var _apiMybookingMybooking = __webpack_require__(105);
	
	var _apiMybookingMybooking2 = _interopRequireDefault(_apiMybookingMybooking);
	
	var _servicesLanguageService = __webpack_require__(14);
	
	var _servicesLanguageService2 = _interopRequireDefault(_servicesLanguageService);
	
	var _servicesCacheService = __webpack_require__(15);
	
	var _servicesCacheService2 = _interopRequireDefault(_servicesCacheService);
	
	var _servicesHelpCentreService = __webpack_require__(13);
	
	var _servicesHelpCentreService2 = _interopRequireDefault(_servicesHelpCentreService);
	
	var _commonFiltersReferenceFormatter = __webpack_require__(107);
	
	var _commonFiltersReferenceFormatter2 = _interopRequireDefault(_commonFiltersReferenceFormatter);
	
	var loginModule = _angular2['default'].module('login', [_angularUiRouter2['default'], _apiMybookingMybooking2['default'], _servicesCacheService2['default'], _servicesLanguageService2['default'], _servicesHelpCentreService2['default'], _commonFiltersReferenceFormatter2['default']]).config(["$stateProvider", "$urlMatcherFactoryProvider", function ($stateProvider, $urlMatcherFactoryProvider) {
	    "ngInject";
	
	    $urlMatcherFactoryProvider.strictMode(false);
	    $stateProvider.state('auth.login', {
	        url: '/login?reference&email',
	        views: {
	            'main@': {
	                template: '<login></login>'
	            }
	        }
	    });
	}]).component('login', _loginComponent2['default']).name;
	
	exports['default'] = loginModule;
	module.exports = exports['default'];

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _loginHtml = __webpack_require__(103);
	
	var _loginHtml2 = _interopRequireDefault(_loginHtml);
	
	var _loginController = __webpack_require__(104);
	
	var _loginController2 = _interopRequireDefault(_loginController);
	
	var loginComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _loginHtml2['default'],
	  controller: _loginController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = loginComponent;
	module.exports = exports['default'];

/***/ },
/* 103 */
/***/ function(module, exports) {

	module.exports = "<div class=\"o-main\">\n    <section class=\"o-main__container--hero\">\n        <span class=\"o-main__background SUMMER-bg has-image has-loaded\" data-progressive-img=\"\"></span>\n        <div class=\"o-main__item--hero-alt\">\n            <h1 class=\"o-main__title--hero-alt\">{{ 'welcome_my_booking' | translate}}</h1>\n            <h2 class=\"o-main__description--hero\">{{ 'manage_amend_cancel_my_booking' | translate}}</h2>\n        </div>\n\n        <div class=\"o-main__item\">\n            <div class=\"o-main__container--search--rounded\">\n                <div class=\"o-main__item\">\n                    <div class=\"o-main__content\">\n                        <form class=\"o-search--landing\" autocomplete=\"off\" novalidate ng-submit=\"vm.login()\">\n                            <div class=\"o-search__container\">\n                                <div class=\"o-search__item\">\n                                    <div class=\"o-search__content\">\n                                        <label class=\"a-input\">\n                                            <div class=\"a-input__container\">\n                                                <span class=\"a-label__label\">\n                                                    {{ 'reference' | translate }}\n                                                    <span class=\"m-tooltip\">\n                                                        <span class=\"m-tooltip__content\">\n                                                            <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"m-tooltip__icon\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n                                                                <defs>\n                                                                    <path id=\"tooltip-b\" d=\"M8.08421053,12.9172932 C7.65413319,12.9172932 7.28471332,12.9255638 6.97593985,12.9421053 C6.66716638,12.9586467 6.36942499,12.9779448 6.08270677,13 C6.06065152,12.8897238 6.04962406,12.7849629 6.04962406,12.6857143 C6.04962406,12.6085209 6.06892211,12.5561405 6.1075188,12.5285714 C6.14611548,12.5010024 6.18746845,12.4817043 6.23157895,12.4706767 C6.58446292,12.4045109 6.82706701,12.3328325 6.9593985,12.2556391 C7.09172998,12.1784457 7.15789474,12.0571437 7.15789474,11.8917293 L7.15789474,7.52481203 C7.15789474,7.19398331 7.10275744,6.94035176 6.9924812,6.76390977 C6.88220496,6.58746779 6.62305968,6.48270693 6.21503759,6.44962406 C6.07167848,6.42756881 6,6.33934914 6,6.18496241 L6,6.06090226 C6,6.01127795 6.01102746,5.96441125 6.03308271,5.92030075 C6.09924845,5.92030075 6.19573871,5.91754389 6.32255639,5.91203008 C6.44937407,5.90651626 6.58446044,5.90100253 6.72781955,5.89548872 C6.87117866,5.88997491 7.01453562,5.88170432 7.15789474,5.87067669 C7.30125385,5.85964907 7.43358335,5.84862161 7.55488722,5.83759398 C7.83057782,5.80451111 8.09523683,5.76040128 8.34887218,5.70526316 C8.60250753,5.65012504 8.77343314,5.62255639 8.86165414,5.62255639 C9.03809612,5.62255639 9.12631579,5.70526233 9.12631579,5.87067669 C9.12631579,5.99198056 9.1097746,6.15187871 9.07669173,6.35037594 C9.04360886,6.54887317 9.02706767,6.82455964 9.02706767,7.17744361 L9.02706767,11.8917293 C9.02706767,12.0571437 9.09874615,12.1784457 9.24210526,12.2556391 C9.38546438,12.3328325 9.62255474,12.4045109 9.95338346,12.4706767 C10.0746873,12.4927319 10.1353383,12.5644104 10.1353383,12.6857143 L10.1353383,12.8511278 C10.1353383,12.9062659 10.1243109,12.9558895 10.1022556,13 C9.82656504,12.9779448 9.52882365,12.9586467 9.20902256,12.9421053 C8.88922146,12.9255638 8.51428786,12.9172932 8.08421053,12.9172932 Z M6.87669173,3.2075188 C6.87669173,2.85463483 6.98972318,2.56516404 7.21578947,2.33909774 C7.44185577,2.11303145 7.72581283,2 8.06766917,2 C8.42055314,2 8.70726707,2.11303145 8.92781955,2.33909774 C9.14837203,2.56516404 9.25864662,2.85463483 9.25864662,3.2075188 C9.25864662,3.56040277 9.14837203,3.84987356 8.92781955,4.07593985 C8.70726707,4.30200614 8.42055314,4.41503759 8.06766917,4.41503759 C7.72581283,4.41503759 7.44185577,4.30200614 7.21578947,4.07593985 C6.98972318,3.84987356 6.87669173,3.56040277 6.87669173,3.2075188 Z\"></path>\n                                                                    <filter id=\"tooltip-a\" width=\"438.5%\" height=\"227.3%\" x=\"-169.3%\" y=\"-45.5%\" filterUnits=\"objectBoundingBox\">\n                                                                        <feOffset dy=\"2\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset>\n                                                                        <feGaussianBlur in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\" stdDeviation=\"2\"></feGaussianBlur>\n                                                                        <feColorMatrix in=\"shadowBlurOuter1\" values=\"0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0\"></feColorMatrix>\n                                                                    </filter>\n                                                                </defs>\n                                                                <g fill=\"none\" fill-rule=\"evenodd\">\n                                                                    <path fill=\"#09AFEE\" fill-rule=\"nonzero\" d=\"M7.99966138,1.33226763e-14 C3.58196825,1.33226763e-14 -8.8817842e-16,3.58196825 -8.8817842e-16,7.99966138 C-8.8817842e-16,12.4173545 3.58196825,16 7.99966138,16 C12.4173545,16 16,12.4173545 16,7.99966138 C16,5.79081481 15.1043386,3.79089947 13.6564656,2.34319577 C12.2085926,0.895492063 10.2085079,1.33226763e-14 7.99966138,1.33226763e-14 Z\"></path>\n                                                                    <use fill=\"#000\" filter=\"url(#tooltip-a)\" xlink:href=\"#tooltip-b\"></use>\n                                                                    <use fill=\"#FFF\" xlink:href=\"#tooltip-b\"></use>\n                                                                    <path fill=\"#1F708F\" fill-rule=\"nonzero\" d=\"M7.9996878,0 C12.4175293,0 16,3.58205176 16,7.9996878 C16,12.4174266 12.4174266,16 7.9996878,16 C3.58205176,16 0,12.4175293 0,7.9996878 C0,3.58194903 3.58194903,0 7.9996878,0 Z M7.9996901,1.29838254 C4.29902424,1.29838254 1.29838254,4.29902424 1.29838254,7.9996901 C1.29838254,11.7004904 4.29915867,14.7016175 7.9996901,14.7016175 C11.700356,14.7016175 14.7016175,11.700356 14.7016175,7.9996901 C14.7016175,4.29915867 11.7004904,1.29838254 7.9996901,1.29838254 Z\"></path>\n                                                                </g>\n                                                            </svg>\n\n                                                            <span class=\"m-tooltip__tooltip\">\n                                                                <span class=\"m-tooltip__text\">You can find this information in your booking voucher email.</span>\n                                                            </span>\n                                                        </span>\n                                                    </span>\n                                                </span>\n                                                <div class=\"a-input__content\">\n                                                    <span class=\"a-input__prefill\">SUNTR_</span>\n                                                    <input class=\"a-input__input--big\" type=\"text\" placeholder=\"AB1234\" id=\"st-bookingReference\" ng-model=\"vm.reference\">\n                                                </div>\n\n                                                <div class=\"a-input__error\" role=\"alert\" type=\"danger\" ng-if=\"vm.error\">\n                                                    {{ 'booking_not_found_or_not_paid' | translate}}\n                                                </div>\n                                            </div>\n                                        </label>\n                                    </div><!--\n                                     --><div class=\"o-search__content\">\n                                    <label class=\"a-input\">\n                                        <div class=\"a-input__container\">\n                                            <span class=\"a-label__label\">{{ 'email_address' | translate}}</span>\n                                            <div class=\"a-input__content\">\n                                                <input class=\"a-input__input--big\" type=\"email\" id=\"st-emailAddress\" placeholder=\"{{ 'john.doe@domain.com' | translate}}\" ng-model=\"vm.email\">\n                                            </div>\n                                        </div>\n                                    </label>\n                                </div>\n                                </div>\n                            </div>\n\n                            <div class=\"o-search__container\">\n                                <div class=\"a-button--primary\">\n                                    <button type=\"submit\" class=\"a-button__container st-loginButton\" title=\"{{ 'Log_in_my_booking' | translate }}\">\n                                            <span class=\"a-button__text\">\n                                                {{ 'Log_in_my_booking' | translate }}\n                                            </span>\n                                    </button>\n                                </div>\n                            </div>\n                        </form>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </section>\n\n    <section class=\"o-main__container\">\n        <div class=\"o-main__item--alt\">\n            <div class=\"o-main__content\">\n                <h2 class=\"o-main__title\">{{ 'you_will_be_able_to' | translate }}</h2>\n            </div>\n\n            <div class=\"o-key-points\">\n                <div class=\"o-key-points__item\">\n                    <div class=\"o-key-points__header\">\n                        <div class=\"o-key-points__icon\">\n                            <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"i-print\" viewBox=\"0 0 16 16\">\n                                <g fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(0 -1)\">\n                                    <polygon fill=\"#FFF\" points=\".408 4.66 .408 13.922 15.351 13.922 15.351 4.66\"></polygon>\n                                    <path fill=\"#09AFEE\" fill-rule=\"nonzero\" d=\"M14.9624442,4.16017086 L0.650542405,4.16017086 C0.292740969,4.16017086 0,4.44111011 0,4.78448693 L0,11.776809 L15.6129866,11.776809 L15.6129866,4.78448693 C15.6129866,4.44111011 15.3202456,4.16017086 14.9624442,4.16017086 Z\"></path>\n                                    <rect width=\"10.506\" height=\"1\" x=\"2.57\" y=\"11.778\" fill=\"#FFCD48\" fill-rule=\"nonzero\"></rect>\n                                    <ellipse cx=\"12.328\" cy=\"6.034\" fill=\"#FFCD48\" fill-rule=\"nonzero\" rx=\"1\" ry=\"1\"></ellipse>\n                                    <ellipse cx=\"14.247\" cy=\"6.034\" fill=\"#FFCD48\" fill-rule=\"nonzero\" rx=\"1\" ry=\"1\"></ellipse>\n                                    <path fill=\"#1F708F\" fill-rule=\"nonzero\" d=\"M0.668579609,13.6750353 C0.668579609,13.6750054 15.3934175,13.6751206 15.3934175,13.6751206 C15.3936795,13.6751206 15.3936792,4.74274798 15.3936792,4.74274798 C15.3936792,4.74277789 0.668841318,4.74266272 0.668841318,4.74266272 C0.668579296,4.74266272 0.668579609,13.6750353 0.668579609,13.6750353 Z M0.0311294098,4.74274798 C0.0311294098,4.41271692 0.316484227,4.14517389 0.668841318,4.14517389 L15.3934175,4.14517389 C15.7456161,4.14517389 16.0311294,4.41279929 16.0311294,4.74274798 L16.0311294,13.6750353 C16.0311294,14.0050664 15.7457746,14.2726094 15.3934175,14.2726094 L0.668841318,14.2726094 C0.316642756,14.2726094 0.0311294098,14.004984 0.0311294098,13.6750353 L0.0311294098,4.74274798 Z\"></path>\n                                    <polygon fill=\"#FFF\" points=\"3.397 12.372 3.397 16.61 12.173 16.61 12.173 12.372\"></polygon>\n                                    <rect width=\"4.93\" height=\"1\" x=\"5.004\" y=\"13.59\" fill=\"#09AFEE\" rx=\".5\"></rect>\n                                    <path fill=\"#1F708F\" fill-rule=\"nonzero\" d=\"M3.10301978 12.3717769L3.10301978 16.3622765C3.10304316 16.7072481 3.38653641 16.987915 3.73501049 16.987915L11.8989799 16.987915C12.2473137 16.987915 12.5306433 16.7072481 12.5306433 16.3622997L12.5306433 12.3717769 11.952737 12.3717769 11.952737 16.3622997C11.952737 16.39179 11.9286294 16.4157942 11.8990267 16.4157942L3.73503388 16.4157942C3.70524417 16.4157942 3.68099619 16.39179 3.68099619 16.3622997L3.68099619 12.3717769 3.10301978 12.3717769zM12.4995373 4.27453019L12.4995373 1.6201222C12.4995373 1.27517381 12.2162077.994506836 11.8678739.994506836L5.75469423.994506836C5.67806875.994506836 5.60457656 1.02466841 5.55035181 1.07830184L3.15653616 3.44805701C3.10235818 3.50169044 3.07189037 3.5744671 3.07189037 3.65032241L3.07189037 4.27453019 12.4995373 4.27453019z\"></path>\n                                    <path fill=\"#FFCD48\" d=\"M5.46577617,3.31102208 C5.46577617,3.34039663 5.44164511,3.36428515 5.4119957,3.36428515 L4.05864515,3.36428515 L5.46577617,1.97125105 L5.46577617,3.31102208 Z\"></path>\n                                    <path fill=\"#FFF\" d=\"M3.64986678,3.93642912 L5.4119957,3.93642912 C5.76035287,3.93642912 6.04370582,3.65587788 6.04370582,3.31104523 L6.04370582,1.56662765 L11.8678739,1.56662765 C11.8974999,1.56662765 11.9215842,1.59063191 11.9215842,1.6201222 L11.9215842,4.27453019 L3.64227753,4.27453019 L3.64986678,3.93642912 Z\"></path>\n                                    <path fill=\"#FFF\" d=\"M3.64986678,3.93642912 L5.4119957,3.93642912 C5.76035287,3.93642912 6.04370582,3.65587788 6.04370582,3.31104523 L6.04370582,1.56662765 L11.8678739,1.56662765 C11.8974999,1.56662765 11.9215842,1.59063191 11.9215842,1.6201222 L11.9215842,4.27453019 L3.64227753,4.27453019 L3.64986678,3.93642912 Z\"></path>\n                                </g>\n                            </svg>\n                        </div>\n                    </div>\n                    <div class=\"o-key-points__headline\">\n                        <h3 class=\"o-key-points__title\">{{ 'print_booking_voucher' | translate}}</h3>\n                    </div>\n                </div><!--\n\n                 --><div class=\"o-key-points__item\">\n                <div class=\"o-key-points__header\">\n                    <div class=\"o-key-points__icon\">\n                        <svg class=\"i-edit\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 72 75\">\n                            <g fill=\"none\" fill-rule=\"evenodd\">\n                                <rect width=\"30.8\" height=\"3.8\" x=\"12\" y=\"29\" fill=\"#09AFEE\" rx=\"1.9\"></rect>\n                                <rect width=\"30.8\" height=\"3.8\" x=\"12\" y=\"41\" fill=\"#09AFEE\" rx=\"1.9\"></rect>\n                                <path fill=\"#09AFEE\" d=\"M12 60c0-1 1-2 2-2h8v3.8h-8c-1 0-2-.8-2-2z\"></path>\n                                <path fill=\"#1F708F\" fill-rule=\"nonzero\" d=\"M57.2 11.5c1 0 1.8-.8 1.8-1.8V4c0-2.2-1.8-4-4-4H17c-.6 0-1 .2-1.4.5l-15 15c-.3.4-.5.8-.5 1.3V71c0 2.2 2 4 4 4h51c2.2 0 4-1.8 4-4V43.4c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8V71c0 .2-.2.4-.3.4H4s-.3-.2-.3-.4V18.6h11c2.2 0 4-1.8 4-4v-11H55c.2 0 .4.2.4.4v5.7c0 1 .8 1.8 1.8 1.8z\"></path>\n                                <path fill=\"#FFCD48\" d=\"M15 14.7s0 .3-.3.3H6.3L15 6.2v8.5z\"></path><path fill=\"#1F708F\" fill-rule=\"nonzero\" d=\"M70.2 15l-2-2.2c-2.4-2.4-6.3-2.4-8.7 0L25 47.6c-.4.2-.5.5-.6.8l-2.8 10s-.8 2.4-.5 3c.4.5 2 .6 2 .6h.4l11.3-3.2c.3 0 .6-.2.8-.5l34.7-34.8c2.4-2.4 2.4-6.2 0-8.6zM25.5 57.5l1.5-5.3 3.8 4-5.3 1.3z\"></path>\n                                <path fill=\"#FFCD48\" d=\"M34.3 54.5L28.6 49l28.7-29L63 26\"></path>\n                                <path fill=\"#09AFEE\" d=\"M67.7 21l-2.3 2.2-5.6-5.6 2.3-2.3c1-1 2.6-1 3.6 0l2 2c1 1 1 2.7 0 3.7z\"></path>\n                            </g>\n                        </svg>\n                    </div>\n                </div>\n                <div class=\"o-key-points__headline\">\n                    <h3 class=\"o-key-points__title\">{{ 'amend_your_booking' | translate }}</h3>\n                </div>\n            </div><!--\n\n                 --><div class=\"o-key-points__item\">\n                <div class=\"o-key-points__header\">\n                    <div class=\"o-key-points__icon\">\n                        <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"i-cancel\" viewBox=\"0 0 13 16\">\n                            <g fill=\"none\" fill-rule=\"evenodd\">\n                                <g transform=\"translate(0 1.39)\">\n                                    <path fill=\"#FFF\" d=\"M0.579167824,3.02253543 L2.56660118,3.02253543 C2.92184359,3.02253543 3.21079697,2.74921473 3.21079697,2.4132693 L3.21079697,0.713809841 L11.4357933,0.713809841 C11.4660049,0.713809841 11.4905652,0.73719545 11.4905652,0.765925696 L11.4905652,14.4421483 L0.571428571,14.4421483 L0.579167824,3.02253543 Z\"></path>\n                                    <rect width=\"6.974\" height=\"1\" x=\"2.391\" y=\"5.727\" fill=\"#09AFEE\" rx=\".5\"></rect>\n                                    <rect width=\"6.974\" height=\"1\" x=\"2.391\" y=\"8.097\" fill=\"#09AFEE\" rx=\".5\"></rect>\n                                    <rect width=\"6.974\" height=\"1\" x=\"2.391\" y=\"10.664\" fill=\"#09AFEE\" rx=\".5\"></rect>\n                                    <path fill=\"#1F708F\" fill-rule=\"nonzero\" d=\"M11.756323,1.90988049 L11.756323,0.781859132 C11.756323,0.350761904 11.4038027,0 10.9704036,0 L3.36434827,0 C3.26901038,0 3.17757095,0.0376942483 3.11010419,0.104722317 L0.131704193,3.06630994 C0.064295619,3.13333801 0.0263873875,3.22429021 0.0263873875,3.31908994 L0.0263873875,14.0296661 C0.0264164806,14.4607923 0.379140501,14.8115542 0.812714081,14.8115542 L10.9703745,14.8115542 C11.4037736,14.8115542 11.7562939,14.4607923 11.7562939,14.0296951 L11.7562939,8.5712902 L11.756323,1.90988049 Z M11.0372594,8.5712902 L11.0372594,14.0296951 C11.0372594,14.0665504 11.0072645,14.0965496 10.9704327,14.0965496 L0.812743174,14.0965496 C0.77567864,14.0965496 0.745509158,14.0665504 0.745509158,14.0296951 L0.745509158,3.67665011 L2.93796067,3.67665011 C3.37138879,3.67665011 3.72393825,3.32603285 3.72393825,2.89508027 L3.72393825,0.715004636 L10.9704036,0.715004636 C11.0072645,0.715004636 11.0372303,0.745003819 11.0372303,0.781859132 L11.0372303,1.90988049\"></path>\n                                    <path fill=\"#FFCD48\" d=\"M3.00487467,2.89505134 C3.00487467,2.93176201 2.97485065,2.96161655 2.93796067,2.96161655 L1.25411369,2.96161655 L3.00487467,1.22068035 L3.00487467,2.89505134 Z\"></path>\n                                </g>\n                                <ellipse cx=\"10.991\" cy=\"2\" fill=\"#E93861\" rx=\"1.991\" ry=\"2\"></ellipse>\n                                <path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M10.7912211,0.767766953 L11.2443128,0.767766953 C11.2762957,0.767766953 11.3029482,0.778427934 11.3242702,0.799749895 C11.3509226,0.821071857 11.3615836,0.847724309 11.3615836,0.879707251 L11.3615836,1.67395032 L12.1558267,1.67395032 C12.1878096,1.67395032 12.214462,1.6846113 12.235784,1.71126375 C12.257106,1.73258572 12.267767,1.75923817 12.267767,1.79122111 L12.267767,2.2443128 C12.267767,2.27629574 12.257106,2.30294819 12.235784,2.32427015 C12.214462,2.34559211 12.1878096,2.35625309 12.1558267,2.35625309 L11.3615836,2.35625309 L11.3615836,3.15582665 C11.3615836,3.1878096 11.3509226,3.21446205 11.3242702,3.23578401 C11.3029482,3.25710597 11.2762957,3.26776695 11.2443128,3.26776695 L10.7912211,3.26776695 C10.7592382,3.26776695 10.7325857,3.25710597 10.7112638,3.23578401 C10.6899418,3.21446205 10.6792808,3.1878096 10.6792808,3.15582665 L10.6792808,2.35625309 L9.87970725,2.35625309 C9.84772431,2.35625309 9.82107186,2.34559211 9.7997499,2.32427015 C9.77842793,2.30294819 9.76776695,2.27629574 9.76776695,2.2443128 L9.76776695,1.79122111 C9.76776695,1.75923817 9.77842793,1.73258572 9.7997499,1.71126375 C9.82107186,1.6846113 9.84772431,1.67395032 9.87970725,1.67395032 L10.6792808,1.67395032 L10.6792808,0.879707251 C10.6792808,0.847724309 10.6899418,0.821071857 10.7112638,0.799749895 C10.7325857,0.778427934 10.7592382,0.767766953 10.7912211,0.767766953 Z\" transform=\"rotate(45 11.018 2.018)\"></path>\n                            </g>\n                        </svg>\n                    </div>\n                </div>\n                <div class=\"o-key-points__headline\">\n                    <h3 class=\"o-key-points__title\">{{ 'cancel_your_booking' | translate }}</h3>\n                </div>\n            </div><!--\n\n                 --><div class=\"o-key-points__item\">\n                <div class=\"o-key-points__header\">\n                    <div class=\"o-key-points__icon\">\n                        <svg class=\"i-extras\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 86 94\">\n                            <defs><rect id=\"a\" width=\"31\" height=\"61\" x=\"27\" y=\"35\" rx=\"3\"></rect><rect id=\"b\" width=\"5.6\" height=\"16\" x=\"55.4\" y=\"57.2\" rx=\"2\"></rect></defs>\n                            <g fill=\"none\" fill-rule=\"evenodd\"><g fill-rule=\"nonzero\"><g fill=\"#45423C\"><path d=\"M30.5 84.7v5c0 .6.5 1 1.2 1H34c.8 0 1.3-.4 1.3-1v-5h-4.8zM3.7 84.7v5c0 .6.5 1 1.2 1h2.3c.7 0 1.2-.4 1.2-1v-5H3.7z\"></path></g>\n                                <path fill=\"#09AFEE\" d=\"M35.3 86H3.7c-1.4 0-2.5-1.2-2.5-2.6v-42c0-1.4 1-2.5 2.5-2.5h31.6c1.4 0 2.5 1 2.5 2.4v42c0 1.4-1 2.5-2.5 2.5z\"></path><path fill=\"#FFCD48\" d=\"M24.4 24h-9.8c-.6 0-1.2-.5-1.2-1v-2.6c0-.7.6-1.2 1.2-1.2h9.8c.6 0 1.2.5 1.2 1.2V23c0 .5-.6 1-1.2 1z\"></path>\n                                <path fill=\"#1F708F\" d=\"M35.3 37.8h-9.8V25c.7-.4 1.2-1.2 1.2-2v-2.6c0-1.3-1-2.4-2.3-2.4h-9.8c-1.3 0-2.3 1-2.3 2.4V23c0 .8.5 1.6 1.2 2v12.8H3.7c-2 0-3.6 1.6-3.6 3.6v42c0 1.6 1 3 2.5 3.5v2.6C2.5 91 3.5 92 5 92h2.3c1.3 0 2.4-1 2.4-2.4V87h19.6v2.6c0 1.3 1 2.4 2.4 2.4H34c1.4 0 2.5-1 2.5-2.4V87c1.4-.6 2.4-2 2.4-3.6v-42c0-2-1.7-3.6-3.7-3.6zM14.6 20.4h9.8V23h-9.8v-2.6zm1.2 5h7.4v12.4h-7.4V25.3zM7.4 89.5H4.8h-.2V87h2.6v2.6zm26.7 0h-2.3V87H34v2.6zm2.6-6.2c0 .7-.6 1.3-1.3 1.3H3.7c-.7 0-1.3-.6-1.3-1.3v-42c0-.7.6-1.3 1.3-1.3h31.6c.7 0 1.3.7 1.3 1.4v42z\"></path>\n                                <path fill=\"#1F708F\" d=\"M19.5 42.7c-.6 0-1 .5-1 1.2v37c0 .6.4 1 1 1s1-.4 1-1V44c0-.8-.4-1.3-1-1.3zM25.6 50c-.6 0-1.2.7-1.2 1.3V81c0 .6.6 1 1.2 1s1-.4 1-1V51.3c0-.6-.4-1.2-1-1.2zM25.6 42.7c-.6 0-1.2.5-1.2 1.2v2.3c0 .7.6 1.2 1.2 1.2s1-.5 1-1.2V44c0-.8-.4-1.3-1-1.3zM31.7 42.7c-.7 0-1.2.5-1.2 1.2v37c0 .6.5 1 1.2 1 .6 0 1-.4 1-1V44c0-.8-.4-1.3-1-1.3zM7.3 42.7c-.6 0-1 .5-1 1.2v37c0 .6.4 1 1 1 .7 0 1.2-.4 1.2-1V44c0-.8-.5-1.3-1.2-1.3zM13.4 77.3c-.6 0-1 .5-1 1.2V81c0 .6.4 1 1 1s1.2-.4 1.2-1v-2.5c0-.7-.6-1.2-1.2-1.2zM13.4 42.7c-.6 0-1 .5-1 1.2v29.5c0 .7.4 1.2 1 1.2s1.2-.5 1.2-1.2V44c0-.8-.6-1.3-1.2-1.3z\"></path></g>\n                                <g fill-rule=\"nonzero\"><path fill=\"#FFCD48\" d=\"M66.4 71c.5 0 .8-.6.7-1.2L56.3 26l-2 .5 11 43.8c0 .6.6 1 1.2.8z\"></path><path fill=\"#FFCD48\" d=\"M55 28.8l1.4-.3c.3 0 .4-.3.4-.6L55 21l9-4.5c1-.5 1.4-1.7 1-2.6-1-1.4-2.5-3.4-5.4-3.8-1 0-2 0-3 .7-2.2 1.3-6 4.6-3.8 10.6l1.7 7s.4.3.6.2z\"></path><path fill=\"#1F708F\" d=\"M55 28.8l1.4-.3c.3 0 .4-.3.4-.6l-.8-3.4-2.3.5.8 3.5c0 .2.4.4.6.3zM56.8 17l3.7-2.5-1-1-3.6 2.4s-.6.3-.2 1c.2.3.7.3 1 0zM59 18.2l3-2-1-1-2.8 2s-.6.3-.2 1c.3.2.7.3 1 0zM56.4 14.6l2.6-1.8-1-1.2-2.5 2s-.5.3 0 1c0 .2.5.3 1 0z\"></path></g>\n                                <g fill-rule=\"nonzero\"><path fill=\"#FFCD48\" d=\"M59 74c.6-.2 1-1 .8-1.5l-13.2-53-2.5.5 13.3 53c.2.8 1 1.2 1.6 1z\"></path>\n                                    <path fill=\"#FFCD48\" d=\"M45.3 23l1.5-.5c.4 0 .6-.4.5-.8l-2-8L56 8c1.2-.6 1.7-2 1-3.2-1-1.8-2.8-4-6.3-4.6-1.3-.2-2.6 0-3.7.8-2.6 1.6-7.2 5.7-4.6 13l2 8.2c.2.4.6.6 1 .5z\"></path><path fill=\"#1F708F\" d=\"M45.3 23l1.5-.5c.4 0 .6-.4.5-.8l-1-4-2.8.7 1 4c0 .4.5.6.8.5zM47.3 8.7l4.5-3.2-1.2-1.3-4.3 3s-.7.5-.2 1.2c.3.5 1 .5 1.3.3zM50 10l3.5-2.4-1.2-1.4L49 8.6s-.7.5-.2 1.2c.3.4.8.5 1.2.2zM46.8 5.7L50 3.4 49 2l-3.2 2.3s-.7.5-.2 1.2c.2.4.8.5 1.2.2z\"></path></g><g transform=\"rotate(-15 33.392 -15.66)\"><use fill=\"#09AFEE\" xlink:href=\"#a\"></use><rect width=\"28\" height=\"58\" x=\"28.5\" y=\"36.5\" stroke=\"#1F708F\" stroke-width=\"3\" rx=\"3\"></rect></g>\n                                <g fill=\"#1F708F\" fill-rule=\"nonzero\"><path d=\"M49.7 47.8c-.3.5-.2 1.2.3 1.6l24 18c.5.4 1.2.3 1.5 0 .3-.6.2-1.3-.3-1.7l-24-18c-.4-.4-1-.3-1.5 0zM47.6 40c-.3.6-.2 1.2.3 1.6l24 18c.4.4 1 .4 1.4 0 .4-.5.2-1.2-.3-1.6L49.3 40c-.5-.4-1.2-.4-1.6 0zM51.6 56c-.3.4-.2 1 .3 1.4l23.8 18c.5.4 1.2.4 1.6 0 .3-.5.2-1.2-.3-1.6l-23.8-18c-.5-.4-1.2-.4-1.6 0zM53.5 64c-.4.3-.2 1 .3 1.4l17.6 13.3c.5.4 1.2.4 1.5 0 .3-.6 0-1.3-.4-1.6L55 63.8c-.5-.3-1.2-.3-1.5.2zM73.8 79.5c-.3.4-.2 1 .3 1.5l2.2 1.5c.6.4 1.3.4 1.6 0 .4-.6.2-1.3-.3-1.6l-2-1.7c-.6-.4-1.3-.3-1.7.2z\"></path></g><g transform=\"rotate(-15 33.392 -15.66)\"><use fill=\"#FFF\" xlink:href=\"#b\"></use>\n                                    <rect width=\"3.6\" height=\"14\" x=\"56.4\" y=\"58.2\" stroke=\"#1F708F\" stroke-width=\"2\" rx=\"1.8\"></rect>\n                                </g>\n                            </g>\n                        </svg>\n                    </div>\n                </div>\n                <div class=\"o-key-points__headline\">\n                    <h3 class=\"o-key-points__title\">{{ 'add_free_extras' | translate }}</h3>\n                </div>\n            </div>\n            </div>\n        </div>\n    </section>\n\n    <section class=\"o-main__container\">\n        <div class=\"o-main__item--alt\">\n            <div class=\"o-main__content\">\n                <h2 class=\"o-main__title\">{{ 'have_a_question' | translate }}</h2>\n                <h3 class=\"o-main__description\">{{ 'search_faq_my_booking' | translate }}</h3>\n            </div>\n        </div>\n\n        <div class=\"o-main__button\">\n            <a class=\"a-highlight-button\" target=\"_blank\" href=\"{{vm.helpCentreService.getBaseUrl()}}\">\n                <div class=\"a-highlight-button__item\">\n                    <svg class=\"i-faq a-highlight-button__icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 95 95\">\n                        <g fill=\"none\" fill-rule=\"evenodd\">\n                            <path fill=\"#09AFEE\" d=\"M47.5 93C22.5 93 2 72.6 2 47.5 2 22.5 22.4 2 47.5 2 72.5 2 93 22.4 93 47.5 93 72.5 72.6 93 47.5 93zm17-62.5c-4.6-4.5-10.6-7-17-7s-12.4 2.5-17 7C21.7 39.3 21 53.3 29 62.8c-.8 1.6-2 3.4-3.8 4.3-1 .5-1.4 1.4-1.3 2.4 0 1 .8 1.8 1.8 2h2c2 0 5.2-.4 8.3-2.8 3.7 2 7.6 3 11.5 3 6.2 0 12.3-2.5 17-7 4.5-4.7 7-10.7 7-17 0-6.5-2.5-12.5-7-17z\"></path>\n                            <path fill=\"#1F708F\" fill-rule=\"nonzero\" d=\"M47.5 94.5c-26 0-47-21-47-47s21-47 47-47 47 21 47 47-21 47-47 47zm0-3c24.3 0 44-19.7 44-44s-19.7-44-44-44-44 19.7-44 44 19.7 44 44 44zm-18-62c4.8-4.8 11.2-7.5 18-7.5 6.8 0 13.2 2.7 18 7.5 4.8 4.8 7.5 11.2 7.5 18 0 6.8-2.7 13.2-7.5 18-4.8 5-11.3 7.5-18 7.5-4 0-7.7-1-11.2-2.6-2.8 1.8-5.7 2.6-8.6 2.6-.8 0-1.5 0-2-.2-1.7-.3-3-1.5-3.3-3-.2-1.8.6-3.4 2-4 1-.6 2-1.6 2.8-2.8-7.7-10-6.8-24.5 2.3-33.5zm18-4.5c-6 0-11.7 2.3-16 6.6-8 8.2-8.7 21.4-1.3 30.2l.6.8-.5 1c-1 2-2.5 4-4.5 4.8-.3.2-.4.5-.4.8 0 .3.3.6.6.6l1.7.2c2.5 0 5-.8 7.6-2.6l.7-.5 1 .3C40 69 43.7 70 47.4 70c6 0 11.6-2.3 16-6.6 4.2-4.2 6.5-10 6.5-16S67.7 36 63.4 31.7c-4.3-4.3-10-6.6-16-6.6z\"></path>\n                            <path fill=\"#1F708F\" d=\"M47.4 59.8h-2.8c-.8 0-1.6 0-2.3.2v-.8-.4c.2 0 .3 0 .4-.2 1 0 1.5-.3 2-.5.2 0 .4-.4.4-.8V46c0-.8 0-1.5-.4-2-.2-.4-1-.6-2-.7-.3 0-.5-.3-.5-.7v-.3s0-.3.2-.4H44l1-.2h1l2-.4 1.4-.2c.5 0 .7.2.7.6V43l-.2 2v12.2c0 .4.2.7.6 1l1.8.4c.3 0 .5.3.5.6v.8h-2.4c-.8-.2-1.8-.2-3-.2zm-3-24.8c0-1 .2-1.6.8-2.2.6-.6 1.3-1 2.2-1 1 0 1.6.4 2.2 1 .5.6.8 1.3.8 2.2 0 1-.3 1.6-.8 2.2-.6.6-1.3 1-2.2 1-1 0-1.6-.4-2.2-1-.6-.6-1-1.3-1-2.2z\"></path>\n                        </g>\n                    </svg>\n                </div>\n                <div class=\"a-highlight-button__item\">\n                    <div class=\"a-highlight-button__title\">\n                        {{ 'help_centre' | translate }}\n                    </div>\n                    <div class=\"a-highlight-button__text\">\n                        {{ 'amending_cancelling_booking' | translate }}\n                    </div>\n                </div>\n            </a>\n        </div>\n    </section>\n\n"

/***/ },
/* 104 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var LoginController = (function () {
	    LoginController.$inject = ["$state", "$stateParams", "authService", "myBookingService", "languageService", "cacheService", "ReferenceFormatterFilter", "CONFIG", "helpCentreService"];
	    function LoginController($state, $stateParams, authService, myBookingService, languageService, cacheService, ReferenceFormatterFilter, CONFIG, helpCentreService) {
	        'ngInject';
	
	        _classCallCheck(this, LoginController);
	
	        this.email = $stateParams.email;
	        this.reference = $stateParams.reference;
	        this.CONFIG = CONFIG;
	        this.$stateParams = $stateParams;
	        this.$state = $state;
	        this.authService = authService;
	        this.myBookingService = myBookingService;
	        this.languageService = languageService;
	        this.cacheService = cacheService;
	        this.helpCentreService = helpCentreService;
	        this.ReferenceFormatterFilter = ReferenceFormatterFilter;
	        // Reset login data to defaults
	        this.error = false;
	        this.setLoginLang();
	        this.test = { '%headline_start%': 'test' };
	    }
	
	    // Set default lang on sign out and with url params
	
	    _createClass(LoginController, [{
	        key: 'setLoginLang',
	        value: function setLoginLang() {
	
	            this.languageService.setLanguage(this.$stateParams.locale || null);
	            try {
	                this.languageService.findLanguageByKey(this.$stateParams.locale || null);
	            } catch (e) {
	                this.$state.transitionTo('auth.login', {
	                    locale: 'en',
	                    reference: this.reference,
	                    email: this.email
	                }, { location: true, notify: false });
	            }
	        }
	    }, {
	        key: 'setLanguage',
	        value: function setLanguage() {
	            this.languageService.setLanguage(this.cacheService.get('customer').language || null);
	        }
	    }, {
	        key: 'login',
	        value: function login() {
	            var _this = this;
	
	            var reference = this.ReferenceFormatterFilter(this.reference);
	            this.authService.loginByBookingReferenceAndCustomerEmail(reference, this.email).then(function (response) {
	                //Bookings
	                return _this.myBookingService.getGlobalInfoBooking(reference).then(function (response) {
	                    _this.cacheService.set('customer', response.customer);
	                    return response;
	                });
	            }).then(function (response) {
	                _this.cacheService.set('bookingReference', response.booking.reference);
	                _this.cacheService.set('agencyBookingReference', '');
	                _this.cacheService.set('onTheBeachBooking', false);
	                _this.setLanguage();
	
	                _this.$state.go('bookings.booking.view', {
	                    locale: _this.cacheService.get('customer').language || null,
	                    bookingReference: response.booking.reference
	                });
	            })['catch'](function (error) {
	                //TODO manage the error with new relic
	                _this.error = true;
	                _this.authService.logout();
	            })['finally'](function () {});
	        }
	    }]);
	
	    return LoginController;
	})();
	
	exports['default'] = LoginController;
	module.exports = exports['default'];

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularResource = __webpack_require__(74);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _configConfig = __webpack_require__(16);
	
	var _configConfig2 = _interopRequireDefault(_configConfig);
	
	var _mybookingService = __webpack_require__(106);
	
	var _mybookingService2 = _interopRequireDefault(_mybookingService);
	
	var myBookingModule = _angular2['default'].module('mybooking', [_angularResource2['default'], _configConfig2['default']]).service('myBookingService', _mybookingService2['default']).name;
	
	exports['default'] = myBookingModule;
	module.exports = exports['default'];

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _commonAuthOnTheBeachAgencyIds = __webpack_require__(57);
	
	var _commonAuthOnTheBeachAgencyIds2 = _interopRequireDefault(_commonAuthOnTheBeachAgencyIds);
	
	var myBookingService = (function () {
	    myBookingService.$inject = ["$resource", "$q", "CONFIG"];
	    function myBookingService($resource, $q, CONFIG) {
	        'ngInject';
	
	        _classCallCheck(this, myBookingService);
	
	        this.resource = {
	            "booking": $resource(CONFIG.apiMyBooking.baseUrl + '/bookings/:bookingReference', {}, {
	                get: {
	                    method: 'GET',
	                    params: {
	                        referenceType: '@referenceType',
	                        'agencyIds[]': '@agencyIds'
	                    }
	                }
	            }),
	            "amendBooking": $resource(CONFIG.apiMyBooking.baseUrl + '/bookings/:bookingReference/amend', {}, {
	                get: {
	                    method: "GET"
	                },
	                put: {
	                    method: "PUT"
	                }
	            }),
	            "cancelBooking": $resource(CONFIG.apiMyBooking.baseUrl + '/bookings/:bookingReference/cancel'),
	            "cancelTransfer": $resource(CONFIG.apiMyBooking.baseUrl + '/bookings/:bookingReference/transfers/:transferId/cancel'),
	            "goldprotection": $resource(CONFIG.apiMyBooking.baseUrl + '/bookings/:bookingReference/goldprotection'),
	            "lastPdfVoucherUrl": CONFIG.apiMyBooking.baseUrl + '/bookings/:bookingReference/voucher?access_token=:accessToken',
	            "invoice": $resource(CONFIG.apiMyBooking.baseUrl + '/bookings/:bookingReference/invoices', {}, {
	                get: {
	                    method: "GET"
	                },
	                post: {
	                    method: "POST"
	                }
	            })
	        };
	        this.$q = $q;
	    }
	
	    _createClass(myBookingService, [{
	        key: 'getGlobalInfoBooking',
	        value: function getGlobalInfoBooking(bookingReference) {
	            var isOnTheBeach = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	            var params = { bookingReference: bookingReference };
	
	            if (isOnTheBeach) {
	                params.referenceType = 'agency';
	                params['agencyIds[]'] = _commonAuthOnTheBeachAgencyIds2['default'];
	            }
	
	            return this.resource.booking.get(params).$promise;
	        }
	    }, {
	        key: 'getLastPdfVoucherUrl',
	        value: function getLastPdfVoucherUrl(bookingReference, accessToken) {
	            var isOnTheBeach = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
	            var url = this.resource.lastPdfVoucherUrl.replace(':bookingReference', bookingReference).replace(':accessToken', accessToken);
	
	            if (isOnTheBeach) {
	                url += '&referenceType=agency' + _commonAuthOnTheBeachAgencyIds2['default'].map(function (id) {
	                    return '&agencyIds[]=' + id;
	                }).join('');
	            }
	            return url;
	        }
	    }, {
	        key: 'getAmend',
	        value: function getAmend(bookingReference) {
	            return this.resource.amendBooking.get({ bookingReference: bookingReference }).$promise;
	        }
	    }, {
	        key: 'saveAmend',
	        value: function saveAmend(bookingReference, data) {
	            return this.resource.amendBooking.put({ bookingReference: bookingReference }, data).$promise;
	        }
	    }, {
	        key: 'getCancel',
	        value: function getCancel(bookingReference) {
	            return this.resource.cancelBooking.get({ bookingReference: bookingReference }).$promise;
	        }
	    }, {
	        key: 'postCancelBooking',
	        value: function postCancelBooking(bookingReference) {
	            return this.resource.cancelBooking.save({ bookingReference: bookingReference }, {}).$promise;
	        }
	    }, {
	        key: 'postCancelTransfer',
	        value: function postCancelTransfer(bookingReference, transferId) {
	            return this.resource.cancelTransfer.save({ bookingReference: bookingReference, transferId: transferId }, {}).$promise;
	        }
	    }, {
	        key: 'postGoldProtectionUpgrade',
	        value: function postGoldProtectionUpgrade(bookingReference) {
	            return this.resource.goldprotection.save({ bookingReference: bookingReference }, {}).$promise;
	        }
	    }, {
	        key: 'getBookingInvoices',
	        value: function getBookingInvoices(bookingReference) {
	            return this.resource.invoice.get({ bookingReference: bookingReference }).$promise;
	        }
	    }, {
	        key: 'createInvoice',
	        value: function createInvoice(bookingReference, customerDetails) {
	            return this.resource.invoice.post({ bookingReference: bookingReference }, customerDetails).$promise;
	        }
	    }]);
	
	    return myBookingService;
	})();
	
	exports['default'] = myBookingService;
	module.exports = exports['default'];

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function ReferenceFormatter() {
	    return function (reference) {
	        var formattedReference = reference.replace('SUNTR-', 'SUNTR_')
	        //delete after /
	        .replace(new RegExp('\/.', 'gi'), '').replace(' ', '').toUpperCase();
	
	        if (!formattedReference.match(/^SUNTR_/)) {
	            formattedReference = 'SUNTR_' + formattedReference;
	        }
	
	        return formattedReference.match(/^SUNTR_[A-Za-z]{2}[0-9]{4}/) ? formattedReference : reference;
	    };
	}
	
	var referenceFormatterFilter = _angular2['default'].module('st.filters.referenceFormatter', []).filter('ReferenceFormatter', ReferenceFormatter).name;
	
	exports['default'] = referenceFormatterFilter;
	module.exports = exports['default'];

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _bookingsComponent = __webpack_require__(109);
	
	var _bookingsComponent2 = _interopRequireDefault(_bookingsComponent);
	
	var _servicesCacheService = __webpack_require__(15);
	
	var _servicesCacheService2 = _interopRequireDefault(_servicesCacheService);
	
	var _bookingBooking = __webpack_require__(112);
	
	var _bookingBooking2 = _interopRequireDefault(_bookingBooking);
	
	var _bookingsRun = __webpack_require__(144);
	
	var _bookingsRun2 = _interopRequireDefault(_bookingsRun);
	
	var _servicesLanguageService = __webpack_require__(14);
	
	var _servicesLanguageService2 = _interopRequireDefault(_servicesLanguageService);
	
	var bookingsModule = _angular2['default'].module('bookings', [_angularUiRouter2['default'], _servicesCacheService2['default'], _bookingBooking2['default']]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    'ngInject';
	    //Redirect default child state from abstract parent
	    $stateProvider.state('bookings', {
	        resolve: {
	            data: ["$q", "$stateParams", "languageService", function data($q, $stateParams, languageService) {
	                'ngInject';
	                languageService.setLanguage($stateParams.locale);
	                var defer = $q.defer();
	                defer.resolve('Success!');
	                return defer.promise;
	            }]
	        },
	        url: '/{locale}/bookings',
	        redirectTo: 'bookings.booking.view',
	        views: {
	            'main@': {
	                template: '<bookings></bookings>'
	            },
	            'navbar@': {
	                template: '<navbar></navbar>'
	            },
	            'footer@': {
	                template: '<footer></footer>'
	            }
	        }
	    });
	}]).component('bookings', _bookingsComponent2['default']).run(_bookingsRun2['default']).name;
	
	exports['default'] = bookingsModule;
	module.exports = exports['default'];

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _bookingsHtml = __webpack_require__(110);
	
	var _bookingsHtml2 = _interopRequireDefault(_bookingsHtml);
	
	var _bookingsController = __webpack_require__(111);
	
	var _bookingsController2 = _interopRequireDefault(_bookingsController);
	
	var bookingsComponent = {
	    restrict: 'E',
	    bindings: {},
	    template: _bookingsHtml2['default'],
	    controller: _bookingsController2['default'],
	    controllerAs: 'vm'
	};
	
	exports['default'] = bookingsComponent;
	module.exports = exports['default'];

/***/ },
/* 110 */
/***/ function(module, exports) {

	module.exports = "<main>\n    Table with all bookings\n    <ul>\n        <li ng-repeat=\"reference in vm.bookings\">\n            <a href=\"\" ui-sref=\"bookings.booking.view({bookingReference: reference})\">{{reference}}</a>\n        </li>\n    </ul>\n</main>"

/***/ },
/* 111 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var BookingsController = function BookingsController($filter, $translate, $stateParams, cacheService, languageService) {
	    'ngInject';
	
	    _classCallCheck(this, BookingsController);
	
	    this.$translate = $translate;
	    this.bookings = [cacheService.get('bookingReference')];
	
	    // this.languageService = languageService;
	    // this.$stateParams = $stateParams;
	    // this.languageService.setLanguage(this.$stateParams.locale || null);
	};
	BookingsController.$inject = ["$filter", "$translate", "$stateParams", "cacheService", "languageService"];
	
	exports['default'] = BookingsController;
	module.exports = exports['default'];

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _bookingComponent = __webpack_require__(113);
	
	var _bookingComponent2 = _interopRequireDefault(_bookingComponent);
	
	var _servicesCacheService = __webpack_require__(15);
	
	var _servicesCacheService2 = _interopRequireDefault(_servicesCacheService);
	
	//Child states
	
	var _viewView = __webpack_require__(116);
	
	var _viewView2 = _interopRequireDefault(_viewView);
	
	var _amendAmend = __webpack_require__(120);
	
	var _amendAmend2 = _interopRequireDefault(_amendAmend);
	
	var _cancelCancel = __webpack_require__(124);
	
	var _cancelCancel2 = _interopRequireDefault(_cancelCancel);
	
	var _goldupgradeGoldupgrade = __webpack_require__(132);
	
	var _goldupgradeGoldupgrade2 = _interopRequireDefault(_goldupgradeGoldupgrade);
	
	var _invoiceInvoice = __webpack_require__(136);
	
	var _invoiceInvoice2 = _interopRequireDefault(_invoiceInvoice);
	
	var bookingModule = _angular2['default'].module('booking', [_angularUiRouter2['default'], _servicesCacheService2['default'], _viewView2['default'], _amendAmend2['default'], _cancelCancel2['default'], _goldupgradeGoldupgrade2['default'], _invoiceInvoice2['default']]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    'ngInject';
	    $stateProvider.state('bookings.booking', {
	        resolve: {
	            data: ["$stateParams", "$q", "myBookingService", "cacheService", "authService", "$state", function data($stateParams, $q, myBookingService, cacheService, authService, $state) {
	                'ngInject';
	                var bookingReference = cacheService.get('bookingReference');
	                if ($stateParams.bookingReference == bookingReference) {
	                    return myBookingService.getGlobalInfoBooking(bookingReference).then(function (booking) {
	                        return booking;
	                    }, function (error) {
	                        if (error.status === 401) {
	                            authService.clearSession();
	                            $state.go('auth.login');
	                        }
	                        return null;
	                    });
	                } else {
	                    return deferred.promise;
	                }
	            }]
	        },
	        url: '/:bookingReference',
	        abstract: true,
	        redirectTo: 'bookings.booking.view',
	        views: {
	            'main@': {
	                template: '<booking data="$resolve.data"></booking>'
	            }
	        }
	    });
	}]).component('booking', _bookingComponent2['default']).name;
	exports['default'] = bookingModule;
	module.exports = exports['default'];

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _bookingHtml = __webpack_require__(114);
	
	var _bookingHtml2 = _interopRequireDefault(_bookingHtml);
	
	var _bookingController = __webpack_require__(115);
	
	var _bookingController2 = _interopRequireDefault(_bookingController);
	
	var bookingComponent = {
	    restrict: 'E',
	    bindings: {
	        "data": '<'
	    },
	    template: _bookingHtml2['default'],
	    controller: _bookingController2['default'],
	    controllerAs: 'vm'
	};
	
	exports['default'] = bookingComponent;
	module.exports = exports['default'];

/***/ },
/* 114 */
/***/ function(module, exports) {

	module.exports = "<!--Start of mybooking content-->\n<div class=\"st-mybooking\">\n    <p class=\"st-mybooking__customer-name\"><strong>{{vm.translations.customer}}</strong> {{vm.data.customer.full_name}} </p>\n    <p class=\"st-mybooking__customer-reference\"><strong>{{vm.translations.payment_reference}}</strong> {{vm.data.booking.reference}}</p>\n\n    <div name=\"crc_alert\" class=\"{{ vm.message.class }}\" role=\"{{ vm.message.role }}\" type=\"{{ vm.message.type }}\" ng-if=\"vm.message\">\n        <div><span>{{ vm.message.text }}</span></div>\n    </div>\n\n    <h1 class=\"st-mybooking__main-title\">{{ vm.translations.mainTitleKey }}</h1>\n\n    <ul class=\"st-navtabs\">\n        <li class=\"st-navtabs__item\">\n            <a class=\"st-navtabs__item__link\" ui-sref-active=\"st-navtabs__item__link--active\" href=\"\" ui-sref=\"bookings.booking.view\">{{vm.translations.tab_title_view}}</a>\n        </li>\n        <li class=\"st-navtabs__item\" ng-class=\"{ disabled : vm.data === null }\">\n            <a ng-if=\"vm.data === null\" class=\"st-navtabs__item__link\" ui-sref-active=\"st-navtabs__item__link--active\">{{vm.translations.tab_title_amend}}</a>\n            <a ng-if=\"vm.data.status_amend == vm.STATUS_OK\" class=\"st-navtabs__item__link\" ui-sref-active=\"st-navtabs__item__link--active\" href=\"\" ui-sref=\"bookings.booking.amend\">{{vm.translations.tab_title_amend}}</a>\n            <a ng-if=\"vm.data.status_amend == vm.STATUS_PENDING_CRC || vm.data.status_amend == 'disabled'\" class=\"st-navtabs__item__link--disabled\" href=\"\">{{vm.translations.tab_title_amend}}</a>\n        </li>\n        <li class=\"st-navtabs__item\" ng-class=\"{ disabled : vm.data === null }\">\n            <a ng-if=\"vm.data === null\" class=\"st-navtabs__item__link\" ui-sref-active=\"st-navtabs__item__link--active\">{{vm.translations.tab_title_cancel}}</a>\n            <a ng-if=\"vm.data !== null && vm.data.status_cancel !== vm.STATUS_DISABLED\" class=\"st-navtabs__item__link\" ui-sref-active=\"st-navtabs__item__link--active\" href=\"\" ui-sref=\"bookings.booking.cancel\">{{vm.translations.tab_title_cancel}}</a>\n            <a ng-if=\"vm.data.status_cancel == vm.STATUS_DISABLED\" class=\"st-navtabs__item__link--disabled\" href=\"\">{{vm.translations.tab_title_cancel}}</a>\n        </li>\n        <!--Add from agency flag check, and hide if it is from agency-->\n        <li class=\"st-navtabs__item\" ng-if=\"vm.data.status_invoices === 'enabled'\" ng-class=\"{ disabled : vm.data === null }\">\n            <a class=\"st-navtabs__item__link\" ui-sref-active=\"st-navtabs__item__link--active\" href=\"\" ui-sref=\"bookings.booking.invoice\">{{'invoice_my_booking' | translate}}</a>\n        </li>\n    </ul>\n\n    <div ui-view=\"booking\" class=\"st-navtabs__container\"></div>\n</div>\n<!--End of mybooking content-->"

/***/ },
/* 115 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var BookingController = (function () {
	    BookingController.$inject = ["$translate", "cacheService"];
	    function BookingController($translate, cacheService) {
	        'ngInject';
	
	        _classCallCheck(this, BookingController);
	
	        this.$translate = $translate;
	        this.cacheService = cacheService;
	        this.message = false;
	
	        this.STATUS_OK = 'ok';
	        this.STATUS_DISABLED = 'disabled';
	        this.STATUS_PENDING_CRC = 'pending_crc';
	        this.STATUS_NOT_CANCELLABLE = 'not_cancellable';
	    }
	
	    _createClass(BookingController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.translations = this.$translate.instant(['msg_7', 'tab_title_view', 'tab_title_amend', 'tab_title_cancel', 'customer', 'payment_reference', 'crc_confirmed']);
	
	            this.translations.mainTitleKey = "";
	            if (this.data !== null) {
	                if (this.data.status_amend === this.STATUS_PENDING_CRC) {
	                    this.message = {
	                        'class': 'st-alert--danger',
	                        role: 'alert',
	                        type: 'danger',
	                        text: this.translations.msg_7
	                    };
	                } else if (this.data.status_amend === this.STATUS_OK && this.cacheService.get('statusAmendUpdated') === true) {
	                    this.message = {
	                        'class': 'st-alert--success',
	                        role: 'alert',
	                        type: 'success',
	                        text: this.translations.crc_confirmed
	                    };
	                    this.cacheService.set('statusAmendUpdated', false);
	                }
	            }
	        }
	    }]);
	
	    return BookingController;
	})();
	
	exports['default'] = BookingController;
	module.exports = exports['default'];

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularOauth2 = __webpack_require__(48);
	
	var _angularOauth22 = _interopRequireDefault(_angularOauth2);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularSanitize = __webpack_require__(20);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _apiMybookingMybooking = __webpack_require__(105);
	
	var _apiMybookingMybooking2 = _interopRequireDefault(_apiMybookingMybooking);
	
	var _viewComponent = __webpack_require__(117);
	
	var _viewComponent2 = _interopRequireDefault(_viewComponent);
	
	var viewModule = _angular2['default'].module('view', [_angularUiRouter2['default'], _angularOauth22['default'].name, _angularSanitize2['default'], _apiMybookingMybooking2['default']]).config(["$stateProvider", function ($stateProvider) {
	    "ngInject";
	    $stateProvider.state('bookings.booking.view', {
	        url: '/view',
	        views: {
	            'booking@bookings.booking': {
	                template: '<view></view>'
	            }
	        }
	    });
	}]).component('view', _viewComponent2['default']).name;
	
	exports['default'] = viewModule;
	module.exports = exports['default'];

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _viewHtml = __webpack_require__(118);
	
	var _viewHtml2 = _interopRequireDefault(_viewHtml);
	
	var _viewController = __webpack_require__(119);
	
	var _viewController2 = _interopRequireDefault(_viewController);
	
	var viewComponent = {
	    restrict: 'E',
	    require: {
	        booking: '^booking'
	    },
	    template: _viewHtml2['default'],
	    controller: _viewController2['default'],
	    controllerAs: 'vm'
	};
	
	exports['default'] = viewComponent;
	module.exports = exports['default'];

/***/ },
/* 118 */
/***/ function(module, exports) {

	module.exports = "<main>\n    <div class=\"st-form\">\n        <iframe\n                ng-if=\"vm.showIframe && !vm.IS_MOBILE\"\n                width=\"100%\"\n                height=\"1200\"\n                ng-src=\"{{vm.lastPdfVoucherUrl}}\"\n        ></iframe>\n        <div ng-if=\"vm.showPdfNotFoundError\">\n          {{ 'voucher_not_generated' | translate }}\n        </div>\n        <div class=\"st-form__info\">\n        <a href=\"{{vm.lastPdfVoucherUrl}}\" ng-if=\"vm.showIframe\" class=\"st-form__button\" type=\"submit\" download>{{ 'download_voucher' | translate }}</a>\n        </div>\n    </div>\n\n</main>"

/***/ },
/* 119 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var viewController = (function () {
	    viewController.$inject = ["$translate", "$http", "$sce", "$stateParams", "authService", "myBookingService", "sharedService"];
	    function viewController($translate, $http, $sce, $stateParams, authService, myBookingService, sharedService) {
	        'ngInject';
	
	        _classCallCheck(this, viewController);
	
	        this.name = 'view';
	        this.$translate = $translate;
	        this.$stateParams = $stateParams;
	        this.$sce = $sce;
	        this.$http = $http;
	        this.myBookingService = myBookingService;
	        this.authService = authService;
	        this.IS_MOBILE = sharedService.IS_MOBILE;
	        this.showIframe = false;
	        this.showPdfNotFoundError = false;
	        this.lastPdfVoucherUrl = null;
	        this.successCallback = this.successCallback.bind(this);
	        this.errorCallback = this.errorCallback.bind(this);
	    }
	
	    _createClass(viewController, [{
	        key: 'getLastPdfVoucherUrl',
	        value: function getLastPdfVoucherUrl() {
	            return this.myBookingService.getLastPdfVoucherUrl(this.$stateParams.bookingReference, this.authService.getAccessToken());
	        }
	    }, {
	        key: 'successCallback',
	        value: function successCallback() {
	            this.lastPdfVoucherUrl = this.$sce.trustAsResourceUrl(this.getLastPdfVoucherUrl());
	            this.showIframe = true;
	        }
	    }, {
	        key: 'errorCallback',
	        value: function errorCallback() {
	            this.showIframe = false;
	            this.showPdfNotFoundError = true;
	        }
	    }, {
	        key: '$onInit',
	        value: function $onInit() {
	            this.$http({
	                method: 'HEAD',
	                url: this.getLastPdfVoucherUrl()
	            }).then(this.successCallback, this.errorCallback);
	
	            this.translations = this.$translate.instant(["content_title_view"]);
	
	            this.booking.translations.mainTitleKey = this.translations.content_title_view;
	        }
	    }]);
	
	    return viewController;
	})();
	
	exports['default'] = viewController;
	module.exports = exports['default'];

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _amendComponent = __webpack_require__(121);
	
	var _amendComponent2 = _interopRequireDefault(_amendComponent);
	
	var _apiMybookingMybooking = __webpack_require__(105);
	
	var _apiMybookingMybooking2 = _interopRequireDefault(_apiMybookingMybooking);
	
	var _servicesCacheService = __webpack_require__(15);
	
	var _servicesCacheService2 = _interopRequireDefault(_servicesCacheService);
	
	var _commonFiltersExtractAndCreateTranslationLink = __webpack_require__(81);
	
	var _commonFiltersExtractAndCreateTranslationLink2 = _interopRequireDefault(_commonFiltersExtractAndCreateTranslationLink);
	
	var amendModule = _angular2['default'].module('amend', [_angularUiRouter2['default'], _apiMybookingMybooking2['default'], _servicesCacheService2['default'], _commonFiltersExtractAndCreateTranslationLink2['default']]).config(["$stateProvider", function ($stateProvider) {
	    "ngInject";
	    $stateProvider.state('bookings.booking.amend', {
	        url: '/amend',
	        resolve: {
	            data: ["myBookingService", "$stateParams", "$q", "authService", "$state", function data(myBookingService, $stateParams, $q, authService, $state) {
	                return $q.all({
	                    amend: myBookingService.getAmend($stateParams.bookingReference),
	                    cancel: myBookingService.getCancel($stateParams.bookingReference)
	                }).then(function (result) {
	                    for (var id in result.amend.transfers) {
	                        _angular2['default'].merge(result.amend.transfers[id], result.cancel.transfers[id]);
	                    }
	                    return result.amend;
	                }, function (error) {
	                    if (error.status === 401) {
	                        authService.clearSession();
	                        $state.go('auth.login');
	                    }
	                    return null;
	                });
	            }]
	        },
	        views: {
	            'booking@bookings.booking': {
	                template: '<amend amend="$resolve.data"></amend>'
	            }
	        }
	    });
	}]).component('amend', _amendComponent2['default']).name;
	
	exports['default'] = amendModule;
	module.exports = exports['default'];

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _amendHtml = __webpack_require__(122);
	
	var _amendHtml2 = _interopRequireDefault(_amendHtml);
	
	var _amendController = __webpack_require__(123);
	
	var _amendController2 = _interopRequireDefault(_amendController);
	
	var amendComponent = {
	    restrict: 'E',
	    require: {
	        booking: '^booking'
	    },
	    bindings: {
	        amend: '<'
	    },
	    template: _amendHtml2['default'],
	    controller: _amendController2['default'],
	    controllerAs: 'vm'
	};
	
	exports['default'] = amendComponent;
	module.exports = exports['default'];

/***/ },
/* 122 */
/***/ function(module, exports) {

	module.exports = "<!--Start of Amend form-->\n<!-- TODO: Collapse component -->\n<div class=\"st-form--static\" ng-if=\"vm.amend === null\">\n    <div class=\"m-summary\">\n        <div class=\"m-summary__container\">\n            <div class=\"m-summary__item\">\n                <div class=\"m-summary__headline\">\n                    <h2 class=\"m-summary__title ng-binding\">We are experiencing technical problems.</h2>\n                    <div class=\"m-summary__description ng-binding\">Please try again later or contact us via live text\n                        chat. Sorry for the inconvenience.\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"st-form\" ng-if=\"vm.amend !== null\">\n    <div ng-if=\"vm.booking.data.status_amend != vm.booking.STATUS_OK\"\n        class=\"st-form__placeholder\">\n        <p class=\"st-form__placeholder__text\">{{vm.translations.msg_2}}</p>\n    </div>\n    <div ng-if=\"vm.booking.data.status_amend == vm.booking.STATUS_OK\">\n        <form class=\"st-form__content\"\n            role=\"form\"\n            name=\"amendForm\"\n            ng-submit=\"vm.save(amendForm.$pristine); vm.gotoCrcMessage() \"\n            autocomplete=\"off\">\n\n            <div class=\"st-alert--danger\" ng-if=\"vm.sharedService.errorMsg\" role=\"alert\" type=\"danger\">\n                <div>{{vm.translations.err_fillall}} <strong>{{vm.sharedService.errorMsg}}</strong></div>\n            </div>\n\n            <div class=\"st-form__info\">\n                <!-- TODO: uncomment -> Wating for translations\n                <span>{{vm.translations.modify_booking_details}} {{vm.translations.modify_booking_details_2}} {{vm.translations.modify_booking_details_3}}</span> \n                -->\n                <button class=\"st-form__button\"\n                    type=\"submit\">{{vm.translations.button_confirm_changes}}\n                </button>\n            </div>\n            <hr class=\"st-form__hr\">\n            <div class=\"st-form__vehicle\">\n\n                <div class=\"st-form__list--titles\" ng-click=\"collapsed_vehicle = !collapsed_vehicle\">\n\n                    <a href=\"#\"\n                        class=\"st-form__toggle--open st-icon-plus\"\n                        ng-class=\"collapsed_vehicle ? 'st-icon-plus' : 'st-icon-minus'\"></a>\n                    <h3 class=\"st-form__title\">{{vm.translations.label_vehicle}}</h3>\n                </div>\n                <div class=\"st-form__list--content\"\n                    ng-class=\"collapsed_vehicle ? 'st-form__list--content--collapsed' : 'st-form__list--content'\">\n                    <div class=\"st-form__item\">\n                        <div class=\"st-form__list-group\">\n                            <div class=\"st-form__list--vehicle\">\n                                <span class=\"st-form__label\">{{vm.translations['type_' + vm.amend.transfers[0].vehicle.type]}}</span>\n                                <p>{{vm.translations.label_max}}:<span class=\"st-form__list__item\">{{vm.amend.transfers[0].vehicle.max_luggage}}x <i class=\"st-icon--briefcase st-icon-briefcase\"></i></span><span class=\"st-form__list__item\">{{vm.amend.transfers[0].vehicle.max_passengers}}x <i class=\"st-icon--passengers st-icon-passengers\"></i></span>\n                                    <span class=\"st-form__list__item\">  <a href uib-tooltip-html=\"'{{vm.translations.more_info_desc}}'\">{{vm.translations.more_info}}</a></span>\n                                </p>\n                            </div>\n                            <div class=\"st-form__list--service\">\n                                <div class=\"st-form__panel__info\">\n                                    <div class=\"panel-body\">\n                                        {{ vm.translations.msg_4 }}\n                                        <a id=\"contact_cs_upgrade_vehicle\" href ng-click=\"vm.openChat()\">{{ vm.translations.msg_4_link }}</a>\n                                        {{ vm.translations.msg_4_end }}\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <!-- Gold Protection -->\n            <div class=\"st-form__vehicle\" \n            ng-init=\"collapsed_gold = true\"\n            ng-if=\"vm.showGoldProtection\">\n               <hr class=\"st-form__hr\">\n            <div class=\"st-form__list--titles\" ng-click=\"collapsed_gold = !collapsed_gold\">\n             <a href=\"#\"\n                        class=\"st-form__toggle--open st-icon-plus\"\n                        ng-class=\"collapsed_gold ? 'st-icon-plus' : 'st-icon-minus'\"\n                        ></a>\n\n                    <h3 class=\"st-form__title\">Gold Protection</h3>\n                </div>\n                <div class=\"st-form__list--content\"\n                    ng-class=\"collapsed_gold ? 'st-form__list--content--collapsed' : 'st-form__list--content'\">\n                    <div class=\"st-form__item\">\n                        <div class=\"m-highlightExtra\">\n                            <div class=\"m-highlightExtra__container\">\n                                <div class=\"m-highlightExtra__item\">\n                                    <!--Remove this item if the image is not required-->\n                                    <img class=\"m-highlightExtra__image\"\n                                        ng-src=\"{{:: vm.amend.gold_protection && 'https://worldwide-cdn.suntransfers.com/st-assets/icon/solid/i-gold-protection.svg' || 'https://worldwide-cdn.suntransfers.com/st-assets/icon/solid/i-gold-protection--added.svg'}}\"\n                                        alt=\"Gold Protection\">\n                                </div>\n                                <div class=\"m-highlightExtra__item\">\n                                    <div class=\"m-highlightExtra__title\" ng-if=\"::vm.amend.gold_protection\">\n                                        {{vm.translations.gp_new_title_1}}\n                                    </div>\n                                    <div class=\"m-highlightExtra__title\" ng-if=\"::!vm.amend.gold_protection\">\n                                        {{vm.translations.gp_new_title}}\n                                        <span class=\"m-highlightExtra__price\"> {{vm.translations.gp_price}}</span>\n                                    </div>\n                                    <div class=\"m-highlightExtra__subtitle\">\n                                       {{vm.translations.gp_new_exp}}\n                                    </div>\n                                    <div class=\"a-iconList\">\n                                        <ul class=\"a-iconList__container\">\n                                            <li clas=\"a-iconList__item\">\n                                                <span class=\"a-iconList__icon st-glyphicon--check\"></span>\n                                                <span class=\"a-iconList__text\"> {{vm.translations.gp_new_point1}}</span>\n                                            </li>\n                                            <li clas=\"a-iconList__item\">\n                                                <span class=\"a-iconList__icon st-glyphicon--check\"></span>\n                                                <span class=\"a-iconList__text\"> {{vm.translations.gp_new_point2}}</span>\n                                            </li>\n                                        </ul>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"st-form__checkbox\">\n                            <div class=\"a-checkbox\">\n                                <div class=\"a-checkbox__container\">\n                                    <div class=\"a-checkbox__item\"\n                                        ng-if=\"::!vm.amend.gold_protection\">\n                                        <input id=\"checkbox_gp\"\n                                            class=\"a-checkbox__input\"\n                                            ng-model=\"vm.amend.gold_protection_check\"\n                                            type=\"checkbox\">\n                                        <label class=\"a-checkbox__label\"\n                                            for=\"checkbox_gp\">\n                                            <span class=\"a-checkbox__text\">{{vm.translations.gp_add}} {{vm.translations.gp_price}}</span>\n                                        </label>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <hr class=\"st-form__hr\">\n            <!--/ End Gold Protection -->\n            <div class=\"st-form__email-address\"\n                ng-init=\"collapsed_email = true\">\n\n                <div class=\"st-form__list--titles\" ng-click=\"collapsed_email = !collapsed_email\">\n                    <a href=\"#\"\n                        class=\"st-form__toggle--open st-icon-plus\"\n                        ng-class=\"collapsed_email ? 'st-icon-plus' : 'st-icon-minus'\"\n                        ></a>\n\n                    <h3 class=\"st-form__title\">{{vm.translations.amend_send_confirmation_title}}</h3>\n                </div>\n                <div class=\"st-form__list--content\"\n                    ng-class=\"collapsed_email ? 'st-form__list--content--collapsed' : 'st-form__list--content'\">\n                    <div class=\"st-form__item\">\n                        <span class=\"st-form__label--required\">{{vm.translations.gad_email}}</span>\n                        <input name=\"customerEmail\"\n                            type=\"email\"\n                            ng-model=\"vm.amend.customer.email\"\n                            ng-pattern=\"/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/\"\n                            ng-class=\"amendForm.customerEmail.$valid ? 'st-form__input' : 'st-form__input--error'\"\n                            required>\n                        <!--\n                        <div ng-messages=\"amendForm.customerEmail.$error\">\n                            <div ng-message=\"pattern\"\n                                class=\"alert alert-danger\">Please enter a valid email address!</div>\n                            <div ng-message=\"required\"\n                                class=\"alert alert-danger\">Please enter a email address!</div>\n                        </div>\n                        -->\n                    </div>\n                </div>\n            </div>\n            <hr class=\"st-form__hr\">\n            <div class=\"st-form__lead-passenger\"\n                ng-init=\"collapsed_lead = true\">\n                <div class=\"st-form__list--titles\" ng-click=\"collapsed_lead = !collapsed_lead\">\n                    <a href=\"#\"\n                        class=\"st-form__toggle--open st-icon-plus\"\n                        ng-class=\"collapsed_lead ? 'st-icon-plus' : 'st-icon-minus'\"></a>\n                    <h3 class=\"st-form__title\">{{vm.translations.subtitle_lead_passenger}}</h3>\n                </div>\n                <div class=\"st-form__list--content\"\n                    ng-class=\"collapsed_lead ? 'st-form__list--content--collapsed' : 'st-form__list--content'\">\n                    <div class=\"st-form__item\">\n                        <div class=\"st-form__list-group\">\n                            <div class=\"st-form__list--first-name\">\n                                <span class=\"st-form__label--required\">{{vm.translations.option_name}}</span>\n                                <input name=\"leadFirstName\"\n                                    type=\"text\"\n                                    ng-model=\"vm.amend.lead_passenger.first_name\"\n                                    ng-class=\"amendForm.leadFirstName.$valid ? 'st-form__input' : 'st-form__input--error'\"\n                                    required>\n                                <!--\n                                <div ng-messages=\"amendForm.leadFirstName.$error\">\n                                    <div ng-message=\"required\"\n                                        class=\"alert alert-danger\">You did not enter a field</div>\n                                </div>\n                                -->\n                            </div>\n                            <div class=\"st-form__list--last-name\">\n                                <span class=\"st-form__label--required\">{{vm.translations.option_family_name}}</span>\n                                <input type=\"text\"\n                                    name=\"leadFamilyName\"\n                                    class=\"st-form__input\"\n                                    ng-model=\"vm.amend.lead_passenger.family_name\"\n                                    ng-class=\"amendForm.leadFamilyName.$valid ? 'st-form__input' : 'st-form__input--error'\"\n                                    required>\n                                <!--\n                                <div ng-messages=\"amendForm.leadFamilyName.$error\">\n                                    <div ng-message=\"required\"\n                                        class=\"alert alert-danger\">You did not enter a field</div>\n                                </div>\n                                -->\n                            </div>\n                        </div>\n                    </div>\n                    <!-- @ST-COMPONENT -->\n                    <st-prefixes data=\"vm.amend.lead_passenger\"></st-prefixes>\n                    <div class=\"st-form__item\">\n                        <span class=\"ammendform__text\">SMS: {{ vm.translations.smsText }}</span>\n                    </div>\n                </div>\n            </div>\n            <hr class=\"st-form__hr\">\n            <!-- transfers -->\n            <div class=\"st-form__transfers\"\n                ng-repeat=\"transfer in vm.amend.transfers\"\n                ng-if=\"transfer.flags.isActive\"\n                ng-init=\"collapsed_$index = true\">\n                <div class=\"st-form__transfer--collapsed\"\n                    ng-class=\"collapsed_$index ? 'st-form__transfer--collapsed' : 'st-form__transfer'\">\n                    <div class=\"st-form__list--titles\" ng-click=\"collapsed_$index = !collapsed_$index\">\n                        <a href=\"#\"\n                            class=\"st-form__toggle--collapsed st-icon-plus\"\n                            ng-class=\"collapsed_$index ? 'st-icon-plus' : 'st-icon-minus'\"\n                            ></a>\n                        <h3 class=\"st-form__title\"\n                            translate=\"transfer_num\"\n                            translate-value-num=\"{{transfer.position}}\"></h3>\n                        <h3 class=\"st-form__title\"\n                            translate=\"dep_arr\"\n                            translate-value-departure=\"{{transfer.from.data.location_name}}\"\n                            translate-value-arrival=\"{{transfer.to.data.location_name}}\"></h3>\n                    </div>\n                    <div class=\"st-form__list--content\"\n                        ng-if=\"transfer.flags.isEditable\">\n                        <!-- @ST-COMPONENT :LOCATION -->\n                        <st-location direction=\"from\"\n                            transfer=\"transfer\"\n                            editable=\"true\"></st-location>\n                        <st-location direction=\"to\"\n                            transfer=\"transfer\"\n                            editable=\"true\"></st-location>\n                        <!-- END LOCATION -->\n                        <!-- @ST-COMPONENT :PASSENGER -->\n                        <st-passengers data=\"transfer\"\n                            index=\"transfer.position\"\n                            editable=\"true\"></st-passengers>\n                        <!-- @ST-COMPONENT :EXTRAS -->\n                        <st-extras ng-if=\"transfer.extras.length\"\n                            index=\"transfer.position\"\n                            data=\"transfer.extras\"></st-extras>\n                    </div>\n                    <div class=\"st-form__list--content\"\n                        ng-if=\"transfer.flags.isAfterFreeSaleDeadLine\">\n                        {{ vm.translations.too_late_edit_transfer }}\n                    </div>\n                </div>\n                <hr class=\"st-form__hr\">\n            </div>\n            <div class=\"st-form__context\">\n                <span class=\"st-form__item__text\">\n                            {{vm.translations.terms_and_conditions_note}}\n                            <a href=\"{{vm.terms_and_conditions_note_href}}\" target=\"_blank\">{{vm.translations.terms_and_conditions_note_link}}</a>\n                            {{vm.translations.terms_and_conditions_note_end}}\n                        </span>\n                <button class=\"st-form__button\"\n                    type=\"submit\">{{vm.translations.button_confirm_changes}}\n                </button>\n            </div>\n        </form>\n    </div>\n</div>\n"

/***/ },
/* 123 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var amendController = (function () {
	    amendController.$inject = ["$translate", "$state", "$stateParams", "$location", "$anchorScroll", "$filter", "myBookingService", "cacheService", "sharedService", "CONFIG"];
	    function amendController($translate, $state, $stateParams, $location, $anchorScroll, $filter, myBookingService, cacheService, sharedService, CONFIG) {
	        'ngInject';
	
	        _classCallCheck(this, amendController);
	
	        this.$translate = $translate;
	        this.$state = $state;
	        this.$stateParams = $stateParams;
	        this.$location = $location;
	        this.$anchorScroll = $anchorScroll;
	        this.$filter = $filter;
	        this.myBookingService = myBookingService;
	        this.cacheService = cacheService;
	        this.sharedService = sharedService;
	        this.languages = CONFIG.languages;
	        this.name = 'amend';
	        this.showGoldProtection = false;
	        this.TRANSFER_STATUS_ACTIVE = 'active';
	    }
	
	    _createClass(amendController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.translations = this.$translate.instant(["modify_booking_details", "modify_booking_details_2", "modify_booking_details_3", "content_title_amend", "msg_2", "type_taxi", "type_minivan", "type_minibus", "type_coach", "type_minicoach", "type_shuttle", "type_vip_car", "type_premium_minivan", "type_premium_taxi", "type_premium_minibus", "type_premium_minicoach", "type_city_taxi", "model_premium_taxi", "model_premium_minivan", "model_premium_minibus", "model_premium_minicoach", "model_vip_car", "more_info", "gad_email", "amend_send_confirmation_title", "subtitle_lead_passenger", "option_name", "option_family_name", "bar_transfers", "tab_title_amend", "dep_arr", "SMS_answer_1", "SMS_answer_2", "SMS_answer3", "label_vehicle", "label_title", "label_max", "msg_4", "title_1", "title_2", "title_3", "title_4", "vehicles_instructions", "vehicles_availability", "too_late_edit_transfer", "transfer_completed", "button_confirm_changes", "is_cancelled", "gp_add", "gp_new_title", "gp_new_title_1", "gp_new_exp", "gp_new_point1", "gp_new_point2", "gp_price", "err_fillall"]);
	            //TODO Clean up when we have correct segment
	            angular.merge(this.translations, this.$filter('splitTranslationWithLink')('msg_4', {
	                link_start: '%LINK_START%',
	                link_end: '%LINK_END%'
	            }));
	
	            angular.merge(this.translations, this.$filter('splitTranslationWithLink')('terms_and_conditions_note', {
	                link_start: '<a>',
	                link_end: '</a>'
	            }));
	
	            this.translations.too_late_edit_transfer = this.$translate.instant("too_late_edit_transfer", {
	                hours: this.amend.transfers[0].free_sale_deadline_check.free_sale_deadline_in_hours
	            });
	
	            //TODO Use languageService
	            var language = this.languages[this.$translate.use()];
	            this.terms_and_conditions_note_href = 'http://www.suntransfers.com' + (language.key == 'en' ? '/' : '/' + language.key + '/') + 'terms-and-conditions';
	
	            if (this.amend !== null) {
	                var vehicle = this.amend.transfers[0].vehicle;
	                var vehicleInfo = {
	                    'private': this.getPrivateMoreInfo,
	                    'shared': this.getSharedMoreInfo
	                };
	
	                vehicleInfo[vehicle.service_type].call(this, vehicle);
	
	                this.lead_passenger_title = {
	                    "Mr": this.translations.title_1,
	                    "Mrs": this.translations.title_2,
	                    "Miss": this.translations.title_3,
	                    "Ms": this.translations.title_4
	                };
	
	                this.lead_passenger_titleInverted = {};
	                for (var idx in this.lead_passenger_title) {
	                    this.lead_passenger_titleInverted[this.lead_passenger_title[idx]] = idx;
	                }
	
	                this.amend.lead_passenger.title = ' '; // this.lead_passenger_titleInverted[this.amend.lead_passenger.title];
	
	                var smsTranslationKeys = {
	                    "no": this.translations.SMS_answer_1,
	                    "only voucher": this.translations.SMS_answer_2,
	                    "voucher +24h": this.translations.SMS_answer3
	                };
	
	                this.booking.translations.mainTitleKey = this.translations.content_title_amend;
	                this.translations.smsText = smsTranslationKeys[this.amend.send_sms_type];
	
	                this.amend.transfers = this.addTransferFlags(this.amend.transfers);
	                this.showGoldProtection = this.setShowGoldProtection(this.amend);
	            }
	        }
	    }, {
	        key: 'setShowGoldProtection',
	        value: function setShowGoldProtection(booking) {
	            var showGoldProtection = booking.transfers.some(function (element) {
	                return element.flags.isActive && element.flags.isEditable && element.from.type == 'airport' && booking.gold_protection;
	            });
	            return showGoldProtection;
	        }
	    }, {
	        key: 'addTransferFlags',
	        value: function addTransferFlags(transfers) {
	            var _this = this;
	
	            return transfers.map(function (transfer) {
	                transfer.flags = {
	                    isActive: transfer.status === _this.TRANSFER_STATUS_ACTIVE,
	                    isEditable: transfer.free_sale_deadline_check.is_valid,
	                    isAfterFreeSaleDeadLine: !transfer.free_sale_deadline_check.is_valid
	                };
	                return transfer;
	            });
	        }
	    }, {
	        key: 'getSharedMoreInfo',
	        value: function getSharedMoreInfo(vehicle) {
	            var isStandardShuttle = vehicle.type == 'sh';
	
	            this.translations.more_info_desc = this.$translate.instant('desc_shared', {
	                num_luggage: vehicle.max_luggage,
	                //TODO Retrun num_hand_luggage from BE
	                num_hand_luggage: vehicle.max_luggage
	            });
	
	            if (this.translations['model_' + vehicle.type]) {
	                this.translations.more_info_desc += '<p>' + this.translations['model_' + vehicle.type] + '</p>';
	            }
	
	            this.translations.more_info_desc += '<p>';
	            this.translations.more_info_desc += this.$translate.instant('description_shared_1', {
	                num_stops: isStandardShuttle ? 10 : 4
	            });
	
	            this.translations.more_info_desc += ' ' + this.$translate.instant('description_shared_2', {
	                max_time: isStandardShuttle ? 45 : 30
	            });
	            this.translations.more_info_desc += '</p>';
	
	            this.translations.more_info_desc += '<p>' + this.translations.vehicles_instructions + '</p>';
	        }
	    }, {
	        key: 'getPrivateMoreInfo',
	        value: function getPrivateMoreInfo(vehicle) {
	            this.translations.more_info_desc = this.$translate.instant('desc_private', {
	                vehicle_title: this.translations['type_' + vehicle.type],
	                n1: vehicle.max_passengers,
	                n2: vehicle.max_luggage
	            });
	
	            if (this.translations['model_' + vehicle.type]) {
	                this.translations.more_info_desc += '<p>' + this.translations['model_' + vehicle.type] + '</p>';
	            }
	
	            this.translations.more_info_desc += '<p>' + this.translations.vehicles_instructions + '</p>';
	            this.translations.more_info_desc += '<p>' + this.translations.vehicles_availability + '</p>';
	        }
	    }, {
	        key: 'range',
	        value: function range(num) {
	            var arr = new Array(num);
	            for (var i = 0; i < arr.length; i++) {
	                arr[i] = i + 1;
	            }
	            return arr;
	        }
	    }, {
	        key: 'save',
	        value: function save(isUntouchedForm) {
	            var _this2 = this;
	
	            this.cacheService.set('statusAmendUpdated', !isUntouchedForm);
	            this.myBookingService.saveAmend(this.$stateParams.bookingReference, this.dataToSaveTransformer(this.amend)).then(function (response) {
	                if (!_this2.amend.gold_protection && _this2.amend.gold_protection_check) {
	                    var reference = _this2.cacheService.get('bookingReference');
	                    _this2.$state.go('bookings.booking.goldupgrade', {
	                        bookingReference: reference
	                    });
	                } else {
	                    _this2.$state.reload();
	                }
	            })['catch'](function (error) {});
	        }
	    }, {
	        key: 'dataToSaveTransformer',
	        value: function dataToSaveTransformer(amend) {
	            var _this3 = this;
	
	            var myAmend = angular.copy(amend);
	            var dateFormat = "yyyy-MM-dd HH:mm:ss";
	            var dateFormatter = function dateFormatter(field, format) {
	                return field ? _this3.$filter('date')(field, format) : null;
	            };
	
	            //Reformat Phone prefix -> stPrefixes.controller removePrefix()
	            var mobile_phone_prefix = myAmend.lead_passenger.mobile_phone_prefix ? myAmend.lead_passenger.mobile_phone_prefix + " " : '';
	            myAmend.lead_passenger.mobile_phone = mobile_phone_prefix + myAmend.lead_passenger.mobile_phone;
	            delete myAmend.lead_passenger.mobile_phone_prefix;
	
	            //Return translated Lead passenger title
	            myAmend.lead_passenger.title = ' '; // this.lead_passenger_title[myAmend.lead_passenger.title];
	
	            myAmend.transfers = myAmend.transfers.map(function (transfer) {
	                delete transfer.flags;
	
	                transfer.latest_pickup_time = dateFormatter(transfer.latest_pickup_time, dateFormat);
	                transfer.pickup_time = dateFormatter(transfer.pickup_time, dateFormat);
	
	                angular.forEach(['to', 'from'], function (legId) {
	                    var leg = transfer[legId];
	                    angular.forEach(['flight_datetime', 'train_datetime', 'cruise_datetime'], function (key) {
	                        leg.data[key] = dateFormatter(leg.data[key], dateFormat);
	                    });
	                });
	
	                angular.forEach(['airline', 'origin_airport'], function (key) {
	                    transfer['from'].data[key] = transfer['from'].data[key] === '' ? 'NOT_PROVIDED' : transfer['from'].data[key];
	                });
	
	                return transfer;
	            });
	
	            return myAmend;
	        }
	    }, {
	        key: 'gotoCrcMessage',
	        value: function gotoCrcMessage() {
	            this.$location.hash('crc_alert');
	            this.$anchorScroll();
	        }
	    }, {
	        key: 'openChat',
	        value: function openChat() {
	            var chat = document.querySelector('.inbenta-launcher');
	            if (chat) {
	                chat.click();
	            } else if (!document.querySelector('.inbenta-avatar')) {
	                zE.activate();
	            }
	            return false;
	        }
	    }]);
	
	    return amendController;
	})();
	
	exports['default'] = amendController;
	module.exports = exports['default'];

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularUiBootstrap = __webpack_require__(4);
	
	var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);
	
	var _cancelComponent = __webpack_require__(125);
	
	var _cancelComponent2 = _interopRequireDefault(_cancelComponent);
	
	var _commonStModalStModal = __webpack_require__(128);
	
	var _commonStModalStModal2 = _interopRequireDefault(_commonStModalStModal);
	
	var cancelModule = _angular2['default'].module('cancel', [_angularUiRouter2['default'], _angularUiBootstrap2['default'], _commonStModalStModal2['default']]).config(["$stateProvider", function ($stateProvider) {
	    "ngInject";
	    $stateProvider.state('bookings.booking.cancel', {
	        url: '/cancel',
	        resolve: {
	            data: ["myBookingService", "$stateParams", "$q", "authService", "$state", function data(myBookingService, $stateParams, $q, authService, $state) {
	                return $q.all({
	                    amend: myBookingService.getAmend($stateParams.bookingReference),
	                    cancel: myBookingService.getCancel($stateParams.bookingReference)
	                }).then(function (result) {
	                    for (var id in result.cancel.transfers) {
	                        _angular2['default'].merge(result.cancel.transfers[id], result.amend.transfers[id]);
	                    }
	                    return result.cancel;
	                }, function (error) {
	                    if (error.status === 401) {
	                        authService.clearSession();
	                        $state.go('auth.login');
	                    }
	                    return null;
	                });
	            }]
	        },
	        views: {
	            'booking@bookings.booking': {
	                template: '<cancel cancel="$resolve.data"></cancel>'
	            }
	        }
	    });
	}]).component('cancel', _cancelComponent2['default']).name;
	
	exports['default'] = cancelModule;
	module.exports = exports['default'];

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _cancelHtml = __webpack_require__(126);
	
	var _cancelHtml2 = _interopRequireDefault(_cancelHtml);
	
	var _cancelController = __webpack_require__(127);
	
	var _cancelController2 = _interopRequireDefault(_cancelController);
	
	var cancelComponent = {
	    restrict: 'E',
	    require: {
	        booking: '^booking'
	    },
	    bindings: {
	        cancel: '<'
	    },
	    template: _cancelHtml2['default'],
	    controller: _cancelController2['default'],
	    controllerAs: 'vm'
	};
	
	exports['default'] = cancelComponent;
	module.exports = exports['default'];

/***/ },
/* 126 */
/***/ function(module, exports) {

	module.exports = "<div class=\"st-form--static\" ng-if=\"vm.cancel === null\">\n    <div class=\"m-summary\">\n        <div class=\"m-summary__container\">\n            <div class=\"m-summary__item\">\n                <div class=\"m-summary__headline\">\n                    <h2 class=\"m-summary__title ng-binding\">We are experiencing technical problems.</h2>\n                    <div class=\"m-summary__description ng-binding\">Please try again later or contact us via live text\n                        chat. Sorry for the inconvenience.\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"m-information-tab\" ng-show=\"vm.is_there_flash_message\">\n    <div ng-class=\"{'m-information-tab__container--error': vm.cancelResponseMessage.status === 'error', 'm-information-tab__container': vm.cancelResponseMessage.status === 'success'}\">\n        <div class=\"m-information-tab__icon\">\n            <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"i-confirm-rounded\" width=\"27\" height=\"27\" ng-if=\"vm.cancelResponseMessage.status === 'success'\">\n                <path fill=\"#31B143\" fill-rule=\"nonzero\" d=\"M0 13.5C0 21 6 27 13.5 27S27 21 27 13.5 21 0 13.5 0 0 6 0 13.5zm19.6-3L11 18.8s0 .2-.2.2-.4 0-.4-.2l-4-4.2H6L6 14l.2-.2.7-.7h.6l3 3c0 .2.3.2.4 0l7-6.8c.4-.2.7-.2 1 0l.6.7c.2 0 .2.3 0 .5z\"></path>\n            </svg>\n            <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"i-cross-rounded\" width=\"27\" height=\"27\" ng-if=\"vm.cancelResponseMessage.status === 'error'\">\n                <path fill=\"#ED3861\" fill-rule=\"evenodd\" d=\"M18.6 18.6c-.5.6-1.4.6-2 0l-3-3-3.2 3.2c-.6.5-1.5.5-2 0-.5-.6-.5-1.4 0-2l3.2-3.2-3-3c-.5-.5-.5-1.4 0-2 .6-.5 1.4-.5 2 0l3 3L16.4 9c.6-.5 1.4-.5 2 0 .5.6.5 1.4 0 2l-3 2.8 3.2 3c.5.6.5 1.5 0 2M13.6 0C6 0 0 6 0 13.5S6 27 13.5 27 27 21 27 13.5 21 0 13.5 0\"></path>\n            </svg>\n        </div>\n        <div class=\"m-information-tab__text\">{{vm.translations[vm.cancelResponseMessage.message] || vm.cancelResponseMessage.message}}</div>\n    </div>\n</div>\n<div class=\"st-form--static\" ng-if=\"vm.cancel !== null\">\n    <div ng-if=\"vm.booking.data.status_cancel == vm.booking.STATUS_PENDING_CRC\" class=\"st-form__placeholder\">\n        <p class=\"st-form__placeholder__text\">{{vm.translations.msg_2}}</p>\n    </div>\n    <div ng-if=\"vm.booking.data.status_cancel == vm.booking.STATUS_NOT_CANCELLABLE\" class=\"st-form__placeholder\">\n        <p class=\"st-form__placeholder__text\" ng-bind-html=\"vm.translations.no_credit_card_note\"></p>\n    </div>\n    <div ng-if=\"vm.booking.data.status_cancel == vm.booking.STATUS_OK\">\n        <div class=\"st-form__cancel-booking\" ng-if=\"vm.canCancelAllBooking()\">\n            <div class=\"st-form__list--titles\" ng-click=\"collapsed_vehicle = !collapsed_vehicle\">\n                <a href=\"#\"\n                   class=\"st-form__toggle--open st-icon-plus\"\n                   ng-class=\"collapsed_vehicle ? 'st-icon-plus' : 'st-icon-minus'\"></a>\n                <h3 class=\"st-form__title\">{{vm.translations.button_cancel_booking}}</h3>\n            </div>\n            <div class=\"st-form__list--content\"\n                 ng-class=\"collapsed_vehicle ? 'st-form__list--content--collapsed' : 'st-form__list--content'\">\n                <span class=\"st-form__item__text\">{{vm.translations.cancel_all_transfers_note}}</span>\n                <button class=\"st-form__button--danger\" ng-disabled=\"vm.disabled\" type=\"submit\" ng-click=\"vm.cancelBooking()\">\n                    {{vm.translations.button_cancel_booking}}\n                </button>\n            </div>\n        </div>\n        <div ng-repeat=\"transfer in vm.cancel.transfers\"\n             ng-if=\"transfer.flags.isActive\"\n             ng-init=\"collapsed_$index = true\">\n            <hr class=\"st-form__hr\">\n            <div class=\"st-form__transfer--collapsed\"\n                 ng-class=\"collapsed_$index ? 'st-form__transfer--collapsed' : 'st-form__transfer'\">\n                <div class=\"st-form__list--titles\" ng-click=\"collapsed_$index = !collapsed_$index\">\n                    <a href=\"#\"\n                       class=\"st-form__toggle--collapsed st-icon-plus\"\n                       ng-class=\"collapsed_$index ? 'st-icon-plus' : 'st-icon-minus'\"\n                    ></a>\n                    <h3 class=\"st-form__title\" translate=\"transfer_num\" translate-value-num=\"{{$index+1}}\"></h3>\n                    <h3 class=\"st-form__title\" translate=\"dep_arr\"\n                        translate-value-departure=\"{{transfer.from.data.location_name}}\"\n                        translate-value-arrival=\"{{transfer.to.data.location_name}}\"></h3>\n                </div>\n                <div class=\"st-form__list--content\">\n\n                    <!-- LOCATION -->\n                    <st-location direction=\"from\"\n                                 transfer=\"transfer\"\n                                 editable=\"false\"></st-location>\n\n                    <st-location direction=\"to\"\n                                 transfer=\"transfer\"\n                                 editable=\"false\"></st-location>\n                    <!-- END LOCATION -->\n\n                    <!-- PASSENGER -->\n                    <st-passengers\n                            data=\"transfer\"\n                            index=\"$index\"\n                            editable=\"false\"></st-passengers>\n                    <!-- END PASSENGER -->\n                    <div ng-if=\"vm.isTransferCancellable($index)\">\n                        <span class=\"st-form__item__text\">{{ $index == 0 ? vm.translations.cancel_note_transfer_1 : vm.translations.cancel_note_transfer_2; }}</span>\n                        <button class=\"st-form__button--danger\" type=\"submit\"\n                                translate=\"button_cancel_transfer_n\" translate-value-n=\"{{$index+1}}\"\n                                ng-disabled=\"vm.disabled\"\n                                ng-click=\"vm.cancelTransfer(transfer)\"></button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ },
/* 127 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var cancelController = (function () {
	    cancelController.$inject = ["$state", "$stateParams", "$translate", "$uibModal", "cacheService", "myBookingService"];
	    function cancelController($state, $stateParams, $translate, $uibModal, cacheService, myBookingService) {
	        'ngInject';
	
	        _classCallCheck(this, cancelController);
	
	        this.name = 'cancel';
	        this.$state = $state;
	        this.$stateParams = $stateParams;
	        this.$translate = $translate;
	        this.$uibModal = $uibModal;
	        this.myBookingService = myBookingService;
	        this.is_there_flash_message = false;
	        this.disabled = false;
	        var cancelResponse = undefined;
	        this.cancelResponseMessage = {};
	        this.cacheService = cacheService;
	        this.TRANSFER_STATUS_ACTIVE = 'active';
	        this.TRANSFER_STATUS_CANCELLED = 'cancelled';
	        this.TRANSFER_STATUS_COMPLETED = 'completed';
	
	        this.numActiveTransfers = this.getNumOfActiveTransfers();
	
	        if (cancelResponse = cacheService.get('cancelResponse')) {
	            this.showConfirmCancelMessage(cancelResponse.status, cancelResponse.message);
	            this.is_there_flash_message = true;
	            cacheService['delete']('cancelResponse');
	        }
	    }
	
	    _createClass(cancelController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.translations = this.$translate.instant(["content_title_cancel", "msg_2", "no_credit_card_note", "button_cancel_booking", "button_cancel_transfer_n", "cancel_all_transfers_note", "cancel_note_transfer_1", "cancel_note_transfer_2", "sure_for_cancel_note", "less_than_24_note", "sure_cancel_booking_note", "less_than_24_booking_note", "yes_cancel_transfer_n", "no_cancel_transfer_n", "yes_cancel_all_transfers", "no_cancel_all_transfers", "booking_cancellation_json", "transfer_cancellation_json"]);
	
	            this.booking.translations.mainTitleKey = this.translations.content_title_cancel;
	            if (this.cancel !== null) {
	                this.cancel.transfers = this.addTransferFlags(this.cancel.transfers);
	            }
	        }
	
	        // TODO move to a service
	    }, {
	        key: 'addTransferFlags',
	        value: function addTransferFlags(transfers) {
	            var _this = this;
	
	            return transfers.map(function (transfer) {
	                transfer.flags = {
	                    isActive: transfer.status === _this.TRANSFER_STATUS_ACTIVE
	                };
	                return transfer;
	            });
	        }
	    }, {
	        key: 'cancelBooking',
	        value: function cancelBooking() {
	            var _this2 = this;
	
	            this.disabled = true;
	            this.myBookingService.postCancelBooking(this.$stateParams.bookingReference).then(function (response) {
	                _this2.$state.reload();
	                _this2.cacheService.set('cancelResponse', { status: 'success', message: _this2.translations.booking_cancellation_json });
	            })['catch'](function (err) {
	                //TODO: add literal
	                _this2.disabled = false;
	                _this2.cacheService.set('cancelResponse', { status: 'error', message: 'Error Booking Message' });
	            });
	        }
	    }, {
	        key: 'cancelTransfer',
	        value: function cancelTransfer(transfer) {
	            var _this3 = this;
	
	            this.disabled = true;
	            this.myBookingService.postCancelTransfer(this.$stateParams.bookingReference, transfer.id).then(function (response) {
	                _this3.$state.reload();
	                _this3.cacheService.set('cancelResponse', { status: 'success', message: _this3.translations.transfer_cancellation_json });
	            })['catch'](function (err) {
	                //TODO: add literal
	                _this3.disabled = false;
	                _this3.cacheService.set('cancelResponse', { status: 'error', message: 'Error Transfer Message' });
	            });
	        }
	    }, {
	        key: 'cancelPopup',
	        value: function cancelPopup(_title, _message) {
	            return this.openComponentModal({
	                title: function title() {
	                    return _title;
	                },
	                message: function message() {
	                    return _message;
	                }
	            });
	        }
	    }, {
	        key: 'getCancelTransferConfirmationMessage',
	        value: function getCancelTransferConfirmationMessage(transfer) {
	            return transfer.free_cancellation ? this.translations.sure_for_cancel_note : this.translations.less_than_24_note;
	        }
	    }, {
	        key: 'getCancelBookingConfirmationMessage',
	        value: function getCancelBookingConfirmationMessage() {
	
	            var transfers = this.cancel.transfers;
	
	            if (this.numActiveTransfers === 1) {
	                return this.getCancelTransferConfirmationMessage(this.getActiveTransfer()[0]);
	            }
	
	            if (transfers[0].free_cancellation && transfers[1].free_cancellation) {
	                return this.translations.sure_cancel_booking_note;
	            }
	
	            if (!transfers[0].free_cancellation && !transfers[1].free_cancellation) {
	                return this.translations.less_than_24_booking_note;
	            }
	
	            if (!transfers[0].free_cancellation && transfers[1].free_cancellation) {
	                var transfer_num_1 = this.$translate.instant('transfer_num', {
	                    num: 1
	                });
	                var transfer_num_2 = this.$translate.instant('transfer_num', {
	                    num: 2
	                });
	                return '\n                ' + transfer_num_1 + ':' + this.getCancelTransferConfirmationMessage(transfers[0]) + '\n                ' + transfer_num_2 + ':' + this.getCancelTransferConfirmationMessage(transfers[1]) + '\n            ';
	            }
	        }
	    }, {
	        key: 'canCancelAllBooking',
	        value: function canCancelAllBooking() {
	            var transfers = this.cancel.transfers;
	            if (this.isTransferOneCompleted(transfers)) {
	                return false;
	            }
	
	            return this.areBothTransfersActive(transfers) || this.isAnyOfTheTransfersCancelledAndTheOtherActive(transfers) || this.thereIsOnlyTransferOneAndIsActive(transfers);
	        }
	    }, {
	        key: 'thereIsOnlyTransferOneAndIsActive',
	        value: function thereIsOnlyTransferOneAndIsActive(transfers) {
	            return transfers.length === 1 && transfers[0].flags.isActive;
	        }
	    }, {
	        key: 'isAnyOfTheTransfersCancelledAndTheOtherActive',
	        value: function isAnyOfTheTransfersCancelledAndTheOtherActive(transfers) {
	            return transfers.length === 2 && (transfers[0].status === this.TRANSFER_STATUS_CANCELLED && transfers[1].flags.isActive || transfers[1].status === this.TRANSFER_STATUS_CANCELLED && transfers[0].flags.isActive);
	        }
	    }, {
	        key: 'isTransferOneCompleted',
	        value: function isTransferOneCompleted(transfers) {
	            return transfers[0].status === this.TRANSFER_STATUS_COMPLETED;
	        }
	    }, {
	        key: 'isTransferCancellable',
	        value: function isTransferCancellable(index) {
	            var transfers = this.cancel.transfers;
	
	            return this.areBothTransfersActive(transfers) || this.isFirstTransferCompletedAndThisOneActive(transfers, index);
	        }
	    }, {
	        key: 'isFirstTransferCompletedAndThisOneActive',
	        value: function isFirstTransferCompletedAndThisOneActive(transfers, index) {
	            return transfers[0].status === this.TRANSFER_STATUS_COMPLETED && transfers[index].flags.isActive;
	        }
	    }, {
	        key: 'areBothTransfersActive',
	        value: function areBothTransfersActive(transfers) {
	            return transfers.length === 2 && transfers[0].flags.isActive && transfers[1].flags.isActive;
	        }
	    }, {
	        key: 'openComponentModal',
	        value: function openComponentModal(resolve) {
	            var modalInstance = this.$uibModal.open({
	                animation: false,
	                component: 'stModal',
	                resolve: resolve || {}
	            });
	
	            return modalInstance.result;
	        }
	    }, {
	        key: 'getNumOfActiveTransfers',
	        value: function getNumOfActiveTransfers() {
	            return this.getActiveTransfer().length;
	        }
	    }, {
	        key: 'getActiveTransfer',
	        value: function getActiveTransfer() {
	            var _this4 = this;
	
	            if (this.cancel !== null) {
	                return this.cancel.transfers.filter(function (item) {
	                    return item.status == _this4.TRANSFER_STATUS_ACTIVE;
	                });
	            } else return [];
	        }
	    }, {
	        key: 'showConfirmCancelMessage',
	        value: function showConfirmCancelMessage($errorType, $cancelMessage) {
	            this.is_there_flash_message = true;
	            document.body.scrollTop = 0;
	            this.cancelResponseMessage = {
	                status: $errorType,
	                message: $cancelMessage
	            };
	        }
	    }]);
	
	    return cancelController;
	})();
	
	exports['default'] = cancelController;
	module.exports = exports['default'];

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _stModalComponent = __webpack_require__(129);
	
	var _stModalComponent2 = _interopRequireDefault(_stModalComponent);
	
	var stModalModule = _angular2['default'].module('stModal', [_angularUiRouter2['default']]).component('stModal', _stModalComponent2['default']).name;
	
	exports['default'] = stModalModule;
	module.exports = exports['default'];

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _stModalHtml = __webpack_require__(130);
	
	var _stModalHtml2 = _interopRequireDefault(_stModalHtml);
	
	var _stModalController = __webpack_require__(131);
	
	var _stModalController2 = _interopRequireDefault(_stModalController);
	
	var stModalComponent = {
	    restrict: 'E',
	    bindings: {
	        resolve: '<',
	        close: '&',
	        dismiss: '&'
	    },
	    template: _stModalHtml2['default'],
	    controller: _stModalController2['default'],
	    controllerAs: 'vm'
	};
	
	exports['default'] = stModalComponent;
	module.exports = exports['default'];

/***/ },
/* 130 */
/***/ function(module, exports) {

	module.exports = "<div class=\"modal-header\" ng-if=\"vm.title\">\n    <h3 class=\"modal-title\" id=\"modal-title\">{{vm.title}}</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" ng-bind-html=\"vm.message\">\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-danger\" type=\"button\" ng-click=\"vm.ok()\">{{ 'yes' | translate }}</button>\n    <button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.cancel()\">{{ 'no' | translate }}</button>\n</div>"

/***/ },
/* 131 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var StModalController = (function () {
	    function StModalController() {
	        'ngInject';
	
	        _classCallCheck(this, StModalController);
	
	        this.name = 'stModal';
	    }
	
	    _createClass(StModalController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.message = this.resolve.message || false;
	            this.title = this.resolve.title || false;
	        }
	    }, {
	        key: 'ok',
	        value: function ok() {
	            this.close({ $value: 'ok' });
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            this.dismiss({ $value: 'cancel' });
	        }
	    }]);
	
	    return StModalController;
	})();
	
	exports['default'] = StModalController;
	module.exports = exports['default'];

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _goldupgradeComponent = __webpack_require__(133);
	
	var _goldupgradeComponent2 = _interopRequireDefault(_goldupgradeComponent);
	
	var goldupgradeModule = _angular2['default'].module('goldupgrade', [_angularUiRouter2['default']]).config(["$stateProvider", function ($stateProvider) {
	    "ngInject";
	    $stateProvider.state('bookings.booking.goldupgrade', {
	        url: '/golpupgrade',
	        resolve: {
	            data: ["$stateParams", "$window", "myBookingService", "authService", "$state", function data($stateParams, $window, myBookingService, authService, $state) {
	                'ngInject';
	
	                var GOLDUPGRADE_STATUS_OK = 'ok';
	
	                return myBookingService.postGoldProtectionUpgrade($stateParams.bookingReference).then(function (booking) {
	                    if (booking.status == GOLDUPGRADE_STATUS_OK) {
	                        $window.location = booking.payment_url;
	                    } else {
	                        return booking.status;
	                    }
	                }, function (error) {
	                    if (error.status === 401) {
	                        authService.clearSession();
	                        $state.go('auth.login');
	                    }
	                    return null;
	                });
	            }]
	        },
	        views: {
	            'booking@bookings.booking': {
	                template: '<goldupgrade status="$resolve.data"></goldupgrade>'
	            }
	        }
	    });
	}]).component('goldupgrade', _goldupgradeComponent2['default']).name;
	
	exports['default'] = goldupgradeModule;
	module.exports = exports['default'];

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _goldupgradeHtml = __webpack_require__(134);
	
	var _goldupgradeHtml2 = _interopRequireDefault(_goldupgradeHtml);
	
	var _goldupgradeController = __webpack_require__(135);
	
	var _goldupgradeController2 = _interopRequireDefault(_goldupgradeController);
	
	var goldupgradeComponent = {
	    restrict: 'E',
	    require: {
	        "booking": "^booking"
	    },
	    bindings: {
	        "status": "<"
	    },
	    template: _goldupgradeHtml2['default'],
	    controller: _goldupgradeController2['default'],
	    controllerAs: "vm"
	};
	
	exports['default'] = goldupgradeComponent;
	module.exports = exports['default'];

/***/ },
/* 134 */
/***/ function(module, exports) {

	module.exports = "<div>\n\n</div>"

/***/ },
/* 135 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var GoldupgradeController = (function () {
	    GoldupgradeController.$inject = ["$translate"];
	    function GoldupgradeController($translate) {
	        'ngInject';
	
	        _classCallCheck(this, GoldupgradeController);
	
	        this.name = 'goldupgrade';
	        this.$translate = $translate;
	    }
	
	    _createClass(GoldupgradeController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.translations = this.$translate.instant(["gp_exists", "too_late"]);
	
	            this.booking.message = this.translations[this.status];
	        }
	    }]);
	
	    return GoldupgradeController;
	})();
	
	exports['default'] = GoldupgradeController;
	module.exports = exports['default'];

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularOauth2 = __webpack_require__(48);
	
	var _angularOauth22 = _interopRequireDefault(_angularOauth2);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularSanitize = __webpack_require__(20);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _apiMybookingMybooking = __webpack_require__(105);
	
	var _apiMybookingMybooking2 = _interopRequireDefault(_apiMybookingMybooking);
	
	var _invoiceComponent = __webpack_require__(137);
	
	var _invoiceComponent2 = _interopRequireDefault(_invoiceComponent);
	
	var _requestInvoiceRequestInvoice = __webpack_require__(140);
	
	var _requestInvoiceRequestInvoice2 = _interopRequireDefault(_requestInvoiceRequestInvoice);
	
	var invoiceModule = _angular2['default'].module('invoice', [_angularUiRouter2['default'], _angularOauth22['default'].name, _angularSanitize2['default'], _apiMybookingMybooking2['default'], _requestInvoiceRequestInvoice2['default']]).config(["$stateProvider", function ($stateProvider) {
	    "ngInject";
	    $stateProvider.state('bookings.booking.invoice', {
	        resolve: {
	            data: ["$stateParams", "myBookingService", "$location", "authService", "$state", function data($stateParams, myBookingService, $location, authService, $state) {
	                'ngInject';
	                return myBookingService.getBookingInvoices($stateParams.bookingReference).then(function (data) {
	                    if (data.invoices.length === 0 && data.can_generate_new_invoice) {
	                        $location.path('/' + $stateParams.locale + '/bookings/' + $stateParams.bookingReference + '/invoice/request');
	                    }
	                    return data;
	                }, function (error) {
	                    if (error.status === 401) {
	                        authService.clearSession();
	                        $state.go('auth.login');
	                    }
	                    return null;
	                });
	            }]
	        },
	        url: '/invoice',
	        views: {
	            'booking@bookings.booking': {
	                template: '<invoice data="$resolve.data"></invoice>'
	            }
	        }
	    });
	}]).component('invoice', _invoiceComponent2['default']).name;
	
	exports['default'] = invoiceModule;
	module.exports = exports['default'];

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invoiceHtml = __webpack_require__(138);
	
	var _invoiceHtml2 = _interopRequireDefault(_invoiceHtml);
	
	var _invoiceController = __webpack_require__(139);
	
	var _invoiceController2 = _interopRequireDefault(_invoiceController);
	
	var invoiceComponent = {
	    restrict: 'E',
	    require: {
	        booking: '^booking'
	    },
	    bindings: {
	        "data": '<'
	    },
	    template: _invoiceHtml2['default'],
	    controller: _invoiceController2['default'],
	    controllerAs: 'vm'
	};
	
	exports['default'] = invoiceComponent;
	module.exports = exports['default'];

/***/ },
/* 138 */
/***/ function(module, exports) {

	module.exports = "<section class=\"o-main__container\">\n    <div class=\"o-main__item\">\n        <div class=\"o-main__content\">\n            <h2 class=\"o-main__title--customer\">{{ 'your_created_invoices' | translate }}</h2>\n            <div class=\"m-information-tab\" ng-show=\"vm.is_there_flash_message\">\n                <div ng-class=\"{'m-information-tab__container--error': vm.createInvoiceResponse.status === 'error', 'm-information-tab__container': vm.createInvoiceResponse.status === 'success'}\">\n                    <div class=\"m-information-tab__icon\">\n                        <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"i-confirm-rounded\" width=\"27\" height=\"27\" ng-if=\"vm.createInvoiceResponse.status === 'success'\">\n                            <path fill=\"#31B143\" fill-rule=\"nonzero\" d=\"M0 13.5C0 21 6 27 13.5 27S27 21 27 13.5 21 0 13.5 0 0 6 0 13.5zm19.6-3L11 18.8s0 .2-.2.2-.4 0-.4-.2l-4-4.2H6L6 14l.2-.2.7-.7h.6l3 3c0 .2.3.2.4 0l7-6.8c.4-.2.7-.2 1 0l.6.7c.2 0 .2.3 0 .5z\"></path>\n                        </svg>\n                        <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"i-cross-rounded\" width=\"27\" height=\"27\" ng-if=\"vm.createInvoiceResponse.status === 'error'\">\n                            <path fill=\"#ED3861\" fill-rule=\"evenodd\" d=\"M18.6 18.6c-.5.6-1.4.6-2 0l-3-3-3.2 3.2c-.6.5-1.5.5-2 0-.5-.6-.5-1.4 0-2l3.2-3.2-3-3c-.5-.5-.5-1.4 0-2 .6-.5 1.4-.5 2 0l3 3L16.4 9c.6-.5 1.4-.5 2 0 .5.6.5 1.4 0 2l-3 2.8 3.2 3c.5.6.5 1.5 0 2M13.6 0C6 0 0 6 0 13.5S6 27 13.5 27 27 21 27 13.5 21 0 13.5 0\"></path>\n                        </svg>\n                    </div>\n                    <div class=\"m-information-tab__text\">{{vm.translations[vm.createInvoiceResponse.message]}}</div>\n                </div>\n            </div>\n            <div class=\"o-table\">\n                <div class=\"o-table__container\">\n                    <div class=\"o-table__header\">\n                        <div class=\"o-table__cell\">{{ 'id_invoice' | translate }}</div>\n                        <div class=\"o-table__cell\">{{ 'date_invoice' | translate }}</div>\n                        <div class=\"o-table__cell--alt\">{{ 'total_invoice' | translate }}</div>\n                        <div class=\"o-table__cell--alt\">{{ 'actions_invoice' | translate }}</div>\n                    </div>\n                    <div class=\"o-table__row\" ng-if=\"vm.data.invoices.length > 0\" ng-repeat=\"invoice in vm.data.invoices\">\n                        <div class=\"o-table__cell\">{{invoice.invoiceNumber}}</div>\n                        <div class=\"o-table__cell\">{{invoice.date.timestamp * 1000 | date : 'dd/MM/yyyy' : invoice.date.timezone }}</div>\n                        <div class=\"o-table__cell--alt\">{{invoice.total.amount | currency : invoice.total.currencySymbol : invoice.total.fractionSize}}</div>\n                        <div class=\"o-table__cell--alt\">\n                            <a class=\"o-table__link\" href=\"{{invoice.actions.downloadUrl + vm.invoiceFileUrl}}\" download>\n                                <i class=\"o-table__icon\">\n                                    <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"i-download\" viewBox=\"0 0 18 18\">\n                                        <g fill=\"#1F708F\" fill-rule=\"evenodd\">\n                                            <path d=\"M0 17.7h17.7v-2.2H0M6.6 0v9H3.3L9 14.3 14.3 9H11V0\"></path>\n                                        </g>\n                                    </svg>\n                                </i>\n                                <span class=\"o-table__description\">{{ 'download_invoice' | translate }}</span>\n                            </a>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"a-button--cta\" ng-if=\"vm.data.can_generate_new_invoice\">\n                <a class=\"a-button--cta__container\" ui-sref=\"bookings.booking.invoice.request\" href=\"\">\n                    <i class=\"a-button--cta__icon\">\n                        <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"i-plus-rounded\" width=\"16\" height=\"16\">\n                            <path fill=\"#FFF\" fill-rule=\"evenodd\" d=\"M12.8 9.2H9.5v3.3h-3V9.4H3.3V6.5h3.3V3.2h3v3.2h3.3v2.8zM7.8 0C3.6 0 0 3.6 0 8c0 4.3 3.7 7.8 8 7.7 4.5 0 8-3.6 8-8C16 3.4 12.3 0 8 0z\"></path>\n                        </svg>\n                    </i>\n                    <span class=\"a-button--cta__description\">{{ 'create_new_invoice' | translate }}</span>\n                </a>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ },
/* 139 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var invoiceController = (function () {
	    invoiceController.$inject = ["$translate", "$state", "cacheService", "sharedService", "authService"];
	    function invoiceController($translate, $state, cacheService, sharedService, authService) {
	        'ngInject';
	
	        _classCallCheck(this, invoiceController);
	
	        this.name = 'invoice';
	        this.$translate = $translate;
	        this.$state = $state;
	        this.IS_MOBILE = sharedService.IS_MOBILE;
	        this.is_there_flash_message = false;
	        var createInvoiceResponse = undefined;
	        this.paddingDigits = 9;
	        this.invoiceFileUrl = '?access_token=' + authService.getAccessToken();
	        if (createInvoiceResponse = cacheService.get('createInvoiceResponse')) {
	            this.createInvoiceResponse = createInvoiceResponse;
	            this.is_there_flash_message = true;
	            cacheService['delete']('createInvoiceResponse');
	        }
	    }
	
	    _createClass(invoiceController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            if (this.data.invoices.length === 0) {
	                this.$state.go('bookings.booking.invoice.request');
	            }
	
	            this.translations = this.$translate.instant(["your_created_invoices", "id_invoice", "date_invoice", "total_invoice", "actions_invoice", "create_new_invoice", "invoice_correctly_created", "something_went_wrong"]);
	        }
	    }]);
	
	    return invoiceController;
	})();
	
	exports['default'] = invoiceController;
	module.exports = exports['default'];

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularOauth2 = __webpack_require__(48);
	
	var _angularOauth22 = _interopRequireDefault(_angularOauth2);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularSanitize = __webpack_require__(20);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _apiMybookingMybooking = __webpack_require__(105);
	
	var _apiMybookingMybooking2 = _interopRequireDefault(_apiMybookingMybooking);
	
	var _requestInvoiceComponent = __webpack_require__(141);
	
	var _requestInvoiceComponent2 = _interopRequireDefault(_requestInvoiceComponent);
	
	var RequestInvoiceModule = _angular2['default'].module('requestInvoice', [_angularUiRouter2['default'], _angularOauth22['default'].name, _angularSanitize2['default'], _apiMybookingMybooking2['default']]).config(["$stateProvider", function ($stateProvider) {
	    "ngInject";
	    $stateProvider.state('bookings.booking.invoice.request', {
	        url: '/request',
	        views: {
	            'booking@bookings.booking': {
	                template: '<request-invoice></request-invoice>'
	            }
	        }
	    });
	}]).component('requestInvoice', _requestInvoiceComponent2['default']).name;
	
	exports['default'] = RequestInvoiceModule;
	module.exports = exports['default'];

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _requestInvoiceHtml = __webpack_require__(142);
	
	var _requestInvoiceHtml2 = _interopRequireDefault(_requestInvoiceHtml);
	
	var _requestInvoiceController = __webpack_require__(143);
	
	var _requestInvoiceController2 = _interopRequireDefault(_requestInvoiceController);
	
	var requestInvoiceComponent = {
	    restrict: 'E',
	    require: {
	        booking: '^booking'
	    },
	    template: _requestInvoiceHtml2['default'],
	    controller: _requestInvoiceController2['default'],
	    controllerAs: 'vm'
	};
	
	exports['default'] = requestInvoiceComponent;
	module.exports = exports['default'];

/***/ },
/* 142 */
/***/ function(module, exports) {

	module.exports = "<div class=\"o-main--alt\">\n    <section class=\"o-main__container\">\n        <div class=\"o-main__item\" ng-show=\"!vm.show_summary\">\n            <div class=\"o-main__content\">\n                <div class=\"o-main__headline\">\n                    <h2 class=\"o-main__title--customer\">{{ 'create_invoice' | translate }}</h2>\n                </div>\n\n                <div class=\"m-form\">\n                    <div class=\"m-form__container\">\n                        <h3 class=\"m-form__title\">{{ 'invoice_details' | translate }}</h3>\n\n                        <div class=\"m-form__item\">\n                            <div class=\"o-card-panel\">\n                                <div class=\"o-card-panel__container\">\n                                    <span class=\"o-card-panel__label\">{{ 'use_invoice' | translate }}</span>\n                                    <a href=\"\" class=\"o-card-panel__item\" ng-class=\"{'is-active': vm.company_is_active, 'is-secondary': vm.customer_is_active}\" ng-click=\"vm.toggleForm(vm.company)\">\n                                        <div class=\"o-card-panel__picture\">\n                                            <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"i-company\" width=\"36\" height=\"36\">\n                                                <g fill=\"none\" fill-rule=\"evenodd\">\n                                                    <path fill=\"#FFCD48\" d=\"M19.4 23.8v-4.4h-2.7v4.4l-4 2.3 1.5 2.5 3.8-2.3 4 2.3 1.3-2.4\"></path>\n                                                    <g fill=\"#09AFEE\" stroke=\"#1F708F\">\n                                                        <path d=\"M18 8.5c2 0 3.8-1.7 3.8-3.7S20 1 18 1c-2 0-3.7 1.7-3.7 3.8 0 2 1.7 3.7 3.7 3.7M18 9.5c-3.3 0-6 2.8-6 6.2V17H24v-1.3c0-3.4-2.8-6.2-6.2-6.2M28.8 26.4c2 0 3.7-1.7 3.7-3.7S30.8 19 28.8 19 25 20.5 25 22.6c0 2 1.7 3.7 3.8 3.7M28.8 27.4c-3.4 0-6 2.8-6 6.2V35h12v-1.4c0-3.4-2.6-6.2-6-6.2M7.2 26.4c2 0 3.7-1.7 3.7-3.7S9 19 7 19c-2 0-3.7 1.6-3.7 3.7 0 2 1.6 3.7 3.7 3.7M7.2 27.4c-3.4 0-6.2 2.8-6.2 6.2V35h12.3v-1.4c0-3.4-2.7-6.2-6-6.2\"></path>\n                                                    </g>\n                                                </g>\n                                            </svg>\n                                        </div>\n                                        <div class=\"o-card-panel__content\">\n                                            <h4 class=\"o-card-panel__title\">{{ 'business_invoice' | translate }}</h4>\n                                        </div>\n                                    </a>\n                                    <a href=\"\" class=\"o-card-panel__item\" ng-class=\"{'is-active': vm.customer_is_active, 'is-secondary': vm.company_is_active}\" ng-click=\"vm.toggleForm(vm.customer)\">\n                                        <div class=\"o-card-panel__picture\">\n                                            <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"i-customer\" width=\"20\" height=\"25\">\n                                                <g fill=\"#09AFEE\" fill-rule=\"evenodd\" stroke=\"#1F708F\">\n                                                    <path d=\"M9.8 12c3 0 5.3-2.5 5.3-5.4 0-3-2.2-5.2-5.2-5.2S4.5 3.7 4.5 6.6c0 3 2.4 5.3 5.3 5.3M9.8 13.3C5 13.3 1 17.3 1 22v2h17.6v-2c0-4.8-4-8.7-8.8-8.7\"></path>\n                                                </g>\n                                            </svg>\n                                        </div>\n                                        <div class=\"o-card-panel__content\">\n                                            <h4 class=\"o-card-panel__title\">{{ 'personal_invoice' | translate }}</h4>\n                                        </div>\n                                    </a>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"m-form__item\" ng-if=\"vm.show_form\">\n                            <form name=\"form\" class=\"m-form__content is-active\">\n                                <label class=\"m-form__field\" ng-class=\"{'has-error' : form.$submitted && form.name.$error.required}\">\n                                    <span class=\"m-form__description\" >{{vm.form_labels[vm.client.type].name | translate}}</span>\n                                    <input class=\"m-form__input\" ng-model=\"vm.client.name\" name=\"name\" type=\"text\" required>\n                                    <span class=\"m-form__validation\">{{ 'required_invoice' | translate }}</span>\n                                </label>\n\n                                <label class=\"m-form__field\" ng-class=\"{'has-error' : form.$submitted && form.address.$error.required}\">\n                                    <span class=\"m-form__description\">{{vm.form_labels[vm.client.type].address | translate}}</span>\n                                    <input class=\"m-form__input\" ng-model=\"vm.client.address\" name=\"address\" type=\"text\" required>\n                                    <span class=\"m-form__validation\">{{ 'required_invoice' | translate }}</span>\n                                </label>\n\n                                <label class=\"m-form__field\" ng-class=\"{'has-error' : form.$submitted && form.countryId.$error.required}\">\n                                    <span class=\"m-form__description\">{{ 'country_invoice' | translate }}</span>\n\n                                    <div class=\"a-select\">\n                                        <select class=\"a-select__select\" name=\"countryId\" ng-model=\"vm.client.countryId\" ng-change=\"vm.onCountryChange(vm.client.countryId)\" required>\n                                            <option value=\"\" selected=\"selected\" disabled=\"disabled\">{{ 'choose_country' | translate }}</option>\n                                            <option ng-repeat=\"country in vm.countries track by $index\" value=\"{{$index}}\">{{country.name}}</option>\n                                        </select>\n                                        <span class=\"st-icon-chevron-down a-select__icon\"></span>\n                                    </div>\n                                    <span class=\"m-form__validation\">{{ 'required_invoice' | translate }}</span>\n                                </label>\n\n                                <label class=\"m-form__field\" ng-class=\"{'has-error' : form.$submitted && form.number.$error.required || form.number.$error.pattern}\">\n                                    <span class=\"m-form__description\" ng-if=\"vm.client.type === vm.customer || vm.client.country.isoCode !== 'es'\">{{ 'tax_id_number' | translate }} <span class=\"m-form__blob\">{{ 'optional_invoice' | translate }}</span></span>\n                                    <span class=\"m-form__description\" ng-if=\"vm.client.country.isoCode === 'es' && vm.client.type === vm.company\">{{ 'nif_number' | translate }}</span>\n                                    <input type=\"hidden\" ng-model=\"vm.client.document.type\" >\n                                    <input class=\"m-form__input\" ng-model=\"vm.client.document.number\" name=\"number\" ng-if=\"vm.client.type === vm.customer || vm.client.country.isoCode !== 'es'\" type=\"text\">\n                                    <input class=\"m-form__input\" ng-model=\"vm.client.document.number\" name=\"number\" ng-if=\"vm.client.country.isoCode === 'es' && vm.client.type === vm.company\" type=\"text\" ng-pattern=\"vm.nifRegex\" required>\n                                    <span ng-show=\"form.number.$error.required\" class=\"m-form__validation\">{{ 'required_invoice' | translate }}</span>\n                                    <span ng-show=\"form.number.$error.pattern\" class=\"m-form__validation\">{{ 'fill_valid_nif' | translate }}</span>\n                                </label>\n                                <input type=\"hidden\" ng-model=\"vm.client.type\" >\n                                <div class=\"m-form__submit\">\n                                    <div class=\"a-button--primary\">\n                                        <button type=\"button\" class=\"a-button__container\" ng-click=\"vm.submit(form, client)\">\n                                            <span class=\"a-button__text\">{{ 'submit_invoice' | translate }}</span>\n                                        </button>\n                                    </div>\n                                </div>\n                            </form>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"o-main__item\" ng-show=\"vm.show_summary\" >\n            <div class=\"o-main__content\">\n                <div class=\"m-summary\">\n                    <div class=\"m-summary__container\">\n                        <div class=\"m-summary__item\">\n                            <div class=\"m-summary__headline\">\n                                <h2 class=\"m-summary__title\">{{ 'invoice_almost_ready' | translate }}</h2>\n                                <div class=\"m-summary__description\">{{ 'make_sure_details' | translate }}</div>\n                            </div>\n                        </div>\n\n                        <div class=\"m-summary__item\">\n                            <div class=\"o-table\">\n                                <div class=\"o-table__container--breakdown\">\n                                    <div class=\"o-table__row--alt\">\n                                        <div class=\"o-table__cell\">{{ 'name_invoice' | translate }}</div>\n                                        <div class=\"o-table__cell\">{{vm.client.name}}</div>\n                                    </div>\n                                    <div class=\"o-table__row--alt\">\n                                        <div class=\"o-table__cell\">{{ 'address_invoice' | translate }}</div>\n                                        <div class=\"o-table__cell\">{{vm.client.address}}</div>\n                                    </div>\n                                    <div class=\"o-table__row--alt\">\n                                        <div class=\"o-table__cell\">{{ 'country_invoice' | translate }}</div>\n                                        <div class=\"o-table__cell\">{{vm.client.country.name}}</div>\n                                    </div>\n                                    <div class=\"o-table__row--alt\" ng-if=\"vm.client.document.number !== undefined && vm.client.document.number !==''\">\n                                        <div class=\"o-table__cell\">{{ 'tax_id_number' | translate }}</div>\n                                        <div class=\"o-table__cell\">{{vm.client.document.number}}</div>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class=\"a-button--cta--alt\">\n                                <a class=\"a-button--cta__container\" href=\"\" ng-click=\"vm.save()\">\n                                    <span class=\"a-button--cta__description\">{{ 'correct_details' | translate }}</span>\n                                </a>\n\n                                <a class=\"a-button--cta__link\" href=\"\" ng-click=\"vm.hideSummary()\">{{ 'not_correct_details' | translate }}</a>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </section>\n</div>"

/***/ },
/* 143 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var RequestInvoiceController = (function () {
	    RequestInvoiceController.$inject = ["$translate", "$stateParams", "$location", "$state", "myBookingService", "locationsService", "cacheService", "sharedService"];
	    function RequestInvoiceController($translate, $stateParams, $location, $state, myBookingService, locationsService, cacheService, sharedService) {
	        'ngInject';
	
	        var _this = this;
	
	        _classCallCheck(this, RequestInvoiceController);
	
	        this.name = 'requestInvoice';
	        this.$translate = $translate;
	        this.show_form = false;
	        this.show_summary = false;
	        this.customer = 'person';
	        this.customer_is_active = false;
	        this.company = 'company';
	        this.company_is_active = false;
	        this.client = { document: { type: 'tax-id' } };
	        this.IS_MOBILE = sharedService.IS_MOBILE;
	        this.countries = [];
	        this.myBookingService = myBookingService;
	        this.$stateParams = $stateParams;
	        this.$location = $location;
	        this.$state = $state;
	        this.cacheService = cacheService;
	        this.dataTransformed = {};
	        this.createInvoiceResponse = {};
	        this.nifRegex = /^([0-9]{8}[\w]{1}|[\w]{1}[0-9]{7}[\w]{1})$/i;
	
	        locationsService.getCountries().then(function (response) {
	            _this.countries = response.reduce(function (items, item) {
	                items[item.id] = item;
	                return items;
	            }, []);
	
	            function compareStrings(a, b) {
	                a = a.toLowerCase();
	                b = b.toLowerCase();
	                return a < b ? -1 : a > b ? 1 : 0;
	            }
	
	            _this.countries.sort(function (a, b) {
	                return compareStrings(a.name, b.name);
	            });
	        });
	
	        this.form_labels = {};
	        this.form_labels[this.customer] = {
	            'name': 'name_invoice',
	            'address': 'address_invoice'
	        };
	        this.form_labels[this.company] = {
	            'name': 'company_name',
	            'address': 'registered_company_address'
	        };
	    }
	
	    _createClass(RequestInvoiceController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.translations = this.$translate.instant(["invoice_details", "business_invoice", "personal_invoice", "required_invoice", "country_invoice", "tax_id_number", "submit_invoice", "invoice_almost_ready", "make_sure_details", "name_invoice", "address_invoice", "correct_details", "not_correct_details", "optional_invoice", "nif_number", "company_name", "registered_company_address"]);
	        }
	    }, {
	        key: 'onCountryChange',
	        value: function onCountryChange(id) {
	            this.client.country = this.countries[id];
	            if (this.client.country.isoCode === 'es') {
	                this.client.document.type = 'nif';
	            }
	        }
	    }, {
	        key: 'toggleForm',
	        value: function toggleForm(clientType) {
	
	            this.show_form = true;
	            this.client.type = clientType;
	            if (clientType === this.company) {
	                this.customer_is_active = false;
	                this.company_is_active = true;
	            }
	            if (clientType === this.customer) {
	                this.customer_is_active = true;
	                this.company_is_active = false;
	            }
	        }
	    }, {
	        key: 'hideSummary',
	        value: function hideSummary() {
	            this.show_summary = false;
	        }
	    }, {
	        key: 'submit',
	        value: function submit(form) {
	            form.$submitted = true;
	            if (form.$valid) {
	                this.show_summary = true;
	            }
	        }
	    }, {
	        key: 'dataTransform',
	        value: function dataTransform() {
	            this.dataTransformed = {
	                content: {
	                    type: this.client.type,
	                    name: this.client.name,
	                    address: this.client.address,
	                    documentNumber: this.client.document.number,
	                    countryIsoCode: this.client.country.isoCode
	                }
	            };
	        }
	    }, {
	        key: 'save',
	        value: function save() {
	            var _this2 = this;
	
	            this.dataTransform();
	            this.myBookingService.createInvoice(this.$stateParams.bookingReference, this.dataTransformed).then(function (response) {
	                _this2.cacheService.set('createInvoiceResponse', { status: 'success', message: 'invoice_correctly_created' });
	                _this2.$state.go('bookings.booking.invoice', {}, { reload: true });
	            }, function (error) {
	                _this2.cacheService.set('createInvoiceResponse', { status: 'error', message: 'something_went_wrong' });
	            });
	            this.$state.go('bookings.booking.invoice', {}, { reload: true });
	        }
	    }]);
	
	    return RequestInvoiceController;
	})();
	
	exports['default'] = RequestInvoiceController;
	module.exports = exports['default'];

/***/ },
/* 144 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var authRun = function authRun($rootScope, $state, cacheService) {
	    "ngInject";
	    //If errors in URL params redirect with cached params
	    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
	        var bookingReference = cacheService.get('bookingReference');
	        var language = cacheService.get('customer').language;
	        $state.go(toState.name, { locale: language, bookingReference: bookingReference });
	    });
	};
	authRun.$inject = ["$rootScope", "$state", "cacheService"];
	
	exports['default'] = authRun;
	module.exports = exports['default'];

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _onTheBeachComponent = __webpack_require__(146);
	
	var _onTheBeachComponent2 = _interopRequireDefault(_onTheBeachComponent);
	
	var _loginLogin = __webpack_require__(147);
	
	var _loginLogin2 = _interopRequireDefault(_loginLogin);
	
	var _bookingBooking = __webpack_require__(155);
	
	var _bookingBooking2 = _interopRequireDefault(_bookingBooking);
	
	var _commonOtbNavbarOtbNavbar = __webpack_require__(163);
	
	var _commonOtbNavbarOtbNavbar2 = _interopRequireDefault(_commonOtbNavbarOtbNavbar);
	
	var onTheBeachModule = _angular2['default'].module('onTheBeach', [_angularUiRouter2['default'], _commonOtbNavbarOtbNavbar2['default'], _loginLogin2['default'], _bookingBooking2['default']]).config(["$stateProvider", function ($stateProvider) {
	    "ngInject";
	    $stateProvider.state('onTheBeach', {
	        abstract: true,
	        url: '/{locale}/on-the-beach',
	        resolve: {
	            checkLocale: ["$state", "$stateParams", "$location", function checkLocale($state, $stateParams, $location) {
	                'ngInject';
	                if ($stateParams.locale !== 'en') {
	                    var currentPath = $location.path();
	                    var newPath = currentPath.replace('/' + $stateParams.locale + '/', '/en/');
	                    $location.path(newPath).replace();
	                    return false;
	                }
	                return true;
	            }]
	        },
	        views: {
	            'navbar@': {
	                template: '<otb-navbar></otb-navbar>'
	            },
	            'main@': {
	                template: '<on-the-beach></on-the-beach>'
	            },
	            'footer@': {
	                template: '<footer></footer>'
	            }
	        }
	    });
	}]).component('onTheBeach', _onTheBeachComponent2['default']).name;
	
	exports['default'] = onTheBeachModule;
	module.exports = exports['default'];

/***/ },
/* 146 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var onTheBeachComponent = {
	    template: '<div ui-view></div>'
	};
	
	exports['default'] = onTheBeachComponent;
	module.exports = exports['default'];

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _loginComponent = __webpack_require__(148);
	
	var _loginComponent2 = _interopRequireDefault(_loginComponent);
	
	var _apiMybookingMybooking = __webpack_require__(105);
	
	var _apiMybookingMybooking2 = _interopRequireDefault(_apiMybookingMybooking);
	
	var _servicesLanguageService = __webpack_require__(14);
	
	var _servicesLanguageService2 = _interopRequireDefault(_servicesLanguageService);
	
	var _servicesCacheService = __webpack_require__(15);
	
	var _servicesCacheService2 = _interopRequireDefault(_servicesCacheService);
	
	var loginModule = _angular2['default'].module('onTheBeachLogin', [_angularUiRouter2['default'], _apiMybookingMybooking2['default'], _servicesCacheService2['default'], _servicesLanguageService2['default']]).config(["$stateProvider", "$urlMatcherFactoryProvider", function ($stateProvider, $urlMatcherFactoryProvider) {
	    "ngInject";
	
	    $urlMatcherFactoryProvider.strictMode(false);
	    $stateProvider.state('onTheBeach.login', {
	        url: '/login?reference&surname',
	        views: {
	            'main@': {
	                template: '<on-the-beach-login></on-the-beach-login>'
	            }
	        }
	    });
	}]).component('onTheBeachLogin', _loginComponent2['default']).name;
	
	exports['default'] = loginModule;
	module.exports = exports['default'];

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _loginController = __webpack_require__(149);
	
	var _loginController2 = _interopRequireDefault(_loginController);
	
	var _loginHtml = __webpack_require__(150);
	
	var _loginHtml2 = _interopRequireDefault(_loginHtml);
	
	__webpack_require__(151);
	
	var loginComponent = {
	    template: _loginHtml2['default'],
	    controller: _loginController2['default'],
	    controllerAs: 'vm'
	};
	
	exports['default'] = loginComponent;
	module.exports = exports['default'];

/***/ },
/* 149 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var LoginController = (function () {
	    LoginController.$inject = ["$state", "$stateParams", "authService", "myBookingService", "languageService", "cacheService"];
	    function LoginController($state, $stateParams, authService, myBookingService, languageService, cacheService) {
	        'ngInject';
	
	        _classCallCheck(this, LoginController);
	
	        this.reference = $stateParams.reference;
	        this.surname = $stateParams.surname;
	        this.$stateParams = $stateParams;
	        this.$state = $state;
	        this.authService = authService;
	        this.myBookingService = myBookingService;
	        this.languageService = languageService;
	        this.cacheService = cacheService;
	        this.errorMessage = '';
	    }
	
	    _createClass(LoginController, [{
	        key: 'login',
	        value: function login() {
	            var _this = this;
	
	            this.errorMessage = '';
	
	            if (!this.reference && !this.surname) {
	                this.errorMessage = 'Please fill in your On The Beach booking reference and surname.';
	                return;
	            }
	            if (!this.reference) {
	                this.errorMessage = 'Please fill in your On The Beach booking reference.';
	                return;
	            }
	            if (!this.surname) {
	                this.errorMessage = 'Please fill in your surname.';
	                return;
	            }
	
	            this.authService.loginByAgencyBookingReferenceAndCustomerSurname(this.reference, this.surname).then(function () {
	                return _this.myBookingService.getGlobalInfoBooking(_this.reference, true).then(function (bookingResponse) {
	                    _this.cacheService.set('customer', bookingResponse.customer);
	                    _this.cacheService.set('agencyBookingReference', _this.reference);
	                    _this.cacheService.set('bookingReference', bookingResponse.booking.reference);
	                    _this.cacheService.set('onTheBeachBooking', true);
	
	                    return _this.$state.go('onTheBeach.booking.view', {
	                        locale: _this.$stateParams.locale
	                    });
	                });
	            })['catch'](function () {
	                _this.errorMessage = 'No booking found with the provided information. Please review the Booking reference and Surname informed.';
	                _this.authService.logout();
	            });
	        }
	    }]);
	
	    return LoginController;
	})();
	
	exports['default'] = LoginController;
	module.exports = exports['default'];

/***/ },
/* 150 */
/***/ function(module, exports) {

	module.exports = "<div class=\"o-main\">\n    <section class=\"o-main__container--hero\">\n        <span class=\"o-main__background SUMMER-bg has-image has-loaded\" data-progressive-img=\"\"></span>\n        <div class=\"o-main__item--hero-alt\">\n            <h1 class=\"o-main__title--hero-alt\">Welcome to My Booking</h1>\n            <h2 class=\"o-main__description--hero\">Retrieve your booking</h2>\n        </div>\n\n        <div class=\"o-main__item\">\n            <div class=\"o-main__container--search--rounded\">\n                <div class=\"o-main__item\">\n                    <div class=\"o-main__content\">\n                        <form class=\"o-search--landing\" autocomplete=\"off\" novalidate ng-submit=\"vm.login()\">\n                            <div class=\"o-search__container\">\n                                <div class=\"o-search__item\">\n                                    <div class=\"o-search__content\">\n                                        <label class=\"a-input\">\n                                            <div class=\"a-input__container\">\n                                                <span class=\"a-label__label\">\n                                                    Booking reference\n                                                    <span class=\"m-tooltip\">\n                                                        <span class=\"m-tooltip__content\">\n                                                            <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"m-tooltip__icon\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n                                                                <defs>\n                                                                    <path id=\"tooltip-b\" d=\"M8.08421053,12.9172932 C7.65413319,12.9172932 7.28471332,12.9255638 6.97593985,12.9421053 C6.66716638,12.9586467 6.36942499,12.9779448 6.08270677,13 C6.06065152,12.8897238 6.04962406,12.7849629 6.04962406,12.6857143 C6.04962406,12.6085209 6.06892211,12.5561405 6.1075188,12.5285714 C6.14611548,12.5010024 6.18746845,12.4817043 6.23157895,12.4706767 C6.58446292,12.4045109 6.82706701,12.3328325 6.9593985,12.2556391 C7.09172998,12.1784457 7.15789474,12.0571437 7.15789474,11.8917293 L7.15789474,7.52481203 C7.15789474,7.19398331 7.10275744,6.94035176 6.9924812,6.76390977 C6.88220496,6.58746779 6.62305968,6.48270693 6.21503759,6.44962406 C6.07167848,6.42756881 6,6.33934914 6,6.18496241 L6,6.06090226 C6,6.01127795 6.01102746,5.96441125 6.03308271,5.92030075 C6.09924845,5.92030075 6.19573871,5.91754389 6.32255639,5.91203008 C6.44937407,5.90651626 6.58446044,5.90100253 6.72781955,5.89548872 C6.87117866,5.88997491 7.01453562,5.88170432 7.15789474,5.87067669 C7.30125385,5.85964907 7.43358335,5.84862161 7.55488722,5.83759398 C7.83057782,5.80451111 8.09523683,5.76040128 8.34887218,5.70526316 C8.60250753,5.65012504 8.77343314,5.62255639 8.86165414,5.62255639 C9.03809612,5.62255639 9.12631579,5.70526233 9.12631579,5.87067669 C9.12631579,5.99198056 9.1097746,6.15187871 9.07669173,6.35037594 C9.04360886,6.54887317 9.02706767,6.82455964 9.02706767,7.17744361 L9.02706767,11.8917293 C9.02706767,12.0571437 9.09874615,12.1784457 9.24210526,12.2556391 C9.38546438,12.3328325 9.62255474,12.4045109 9.95338346,12.4706767 C10.0746873,12.4927319 10.1353383,12.5644104 10.1353383,12.6857143 L10.1353383,12.8511278 C10.1353383,12.9062659 10.1243109,12.9558895 10.1022556,13 C9.82656504,12.9779448 9.52882365,12.9586467 9.20902256,12.9421053 C8.88922146,12.9255638 8.51428786,12.9172932 8.08421053,12.9172932 Z M6.87669173,3.2075188 C6.87669173,2.85463483 6.98972318,2.56516404 7.21578947,2.33909774 C7.44185577,2.11303145 7.72581283,2 8.06766917,2 C8.42055314,2 8.70726707,2.11303145 8.92781955,2.33909774 C9.14837203,2.56516404 9.25864662,2.85463483 9.25864662,3.2075188 C9.25864662,3.56040277 9.14837203,3.84987356 8.92781955,4.07593985 C8.70726707,4.30200614 8.42055314,4.41503759 8.06766917,4.41503759 C7.72581283,4.41503759 7.44185577,4.30200614 7.21578947,4.07593985 C6.98972318,3.84987356 6.87669173,3.56040277 6.87669173,3.2075188 Z\"></path>\n                                                                    <filter id=\"tooltip-a\" width=\"438.5%\" height=\"227.3%\" x=\"-169.3%\" y=\"-45.5%\" filterUnits=\"objectBoundingBox\">\n                                                                        <feOffset dy=\"2\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset>\n                                                                        <feGaussianBlur in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\" stdDeviation=\"2\"></feGaussianBlur>\n                                                                        <feColorMatrix in=\"shadowBlurOuter1\" values=\"0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0\"></feColorMatrix>\n                                                                    </filter>\n                                                                </defs>\n                                                                <g fill=\"none\" fill-rule=\"evenodd\">\n                                                                    <path fill=\"#09AFEE\" fill-rule=\"nonzero\" d=\"M7.99966138,1.33226763e-14 C3.58196825,1.33226763e-14 -8.8817842e-16,3.58196825 -8.8817842e-16,7.99966138 C-8.8817842e-16,12.4173545 3.58196825,16 7.99966138,16 C12.4173545,16 16,12.4173545 16,7.99966138 C16,5.79081481 15.1043386,3.79089947 13.6564656,2.34319577 C12.2085926,0.895492063 10.2085079,1.33226763e-14 7.99966138,1.33226763e-14 Z\"></path>\n                                                                    <use fill=\"#000\" filter=\"url(#tooltip-a)\" xlink:href=\"#tooltip-b\"></use>\n                                                                    <use fill=\"#FFF\" xlink:href=\"#tooltip-b\"></use>\n                                                                    <path fill=\"#1F708F\" fill-rule=\"nonzero\" d=\"M7.9996878,0 C12.4175293,0 16,3.58205176 16,7.9996878 C16,12.4174266 12.4174266,16 7.9996878,16 C3.58205176,16 0,12.4175293 0,7.9996878 C0,3.58194903 3.58194903,0 7.9996878,0 Z M7.9996901,1.29838254 C4.29902424,1.29838254 1.29838254,4.29902424 1.29838254,7.9996901 C1.29838254,11.7004904 4.29915867,14.7016175 7.9996901,14.7016175 C11.700356,14.7016175 14.7016175,11.700356 14.7016175,7.9996901 C14.7016175,4.29915867 11.7004904,1.29838254 7.9996901,1.29838254 Z\"></path>\n                                                                </g>\n                                                            </svg>\n\n                                                            <span class=\"m-tooltip__tooltip\">\n                                                                <span class=\"m-tooltip__text\">Please enter the booking reference given to you by On The Beach.</span>\n                                                            </span>\n                                                        </span>\n                                                    </span>\n                                                </span>\n                                                <div class=\"a-input__content\">\n                                                    <input class=\"a-input__input--big\" type=\"text\" placeholder=\"RT-2300010 or SUNTR_XXXXXX\" ng-model=\"vm.reference\" ng-change=\"vm.reference = vm.reference.toUpperCase()\">\n                                                </div>\n\n                                                <div class=\"a-input__error\" role=\"alert\" type=\"danger\" ng-if=\"vm.errorMessage\">\n                                                    {{vm.errorMessage}}\n                                                </div>\n                                            </div>\n                                        </label>\n                                    </div>\n                                    <div class=\"o-search__content\">\n                                        <label class=\"a-input\">\n                                            <div class=\"a-input__container\">\n                                                <span class=\"a-label__label\">Surname</span>\n                                                <div class=\"a-input__content\">\n                                                    <input class=\"a-input__input--big\" type=\"text\" placeholder=\"Doe\" ng-model=\"vm.surname\">\n                                                </div>\n                                            </div>\n                                        </label>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class=\"o-search__container\" ng-style=\"{'vertical-align': vm.errorMessage ? 'middle' : ''}\">\n                                <div class=\"a-button--primary\">\n                                    <button type=\"submit\" class=\"a-button__container st-loginButton\" title=\"Retrieve\">\n                                            <span class=\"a-button__text\">Retrieve</span>\n                                    </button>\n                                </div>\n                            </div>\n                        </form>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </section>\n\n    <section class=\"o-main__container\">\n        <div class=\"o-main__item--alt\">\n            <div class=\"o-main__content\">\n                <h2 class=\"o-main__title\">You will be able to</h2>\n            </div>\n\n            <div class=\"o-key-points\">\n                <div class=\"o-key-points__item\">\n                    <div class=\"o-key-points__header\">\n                        <div class=\"o-key-points__icon\">\n                            <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"i-retrieve\" viewBox=\"0 0 16 16\">\n                                <g fill=\"none\" fill-rule=\"evenodd\">\n                                    <rect width=\"10\" height=\"12\" x=\"3\" y=\"2\" fill=\"#09AFEE\" rx=\"1\"></rect>\n                                    <rect width=\"6\" height=\"1\" x=\"5\" y=\"5\" fill=\"#FFF\" rx=\"0.5\"></rect>\n                                    <rect width=\"6\" height=\"1\" x=\"5\" y=\"7\" fill=\"#FFF\" rx=\"0.5\"></rect>\n                                    <rect width=\"6\" height=\"1\" x=\"5\" y=\"9\" fill=\"#FFF\" rx=\"0.5\"></rect>\n                                    <path fill=\"#09AFEE\" d=\"M11,2V1c0-0.5-0.5-1-1-1H4C3.5,0,3,0.5,3,1v1H2C1.5,2,1,2.5,1,3v10c0,0.5,0.5,1,1,1h12c0.5,0,1-0.5,1-1V3c0-0.5-0.5-1-1-1H11z M4,1h6v1H4V1z\"></path>\n                                    <path fill=\"#FFCD48\" d=\"M8 12l2-2H9V8H7v2H6l2 2z\"></path>\n                                </g>\n                            </svg>\n                        </div>\n                    </div>\n                    <div class=\"o-key-points__headline\">\n                        <h3 class=\"o-key-points__title\">Retrieve booking voucher</h3>\n                    </div>\n                </div>\n                <div class=\"o-key-points__item\">\n                    <div class=\"o-key-points__header\">\n                        <div class=\"o-key-points__icon\">\n                            <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"i-print\" viewBox=\"0 0 16 16\">\n                                <g fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(0 -1)\">\n                                    <polygon fill=\"#FFF\" points=\".408 4.66 .408 13.922 15.351 13.922 15.351 4.66\"></polygon>\n                                    <path fill=\"#09AFEE\" fill-rule=\"nonzero\" d=\"M14.9624442,4.16017086 L0.650542405,4.16017086 C0.292740969,4.16017086 0,4.44111011 0,4.78448693 L0,11.776809 L15.6129866,11.776809 L15.6129866,4.78448693 C15.6129866,4.44111011 15.3202456,4.16017086 14.9624442,4.16017086 Z\"></path>\n                                    <rect width=\"10.506\" height=\"1\" x=\"2.57\" y=\"11.778\" fill=\"#FFCD48\" fill-rule=\"nonzero\"></rect>\n                                    <ellipse cx=\"12.328\" cy=\"6.034\" fill=\"#FFCD48\" fill-rule=\"nonzero\" rx=\"1\" ry=\"1\"></ellipse>\n                                    <ellipse cx=\"14.247\" cy=\"6.034\" fill=\"#FFCD48\" fill-rule=\"nonzero\" rx=\"1\" ry=\"1\"></ellipse>\n                                    <path fill=\"#1F708F\" fill-rule=\"nonzero\" d=\"M0.668579609,13.6750353 C0.668579609,13.6750054 15.3934175,13.6751206 15.3934175,13.6751206 C15.3936795,13.6751206 15.3936792,4.74274798 15.3936792,4.74274798 C15.3936792,4.74277789 0.668841318,4.74266272 0.668841318,4.74266272 C0.668579296,4.74266272 0.668579609,13.6750353 0.668579609,13.6750353 Z M0.0311294098,4.74274798 C0.0311294098,4.41271692 0.316484227,4.14517389 0.668841318,4.14517389 L15.3934175,4.14517389 C15.7456161,4.14517389 16.0311294,4.41279929 16.0311294,4.74274798 L16.0311294,13.6750353 C16.0311294,14.0050664 15.7457746,14.2726094 15.3934175,14.2726094 L0.668841318,14.2726094 C0.316642756,14.2726094 0.0311294098,14.004984 0.0311294098,13.6750353 L0.0311294098,4.74274798 Z\"></path>\n                                    <polygon fill=\"#FFF\" points=\"3.397 12.372 3.397 16.61 12.173 16.61 12.173 12.372\"></polygon>\n                                    <rect width=\"4.93\" height=\"1\" x=\"5.004\" y=\"13.59\" fill=\"#09AFEE\" rx=\".5\"></rect>\n                                    <path fill=\"#1F708F\" fill-rule=\"nonzero\" d=\"M3.10301978 12.3717769L3.10301978 16.3622765C3.10304316 16.7072481 3.38653641 16.987915 3.73501049 16.987915L11.8989799 16.987915C12.2473137 16.987915 12.5306433 16.7072481 12.5306433 16.3622997L12.5306433 12.3717769 11.952737 12.3717769 11.952737 16.3622997C11.952737 16.39179 11.9286294 16.4157942 11.8990267 16.4157942L3.73503388 16.4157942C3.70524417 16.4157942 3.68099619 16.39179 3.68099619 16.3622997L3.68099619 12.3717769 3.10301978 12.3717769zM12.4995373 4.27453019L12.4995373 1.6201222C12.4995373 1.27517381 12.2162077.994506836 11.8678739.994506836L5.75469423.994506836C5.67806875.994506836 5.60457656 1.02466841 5.55035181 1.07830184L3.15653616 3.44805701C3.10235818 3.50169044 3.07189037 3.5744671 3.07189037 3.65032241L3.07189037 4.27453019 12.4995373 4.27453019z\"></path>\n                                    <path fill=\"#FFCD48\" d=\"M5.46577617,3.31102208 C5.46577617,3.34039663 5.44164511,3.36428515 5.4119957,3.36428515 L4.05864515,3.36428515 L5.46577617,1.97125105 L5.46577617,3.31102208 Z\"></path>\n                                    <path fill=\"#FFF\" d=\"M3.64986678,3.93642912 L5.4119957,3.93642912 C5.76035287,3.93642912 6.04370582,3.65587788 6.04370582,3.31104523 L6.04370582,1.56662765 L11.8678739,1.56662765 C11.8974999,1.56662765 11.9215842,1.59063191 11.9215842,1.6201222 L11.9215842,4.27453019 L3.64227753,4.27453019 L3.64986678,3.93642912 Z\"></path>\n                                    <path fill=\"#FFF\" d=\"M3.64986678,3.93642912 L5.4119957,3.93642912 C5.76035287,3.93642912 6.04370582,3.65587788 6.04370582,3.31104523 L6.04370582,1.56662765 L11.8678739,1.56662765 C11.8974999,1.56662765 11.9215842,1.59063191 11.9215842,1.6201222 L11.9215842,4.27453019 L3.64227753,4.27453019 L3.64986678,3.93642912 Z\"></path>\n                                </g>\n                            </svg>\n                        </div>\n                    </div>\n                    <div class=\"o-key-points__headline\">\n                        <h3 class=\"o-key-points__title\">Print booking voucher</h3>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </section>\n\n</div>"

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(152);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(154)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./login.less", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./login.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(153)();
	// imports
	
	
	// module
	exports.push([module.id, ".o-key-points{text-align:center!important}.o-key-points__icon .i-retrieve{width:56px;height:56px}@media only screen and (min-width:62.38em){.o-search__item{display:flex!important}}", ""]);
	
	// exports


/***/ },
/* 153 */,
/* 154 */,
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _bookingComponent = __webpack_require__(156);
	
	var _bookingComponent2 = _interopRequireDefault(_bookingComponent);
	
	var _servicesCacheService = __webpack_require__(15);
	
	var _servicesCacheService2 = _interopRequireDefault(_servicesCacheService);
	
	var _viewView = __webpack_require__(159);
	
	var _viewView2 = _interopRequireDefault(_viewView);
	
	var _apiMybookingMybooking = __webpack_require__(105);
	
	var _apiMybookingMybooking2 = _interopRequireDefault(_apiMybookingMybooking);
	
	var BookingModule = _angular2['default'].module('onTheBeachBooking', [_angularUiRouter2['default'], _servicesCacheService2['default'], _apiMybookingMybooking2['default'], _viewView2['default']]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    'ngInject';
	    $stateProvider.state('onTheBeach.booking', {
	        resolve: {
	            data: ["$q", "myBookingService", "cacheService", "authService", "$state", function data($q, myBookingService, cacheService, authService, $state) {
	                'ngInject';
	                var agencyBookingReference = cacheService.get('agencyBookingReference');
	                if (agencyBookingReference) {
	                    return myBookingService.getGlobalInfoBooking(agencyBookingReference, true).then(function (booking) {
	                        return booking;
	                    }, function (error) {
	                        if (error.status === 401 || error.status === 403) {
	                            authService.clearSession();
	                            $state.go('onTheBeach.login');
	                        }
	                        return $q.reject(error);
	                    });
	                } else {
	                    $state.go('onTheBeach.login');
	                    return $q.reject('No booking reference');
	                }
	            }]
	        },
	        url: '/booking',
	        abstract: true,
	        redirectTo: 'onTheBeach.booking.view',
	        views: {
	            'main@': {
	                template: '<on-the-beach-booking data="$resolve.data"></on-the-beach-booking>'
	            }
	        }
	    });
	}]).component('onTheBeachBooking', _bookingComponent2['default']).name;
	
	exports['default'] = BookingModule;
	module.exports = exports['default'];

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _bookingHtml = __webpack_require__(157);
	
	var _bookingHtml2 = _interopRequireDefault(_bookingHtml);
	
	var _bookingController = __webpack_require__(158);
	
	var _bookingController2 = _interopRequireDefault(_bookingController);
	
	var bookingComponent = {
	    bindings: {
	        data: '<'
	    },
	    template: _bookingHtml2['default'],
	    controller: _bookingController2['default'],
	    controllerAs: 'vm'
	};
	
	exports['default'] = bookingComponent;
	module.exports = exports['default'];

/***/ },
/* 157 */
/***/ function(module, exports) {

	module.exports = "<div class=\"st-mybooking\">\n    <p class=\"st-mybooking__customer-name\"><strong>Customer:</strong> {{vm.data.customer.full_name}} </p>\n    <p class=\"st-mybooking__customer-reference\" style=\"margin-bottom: 0\"><strong>Booking reference:</strong> {{vm.data.booking.reference}}</p>\n    <p class=\"st-mybooking__customer-reference\"><strong>On The Beach booking reference:</strong> {{vm.cacheService.get('agencyBookingReference')}}</p>\n\n    <h1 class=\"st-mybooking__main-title\">View your booking voucher</h1>\n    <div ui-view=\"booking\" class=\"st-navtabs__container\"></div>\n</div>\n"

/***/ },
/* 158 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var BookingController = function BookingController($state, cacheService) {
	    'ngInject';
	
	    _classCallCheck(this, BookingController);
	
	    this.$state = $state;
	    this.cacheService = cacheService;
	    this.name = 'booking';
	};
	BookingController.$inject = ["$state", "cacheService"];
	
	exports['default'] = BookingController;
	module.exports = exports['default'];

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularOauth2 = __webpack_require__(48);
	
	var _angularOauth22 = _interopRequireDefault(_angularOauth2);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularSanitize = __webpack_require__(20);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _apiMybookingMybooking = __webpack_require__(105);
	
	var _apiMybookingMybooking2 = _interopRequireDefault(_apiMybookingMybooking);
	
	var _viewComponent = __webpack_require__(160);
	
	var _viewComponent2 = _interopRequireDefault(_viewComponent);
	
	var onTheBeachBookingViewModule = _angular2['default'].module('onTheBeachBookingView', [_angularUiRouter2['default'], _angularOauth22['default'].name, _angularSanitize2['default'], _apiMybookingMybooking2['default']]).config(["$stateProvider", function ($stateProvider) {
	    "ngInject";
	    $stateProvider.state('onTheBeach.booking.view', {
	        url: '/view',
	        views: {
	            'booking@onTheBeach.booking': {
	                template: '<on-the-beach-booking-view></on-the-beach-booking-view>'
	            }
	        }
	    });
	}]).component('onTheBeachBookingView', _viewComponent2['default']).name;
	
	exports['default'] = onTheBeachBookingViewModule;
	module.exports = exports['default'];

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _viewHtml = __webpack_require__(161);
	
	var _viewHtml2 = _interopRequireDefault(_viewHtml);
	
	var _viewController = __webpack_require__(162);
	
	var _viewController2 = _interopRequireDefault(_viewController);
	
	var viewComponent = {
	    bindings: {},
	    template: _viewHtml2['default'],
	    controller: _viewController2['default'],
	    controllerAs: 'vm'
	};
	
	exports['default'] = viewComponent;
	module.exports = exports['default'];

/***/ },
/* 161 */
/***/ function(module, exports) {

	module.exports = "<div class=\"st-form\">\n    <iframe\n            ng-if=\"vm.showIframe && !vm.IS_MOBILE\"\n            width=\"100%\"\n            height=\"1200\"\n            ng-src=\"{{vm.lastPdfVoucherUrl}}\"\n    ></iframe>\n    <div ng-if=\"vm.showPdfNotFoundError\" class=\"st-form__error\">\n        Your booking details will now be verified by our staff and your booking voucher will be issued by email shortly. Please note that it may take several hours before you receive your booking voucher.\n    </div>\n    <div class=\"st-form__info\">\n        <a href=\"{{vm.lastPdfVoucherUrl}}\"\n           ng-if=\"vm.showIframe\"\n           class=\"st-form__button\"\n           type=\"submit\"\n           download>Download your voucher</a>\n    </div>\n</div>\n\n"

/***/ },
/* 162 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var ViewController = (function () {
	    ViewController.$inject = ["$http", "$sce", "authService", "myBookingService", "sharedService", "cacheService"];
	    function ViewController($http, $sce, authService, myBookingService, sharedService, cacheService) {
	        'ngInject';
	
	        _classCallCheck(this, ViewController);
	
	        this.name = 'view';
	        this.$sce = $sce;
	        this.$http = $http;
	        this.myBookingService = myBookingService;
	        this.authService = authService;
	        this.cacheService = cacheService;
	        this.IS_MOBILE = sharedService.IS_MOBILE;
	        this.showIframe = false;
	        this.showPdfNotFoundError = false;
	        this.lastPdfVoucherUrl = null;
	        this.successCallback = this.successCallback.bind(this);
	        this.errorCallback = this.errorCallback.bind(this);
	    }
	
	    _createClass(ViewController, [{
	        key: 'getLastPdfVoucherUrl',
	        value: function getLastPdfVoucherUrl() {
	            var agencyBookingReference = this.cacheService.get('agencyBookingReference');
	            return this.myBookingService.getLastPdfVoucherUrl(agencyBookingReference, this.authService.getAccessToken(), true);
	        }
	    }, {
	        key: 'successCallback',
	        value: function successCallback() {
	            this.lastPdfVoucherUrl = this.$sce.trustAsResourceUrl(this.getLastPdfVoucherUrl());
	            this.showIframe = true;
	        }
	    }, {
	        key: 'errorCallback',
	        value: function errorCallback() {
	            this.showIframe = false;
	            this.showPdfNotFoundError = true;
	        }
	    }, {
	        key: '$onInit',
	        value: function $onInit() {
	            this.$http({
	                method: 'HEAD',
	                url: this.getLastPdfVoucherUrl()
	            }).then(this.successCallback, this.errorCallback);
	        }
	    }]);
	
	    return ViewController;
	})();
	
	exports['default'] = ViewController;
	module.exports = exports['default'];

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _otbNavbarComponent = __webpack_require__(164);
	
	var _otbNavbarComponent2 = _interopRequireDefault(_otbNavbarComponent);
	
	__webpack_require__(167);
	
	var otbNavbarModule = _angular2['default'].module('otbNavbar', [_angularUiRouter2['default']]).component('otbNavbar', _otbNavbarComponent2['default']).name;
	
	exports['default'] = otbNavbarModule;
	module.exports = exports['default'];

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _otbNavbarHtml = __webpack_require__(165);
	
	var _otbNavbarHtml2 = _interopRequireDefault(_otbNavbarHtml);
	
	var _otbNavbarController = __webpack_require__(166);
	
	var _otbNavbarController2 = _interopRequireDefault(_otbNavbarController);
	
	var otbNavbarComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _otbNavbarHtml2['default'],
	  controller: _otbNavbarController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = otbNavbarComponent;
	module.exports = exports['default'];

/***/ },
/* 165 */
/***/ function(module, exports) {

	module.exports = "<header class=\"o-header\">\n    <div class=\"o-header__container\">\n        <div class=\"o-header__item\">\n            <div class=\"o-header__logos\">\n                <a href=\"https://www.onthebeach.co.uk\" target=\"_blank\" title=\"On The Beach\">\n                    <img class=\"img-logo\" src=\"https://worldwide-cdn.suntransfers.com/st-assets/branding/logo/on-the-beach.png\" alt=\"On the Beach\">\n                </a>\n                <a href=\"https://www.sunshine.co.uk\" target=\"_blank\" title=\"Sunshine\">\n                    <img class=\"img-logo\" src=\"https://worldwide-cdn.suntransfers.com/st-assets/branding/logo/sunshine.png\" alt=\"Sunshine.co.uk\">\n                </a>\n            </div>\n        </div>\n\n        <div class=\"o-header__item\" ng-class=\"{'has-one-child': !vm.authService.authenticated}\">\n            <nav class=\"o-nav\">\n                <div class=\"o-nav__main\">\n                    <a class=\"o-nav__st\" href=\"https://www.suntransfers.com\" target=\"_blank\">\n                        <img class=\"o-nav__st--logo\" src=\"https://worldwide-cdn.suntransfers.com/st-assets/branding/favicon/favicon.ico\" alt=\"Suntransfers\">\n                        <p class=\"o-nav__st--text\"><span>Provided by</span><span>Suntransfers</span></p>\n                    </a>\n\n                    <a class=\"o-nav__logout\" href=\"#\" ng-click=\"vm.logout()\" ng-if=\"vm.authService.authenticated\">\n                        <i class=\"o-nav__icon st-icon-logout\"></i>\n                        <span class=\"o-nav__logout--text\">Logout</span>\n                    </a>\n                </div>\n            </nav>\n        </div>\n    </div>\n</header>\n<st-browser-alerts></st-browser-alerts>"

/***/ },
/* 166 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var OtbNavbarController = (function () {
	    OtbNavbarController.$inject = ["$state", "$stateParams", "authService"];
	    function OtbNavbarController($state, $stateParams, authService) {
	        'ngInject';
	
	        _classCallCheck(this, OtbNavbarController);
	
	        this.$state = $state;
	        this.$stateParams = $stateParams;
	        this.authService = authService;
	        this.name = 'otbNavbar';
	    }
	
	    _createClass(OtbNavbarController, [{
	        key: 'logout',
	        value: function logout() {
	            var _this = this;
	
	            this.authService.logout().then(function () {
	                _this.$state.go('onTheBeach.login', {
	                    locale: _this.$stateParams.locale
	                });
	            });
	        }
	    }]);
	
	    return OtbNavbarController;
	})();
	
	exports['default'] = OtbNavbarController;
	module.exports = exports['default'];

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(168);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(154)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./otbNavbar.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./otbNavbar.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(153)();
	// imports
	
	
	// module
	exports.push([module.id, ".o-header__logos{display:flex;flex-direction:row;justify-content:space-between;align-items:center;gap:.8rem;padding-left:5px;width:90%}.img-logo{height:2rem;object-fit:cover}.o-nav__main{display:flex!important;justify-content:flex-end}.o-nav__logout,.o-nav__st{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:5px;padding:5px;color:#45423c;border-left:1px dotted #b2aea5}.o-nav__logout:hover,.o-nav__st:hover{text-decoration:none}.o-nav__logout--text,.o-nav__st--text{display:flex;flex-direction:column;align-items:center;text-align:center;margin:0}.o-nav__st--logo{width:24px;height:24px}@media only screen and (min-width:62.38em){.o-header__logos{padding:0;gap:1rem}.img-logo{height:3.5rem}.o-nav__st{padding:5px 10px}}", ""]);
	
	// exports


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _appHtml = __webpack_require__(170);
	
	var _appHtml2 = _interopRequireDefault(_appHtml);
	
	var _appController = __webpack_require__(171);
	
	var _appController2 = _interopRequireDefault(_appController);
	
	__webpack_require__(172);
	
	var appComponent = {
	  template: _appHtml2['default'],
	  controller: _appController2['default'],
	  restrict: 'E',
	  controllerAs: 'vm'
	};
	
	exports['default'] = appComponent;
	module.exports = exports['default'];

/***/ },
/* 170 */
/***/ function(module, exports) {

	module.exports = "<div class=\"app\">\n    <st-global-preloader></st-global-preloader>\n    <div ui-view=\"navbar\"></div>\n    <div ui-view=\"main\" class=\"p-sticky__content\"></div>\n    <div ui-view=\"footer\"></div>\n</div>"

/***/ },
/* 171 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var AppController = (function () {
	    AppController.$inject = ["$translate", "languageService", "cacheService", "CONFIG", "$window", "sharedService"];
	    function AppController($translate, languageService, cacheService, CONFIG, $window, sharedService) {
	        'ngInject';
	
	        _classCallCheck(this, AppController);
	
	        this.name = 'home';
	        this.$translate = $translate;
	        this.CONFIG = CONFIG;
	        this.cacheService = cacheService;
	        this.languageService = languageService;
	        this.setLanguage();
	
	        //TODO: move to file service
	        var isMobile = {
	            Android: function Android() {
	                return $window.navigator.userAgent.match(/Android/i);
	            },
	            BlackBerry: function BlackBerry() {
	                return $window.navigator.userAgent.match(/BlackBerry/i);
	            },
	            iOS: function iOS() {
	                return $window.navigator.userAgent.match(/iPhone|iPad|iPod/i);
	            },
	            Opera: function Opera() {
	                return $window.navigator.userAgent.match(/Opera Mini/i);
	            },
	            Windows: function Windows() {
	                return $window.navigator.userAgent.match(/IEMobile/i);
	            },
	            any: function any() {
	                return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
	            }
	        };
	        sharedService.IS_MOBILE = isMobile.any();
	    }
	
	    //TODO: Move to service, using the same func on loginController
	
	    _createClass(AppController, [{
	        key: 'setLanguage',
	        value: function setLanguage() {
	            this.languageService.setLanguage(this.cacheService.get('customer').language || null);
	        }
	    }]);
	
	    return AppController;
	})();
	
	exports['default'] = AppController;
	module.exports = exports['default'];

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(173);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(154)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./app.less", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./app.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(153)();
	// imports
	exports.i(__webpack_require__(174), "");
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ },
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	//TODO:: LOAD VIA WEBPACK
	'use strict';
	
	__webpack_require__(187);
	module.exports = 'offClick';

/***/ },
/* 187 */,
/* 188 */
/***/ function(module, exports) {

	'use strict';
	
	appConfigLocation.$inject = ["$locationProvider", "$urlRouterProvider", "cacheServiceProvider"];
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = appConfigLocation;
	var DEFAULT_LANGUAGE = 'en';
	
	var DEFAULT_PATHS = {
	    LOGIN: function LOGIN(locale) {
	        return '/' + locale + '/auth/login';
	    },
	    BOOKING_VIEW: function BOOKING_VIEW(locale, reference) {
	        return '/' + locale + '/bookings/' + reference + '/view';
	    }
	};
	
	var ON_THE_BEACH_PATHS = {
	    LOGIN: '/' + DEFAULT_LANGUAGE + '/on-the-beach/login',
	    BOOKING_VIEW: '/' + DEFAULT_LANGUAGE + '/on-the-beach/booking/view'
	};
	
	function appConfigLocation($locationProvider, $urlRouterProvider, cacheServiceProvider) {
	    'ngInject';
	    //TODO: rename component to app.config
	    $locationProvider.html5Mode(true).hashPrefix('!');
	
	    $urlRouterProvider.otherwise(function ($injector) {
	        var cacheService = $injector.get('cacheService');
	        var locale = cacheService.get('customer').language || DEFAULT_LANGUAGE;
	        var bookingReference = cacheService.get('bookingReference');
	
	        if (!bookingReference) {
	            var isOnTheBeach = window.location.pathname.includes('on-the-beach');
	            if (isOnTheBeach) return ON_THE_BEACH_PATHS.LOGIN;
	            return DEFAULT_PATHS.LOGIN(locale);
	        }
	
	        var isOnTheBeachBooking = cacheService.get('onTheBeachBooking');
	        if (isOnTheBeachBooking) return ON_THE_BEACH_PATHS.BOOKING_VIEW;
	        return DEFAULT_PATHS.BOOKING_VIEW(locale, bookingReference);
	    });
	}
	
	module.exports = exports['default'];

/***/ },
/* 189 */
/***/ function(module, exports) {

	'use strict';
	
	appConfigAuth.$inject = ["$httpProvider"];
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	function appConfigAuth($httpProvider) {
	    'ngInject';
	
	    // Emit oauth:error on any 401 so auth.run.js can attempt a token refresh.
	    // The backend returns {"code":401,"message":"Unauthorized"} for expired JWTs
	    // (not the OAuth2 {"error":"invalid_token"} format), so we match on status only.
	    authInterceptor.$inject = ["$q", "$rootScope"];
	    function authInterceptor($q, $rootScope) {
	        'ngInject';
	        return {
	            responseError: function responseError(rejection) {
	                if (401 === rejection.status) {
	                    $rootScope.$emit('oauth:error', rejection);
	                }
	                return $q.reject(rejection);
	            }
	        };
	    }
	    $httpProvider.interceptors.push(authInterceptor);
	}
	
	exports['default'] = appConfigAuth;
	module.exports = exports['default'];

/***/ },
/* 190 */
/***/ function(module, exports) {

	'use strict';
	
	appConfigTranslations.$inject = ["$translateProvider", "CONFIG"];
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	function appConfigTranslations($translateProvider, CONFIG) {
	    'ngInject';
	
	    $translateProvider.useStaticFilesLoader({
	        prefix: 'app/assets/translations/locale-',
	        suffix: '.json?1647355100'
	    });
	
	    $translateProvider.fallbackLanguage(CONFIG.default_locale);
	    $translateProvider.use(CONFIG.default_locale);
	    $translateProvider.useSanitizeValueStrategy(null);
	}
	
	exports['default'] = appConfigTranslations;
	module.exports = exports['default'];

/***/ },
/* 191 */
/***/ function(module, exports) {

	//create interceptor
	"use strict";
	
	appLoadingInterceptor.$inject = ["$q", "sharedService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function appLoadingInterceptor($q, sharedService) {
	    "ngInject";
	    sharedService.loader.loadingCount = 0;
	
	    function showLoading() {
	        sharedService.loader.loadingCount++;
	    }
	
	    function showErrors(response) {
	
	        if (response.data && response.data.message) {
	            sharedService.errorMsg = response.data.message;
	        } else {
	            sharedService.errorMsg = response;
	        }
	        scrollTo(document.body, 0, 400);
	    }
	    function hideErrors() {
	        sharedService.errorMsg = null;
	    }
	
	    function hideLoading() {
	        if (sharedService.loader.loadingCount > 0) {
	            sharedService.loader.loadingCount--;
	        }
	    }
	
	    function scrollTo(element, to, duration) {
	        var start = element.scrollTop,
	            change = to - start,
	            increment = 20;
	
	        var animateScroll = function animateScroll(elapsedTime) {
	            elapsedTime += increment;
	            var position = easeInOut(elapsedTime, start, change, duration);
	            element.scrollTop = position;
	            if (elapsedTime < duration) {
	                setTimeout(function () {
	                    animateScroll(elapsedTime);
	                }, increment);
	            }
	        };
	
	        animateScroll(0);
	    }
	
	    function easeInOut(currentTime, start, change, duration) {
	        currentTime /= duration / 2;
	        if (currentTime < 1) {
	            return change / 2 * currentTime * currentTime + start;
	        }
	        currentTime -= 1;
	        return -change / 2 * (currentTime * (currentTime - 2) - 1) + start;
	    }
	
	    return {
	        request: function request(config) {
	            showLoading();
	            hideErrors();
	            // Return the config or wrap it in a promise if blank.
	            return config || $q.when(config);
	        },
	        response: function response(_response) {
	            hideLoading();
	            hideErrors();
	            // Return the response or wrap it in a promise if blank.           
	            return _response || $q.when(_response);
	        },
	        responseError: function responseError(response) {
	            //Show Error msg
	            hideLoading();
	            showErrors(response);
	            // Return the promise rejection.
	            return $q.reject(response);
	        }
	    };
	}
	
	exports["default"] = appLoadingInterceptor;
	module.exports = exports["default"];

/***/ },
/* 192 */
/***/ function(module, exports) {

	//registers interceptor
	"use strict";
	
	loadingInterceptorConfig.$inject = ["$httpProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function loadingInterceptorConfig($httpProvider) {
	    "ngInject";
	    $httpProvider.interceptors.push('loadingInterceptor');
	}
	exports["default"] = loadingInterceptorConfig;
	module.exports = exports["default"];

/***/ },
/* 193 */
/***/ function(module, exports) {

	'use strict';
	
	appRunQueryStringInterceptor.$inject = ["$rootScope", "$location"];
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	function appRunQueryStringInterceptor($rootScope, $location) {
	    "ngInject";
	    var locationSearch;
	
	    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
	        //save location.search so we can add it back after transition is done
	        locationSearch = $location.search();
	    });
	
	    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
	        //restore all query string parameters back to $location.search
	        $location.search(locationSearch);
	    });
	}
	
	exports['default'] = appRunQueryStringInterceptor;
	module.exports = exports['default'];

/***/ },
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 198,
		"./af.js": 198,
		"./ar": 199,
		"./ar-dz": 200,
		"./ar-dz.js": 200,
		"./ar-ly": 201,
		"./ar-ly.js": 201,
		"./ar-ma": 202,
		"./ar-ma.js": 202,
		"./ar-sa": 203,
		"./ar-sa.js": 203,
		"./ar-tn": 204,
		"./ar-tn.js": 204,
		"./ar.js": 199,
		"./az": 205,
		"./az.js": 205,
		"./be": 206,
		"./be.js": 206,
		"./bg": 207,
		"./bg.js": 207,
		"./bn": 208,
		"./bn.js": 208,
		"./bo": 209,
		"./bo.js": 209,
		"./br": 210,
		"./br.js": 210,
		"./bs": 211,
		"./bs.js": 211,
		"./ca": 212,
		"./ca.js": 212,
		"./cs": 213,
		"./cs.js": 213,
		"./cv": 214,
		"./cv.js": 214,
		"./cy": 215,
		"./cy.js": 215,
		"./da": 216,
		"./da.js": 216,
		"./de": 217,
		"./de-at": 218,
		"./de-at.js": 218,
		"./de.js": 217,
		"./dv": 219,
		"./dv.js": 219,
		"./el": 220,
		"./el.js": 220,
		"./en-au": 221,
		"./en-au.js": 221,
		"./en-ca": 222,
		"./en-ca.js": 222,
		"./en-gb": 223,
		"./en-gb.js": 223,
		"./en-ie": 224,
		"./en-ie.js": 224,
		"./en-nz": 225,
		"./en-nz.js": 225,
		"./eo": 226,
		"./eo.js": 226,
		"./es": 227,
		"./es-do": 228,
		"./es-do.js": 228,
		"./es.js": 227,
		"./et": 229,
		"./et.js": 229,
		"./eu": 230,
		"./eu.js": 230,
		"./fa": 231,
		"./fa.js": 231,
		"./fi": 232,
		"./fi.js": 232,
		"./fo": 233,
		"./fo.js": 233,
		"./fr": 234,
		"./fr-ca": 235,
		"./fr-ca.js": 235,
		"./fr-ch": 236,
		"./fr-ch.js": 236,
		"./fr.js": 234,
		"./fy": 237,
		"./fy.js": 237,
		"./gd": 238,
		"./gd.js": 238,
		"./gl": 239,
		"./gl.js": 239,
		"./he": 240,
		"./he.js": 240,
		"./hi": 241,
		"./hi.js": 241,
		"./hr": 242,
		"./hr.js": 242,
		"./hu": 243,
		"./hu.js": 243,
		"./hy-am": 244,
		"./hy-am.js": 244,
		"./id": 245,
		"./id.js": 245,
		"./is": 246,
		"./is.js": 246,
		"./it": 247,
		"./it.js": 247,
		"./ja": 248,
		"./ja.js": 248,
		"./jv": 249,
		"./jv.js": 249,
		"./ka": 250,
		"./ka.js": 250,
		"./kk": 251,
		"./kk.js": 251,
		"./km": 252,
		"./km.js": 252,
		"./ko": 253,
		"./ko.js": 253,
		"./ky": 254,
		"./ky.js": 254,
		"./lb": 255,
		"./lb.js": 255,
		"./lo": 256,
		"./lo.js": 256,
		"./lt": 257,
		"./lt.js": 257,
		"./lv": 258,
		"./lv.js": 258,
		"./me": 259,
		"./me.js": 259,
		"./mi": 260,
		"./mi.js": 260,
		"./mk": 261,
		"./mk.js": 261,
		"./ml": 262,
		"./ml.js": 262,
		"./mr": 263,
		"./mr.js": 263,
		"./ms": 264,
		"./ms-my": 265,
		"./ms-my.js": 265,
		"./ms.js": 264,
		"./my": 266,
		"./my.js": 266,
		"./nb": 267,
		"./nb.js": 267,
		"./ne": 268,
		"./ne.js": 268,
		"./nl": 269,
		"./nl-be": 270,
		"./nl-be.js": 270,
		"./nl.js": 269,
		"./nn": 271,
		"./nn.js": 271,
		"./pa-in": 272,
		"./pa-in.js": 272,
		"./pl": 273,
		"./pl.js": 273,
		"./pt": 274,
		"./pt-br": 275,
		"./pt-br.js": 275,
		"./pt.js": 274,
		"./ro": 276,
		"./ro.js": 276,
		"./ru": 277,
		"./ru.js": 277,
		"./se": 278,
		"./se.js": 278,
		"./si": 279,
		"./si.js": 279,
		"./sk": 280,
		"./sk.js": 280,
		"./sl": 281,
		"./sl.js": 281,
		"./sq": 282,
		"./sq.js": 282,
		"./sr": 283,
		"./sr-cyrl": 284,
		"./sr-cyrl.js": 284,
		"./sr.js": 283,
		"./ss": 285,
		"./ss.js": 285,
		"./sv": 286,
		"./sv.js": 286,
		"./sw": 287,
		"./sw.js": 287,
		"./ta": 288,
		"./ta.js": 288,
		"./te": 289,
		"./te.js": 289,
		"./tet": 290,
		"./tet.js": 290,
		"./th": 291,
		"./th.js": 291,
		"./tl-ph": 292,
		"./tl-ph.js": 292,
		"./tlh": 293,
		"./tlh.js": 293,
		"./tr": 294,
		"./tr.js": 294,
		"./tzl": 295,
		"./tzl.js": 295,
		"./tzm": 296,
		"./tzm-latn": 297,
		"./tzm-latn.js": 297,
		"./tzm.js": 296,
		"./uk": 298,
		"./uk.js": 298,
		"./uz": 299,
		"./uz.js": 299,
		"./vi": 300,
		"./vi.js": 300,
		"./x-pseudo": 301,
		"./x-pseudo.js": 301,
		"./yo": 302,
		"./yo.js": 302,
		"./zh-cn": 303,
		"./zh-cn.js": 303,
		"./zh-hk": 304,
		"./zh-hk.js": 304,
		"./zh-tw": 305,
		"./zh-tw.js": 305
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 197;


/***/ },
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var DropdownManager = (function () {
	    function DropdownManager() {
	        _classCallCheck(this, DropdownManager);
	
	        document.removeEventListener('click', this.onClickDropdownHandler.bind(this));
	        document.addEventListener('click', this.onClickDropdownHandler.bind(this));
	    }
	
	    _createClass(DropdownManager, [{
	        key: 'addClassesIsActive',
	        value: function addClassesIsActive(button) {
	            button.setAttribute('data-is-active', 1);
	            button.className += ' ' + button.getAttribute('data-is-active-class');
	            var dropdownIsActiveClass;
	
	            if (dropdownIsActiveClass = button.getAttribute('data-dropdown-is-active-class')) {
	                var dropdown = document.getElementById(button.getAttribute('data-dropdown-id'));
	                dropdown.className += ' ' + dropdownIsActiveClass;
	            }
	        }
	    }, {
	        key: 'removeClassesIsActive',
	        value: function removeClassesIsActive(button) {
	            button.setAttribute('data-is-active', 0);
	            button.className = button.className.replace(button.getAttribute('data-is-active-class'), '').trim();
	            var dropdownIsActiveClass;
	
	            if (dropdownIsActiveClass = button.getAttribute('data-dropdown-is-active-class')) {
	                var dropdown = document.getElementById(button.getAttribute('data-dropdown-id'));
	                dropdown.className = dropdown.className.replace(dropdownIsActiveClass, '').trim();
	            }
	        }
	    }, {
	        key: 'onClickDropdownHandler',
	        value: function onClickDropdownHandler(event) {
	            var buttons = document.getElementsByClassName('js-dropdown-button');
	            for (var i = 0; i < buttons.length; i++) {
	                var button = buttons[i];
	                if (button.getAttribute('data-is-active') == 1) {
	                    var dropdown = document.getElementById(button.getAttribute('data-dropdown-id'));
	                    var isClickInside = dropdown.contains(event.target);
	                    var excludedElement = false;
	
	                    if (button.getAttribute('data-excluded-dropdown-element')) {
	                        excludedElement = document.getElementById(button.getAttribute('data-excluded-dropdown-element'));
	                    }
	
	                    if (button.contains(event.target) || !isClickInside || excludedElement && excludedElement.contains(event.target)) {
	                        this.removeClassesIsActive(button);
	                    }
	                } else if (button.contains(event.target)) {
	                    this.addClassesIsActive(button);
	                }
	            }
	        }
	    }]);
	
	    return DropdownManager;
	})();
	
	var _module = _angular2['default'].module('st.services.dropdown', []).service('DropdownManager', DropdownManager).name;
	
	exports['default'] = _module;
	module.exports = exports['default'];

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _cookiesJs = __webpack_require__(308);
	
	var _cookiesJs2 = _interopRequireDefault(_cookiesJs);
	
	var _cookiesService = __webpack_require__(309);
	
	var _cookiesService2 = _interopRequireDefault(_cookiesService);
	
	var CookiesConsent = (function () {
	    function CookiesConsent(CONFIG, cookiesService) {
	        _classCallCheck(this, CookiesConsent);
	
	        this.CONFIG = CONFIG;
	        this.cookiesService = cookiesService;
	    }
	
	    _createClass(CookiesConsent, [{
	        key: "validateAndSetCookies",
	        value: function validateAndSetCookies(cookiesBox) {
	            var _this = this;
	
	            var acceptedCookies = _cookiesJs2["default"].get('CookieConsent');
	            if (cookiesBox && acceptedCookies === undefined) {
	                var closeButton = cookiesBox.querySelector('.js-close');
	                cookiesBox.classList.remove('is-collapsed');
	
	                closeButton.addEventListener('click', function (e) {
	                    e.preventDefault();
	                    cookiesBox.classList.add('is-collapsed');
	                    _this.setCookie('{"performance":true,"targeting":true }');
	                });
	            }
	        }
	    }, {
	        key: "setCookie",
	        value: function setCookie(value) {
	            _cookiesJs2["default"].set('CookieConsent', value, {
	                expires: 365 * 24 * 60 * 60,
	                domain: this.CONFIG.cookiesGlobalDomain
	            });
	        }
	    }, {
	        key: "checkCookieConsent",
	        value: function checkCookieConsent() {
	            var _this2 = this;
	
	            var userCookieConsent = _cookiesJs2["default"].get('CookieConsent');
	            if (!userCookieConsent) {
	                return;
	            }
	
	            var cookies = document.cookie.split(';');
	            var objectUserCookieConsent = JSON.parse(userCookieConsent);
	            cookies.forEach(function (cookie) {
	                var name = cookie.split('=')[0].trim();
	                if (name === 'CookieConsent') {
	                    return;
	                }
	                if (!_this2.cookiesService.isValidCookie(name, objectUserCookieConsent)) {
	                    _this2.cookiesService.deleteCookie(name);
	                }
	            });
	        }
	    }]);
	
	    return CookiesConsent;
	})();
	
	var _module = _angular2["default"].module('st.services.cookiesConsent', [_cookiesService2["default"]]).service('cookiesConsent', CookiesConsent).name;
	
	exports["default"] = _module;
	module.exports = exports["default"];

/***/ },
/* 308 */,
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _cookiesJs = __webpack_require__(308);
	
	var _cookiesJs2 = _interopRequireDefault(_cookiesJs);
	
	var CookiesService = (function () {
	    CookiesService.$inject = ["CONFIG"];
	    function CookiesService(CONFIG) {
	        'ngInject';
	
	        _classCallCheck(this, CookiesService);
	
	        this.CONFIG = CONFIG;
	        this.configCookies = CONFIG.cookies;
	    }
	
	    _createClass(CookiesService, [{
	        key: 'isValidCookie',
	        value: function isValidCookie(cookie, objectUserCookieConsent) {
	
	            if (this.configCookies.performance.includes(cookie)) {
	                return objectUserCookieConsent.hasOwnProperty('performance') && objectUserCookieConsent.performance;
	            }
	
	            if (this.configCookies.targeting.includes(cookie)) {
	                return objectUserCookieConsent.hasOwnProperty('marketing') && objectUserCookieConsent.marketing || objectUserCookieConsent.hasOwnProperty('targeting') && objectUserCookieConsent.targeting;
	            }
	
	            return true;
	        }
	    }, {
	        key: 'deleteCookie',
	        value: function deleteCookie(cookie) {
	            _cookiesJs2['default'].set(cookie, '', {
	                expires: new Date(0).toUTCString(),
	                domain: this.CONFIG.cookiesGlobalDomain
	            });
	        }
	    }]);
	
	    return CookiesService;
	})();
	
	var cookiesServiceModule = _angular2['default'].module('st.services.cookies', []).service('cookiesService', CookiesService).name;
	
	exports['default'] = cookiesServiceModule;
	module.exports = exports['default'];

/***/ }
]);


// WEBPACK FOOTER //
// app.bundle.js